<template>
  <div class="no-scroll">
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar" timeout="5000" :value="true" :color="snackbarclr" absolute outlined top right>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>
    <LayOut />
    <v-container class="px-md-6 pt-14 no-scroll" fluid fill-height style="height: 100vh; overflow: scroll">
      <v-row no-glutters class="pt-sm-2 pb-sm-4">
        <v-col cols="12" sm="6" md="3">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined>
            New request : <b>{{ viewcount ? viewcount : 0 }}</b> <br />
            Re-activation : <b>{{ reactcount ? reactcount : 0 }}</b>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined>
            E-signed : <b>{{ esigncount ? esigncount : 0 }}</b> <br />
            Re-e-signed : <b>{{ resigncount ? resigncount : 0 }}</b>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined>
            E-sign pending : <b>{{ esignpcount ? esignpcount : 0 }}</b> <br />
            Re-e-sign pending : <b>{{ resignpcount ? resignpcount : 0 }}</b>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined>
            Completed : <b>{{ comcount ? comcount : 0 }}</b> <br />
            Pending : <b>{{ pencount ? pencount : 0 }}</b> | Rejected : <b>{{ rejcount ? rejcount : 0 }}</b>
          </v-card>
        </v-col>
      </v-row>
      <!-- :show-group-by="tab == 1"
          :group-by="tab == 1 ? 'segment' : []" -->
      <v-card width="100%" class="elevation-0 rounded-lg mt-auto" outlined>
        <v-data-table
      :show-group-by="tab == 0 && (status.includes('e-signed pending') || status.includes('e-signed completed'))"
:group-by="tab == 0 && (status.includes('e-signed pending') || status.includes('e-signed completed')) ? 'app_status' : []"

          ref="ovrtable"
          height="calc(100vh - 280px)"
          dense
          style="overflow: auto"
          fixed-header
          must-sort
          :search="search"
          :sort-by="[tab == 2 ? 'rejection_date_time' : tab == 1 || tab == 3 ? 'com_date' : 'date_time']"
          :sort-desc="[true]"
          :headers="tab == 0 ? headers : tab == 1 ? headersc : tab == 2 ? headersr : tab == 3 ? headersp : tab == 4 ? headersmf : headers"
          :items="itemsWithSno"
          :loading="mainloader"
          :footer-props="{
            'items-per-page-options': [10, 30, 50, 100, -1],
          }"
          class="elevation-0"
          mobile-breakpoint
          item-key="sno"
           
       :page.sync="page"
      :items-per-page="itemsPerPage"
     hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar dense flat>
              <v-tabs dense @change="setTypedata()" v-model="tab">
                <v-tab class="text-none">
                  <v-badge :content="tab == 0 ? showdata.length : viewcount" :value="tab == 0 ? showdata.length : viewcount">
                    <span> View </span>
                  </v-badge>
                </v-tab>
                <v-tab class="text-none">
                  <v-badge :content="tab == 1 ? showdata.length : pencount" :value="tab == 1 ? showdata.length : pencount">
                    <span> Pending </span>
                  </v-badge>
                </v-tab>
                <v-tab class="text-none">
                  <v-badge :content="tab == 2 ? showdata.length : rejcount" :value="tab == 2 ? showdata.length : rejcount">
                    <span> Reject </span>
                  </v-badge>
                </v-tab>
                <v-tab class="text-none">
                  <v-badge :content="tab == 3 ? showdata.length : comcount" :value="tab == 3 ? showdata.length : comcount">
                    <span> Complete </span>
                  </v-badge>
                </v-tab>
                <v-tab class="text-none">
                  <v-badge :content="tab == 4 ? showdata.length : mfcount" :value="tab == 4 ? showdata.length : mfcount">
                    <span> Mutual funds </span>
                  </v-badge>
                </v-tab>
              </v-tabs>
              <v-spacer></v-spacer>
              <v-menu v-model="menu22" :close-on-content-click="false" transition="scale-transition" offset-y>
                <template v-slot:activator="{on, attrs}">
                  <v-text-field v-bind="attrs" v-on="on" readonly color="#fb8c00" :disabled="mainloader" dense @click:clear="dateClear()" clearable v-model="alldate" class="rounded-lg mr-4" style="min-width: 200px" prepend-inner-icon="mdi-calendar" label="Date filter" single-line hide-details>
                  </v-text-field>
                </template>
                <v-card width="580px">
                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-date-picker v-model="dateSelect2" :max="maxDate2"></v-date-picker>
                    </v-col>
                    <v-col cols="6">
                      <v-date-picker v-model="dateSelectto" :min="dateSelect2" :max="maxDate2" @input="(menu22 = false), (menu2to = false), dayCustom()"></v-date-picker>
                    </v-col>
                  </v-row>
                </v-card>
              </v-menu>
              <!-- dashboarddata  item-text="app_status" item-value="app_status"-->
              <v-autocomplete chips
            small-chips multiple v-if="tab == 0" color="#fb8c00" @change="statusChange(),getDashboard()" dense v-model="status" class="mr-4 rounded-lg" :items="getAppfilter()" hide-details :disabled="mainloader"  style="min-width: 200px; font-size: 12px !important;" label="Status filter" single-line>
                <template #append>
                  <v-icon @click="closefiltercancel()">{{ status ? "mdi-close" : "mdi-chevron-down" }}</v-icon>
                </template>
              </v-autocomplete>

              <!-- <v-autocomplete color="#fb8c00" @change="requestChange()" dense item-text="request" item-value="request"
                v-model="request" class="mr-4 rounded-lg" :items="dashboarddata" hide-details :disabled="mainloader"
                style="min-width: 110px;" label="Request filter" single-line>
                <template #append>
                  <v-icon @click="request ? (request = null, requestChange(), statusChange()) : null">{{ request ?
                    'mdi-close'
                    : 'mdi-chevron-down' }}</v-icon>
                </template>
              </v-autocomplete> -->

              <v-text-field color="#fb8c00"  @input="searchapicall()" dense v-model="search" class="rounded-lg" style="max-width: 160px" prepend-inner-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
              <v-btn icon :loading="mainloader" :disabled="mainloader" @click="(emaildialog = true), (emailmobile = null), (emailstatus = false), (btmdata = [])"><v-icon color="#fb8c00">mdi-email-outline</v-icon></v-btn>

              <v-btn v-if="dashboarddata.length > 0" icon :loading="mainloader" :disabled="mainloader" @click="tab == 3 ? downloadFile('comxls') : tab == 0 ? downloadFile('viewxls') : downloadFile('xls')"
                ><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                  <path
                    d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                    stroke="#fb8c00"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  /></svg>
            </v-btn>

              <v-btn v-else icon :loading="mainloader" disabled
                ><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                  <path
                    d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                    stroke="#fb8c00"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  /></svg>
                </v-btn>

              <v-btn icon :loading="mainloader" :disabled="mainloader" @click="getDashboard()"><v-icon color="#fb8c00">mdi-refresh</v-icon></v-btn>
              <v-btn v-if="tab == 4" :loading="mainloader" :disabled="mainloader" @click="openPasswordDialog()" class="mr-2 text-none" color="primary" elevation="0">
               
                Update Password
              </v-btn>
              <v-switch v-if="tab == 1" :disabled="mainloader" class="mb-0" hide-details v-model="protype" :label="protype ? 'Manual' : 'Auto'"></v-switch>
            </v-toolbar>
            <v-divider></v-divider>
          </template>
          <template v-slot:[`item.date_time`]="{item}">
            <p class="mb-0" style="width: 120px">{{ item.date_time ? item.date_time.slice(0, 16) : item.date_time }}</p>
          </template>
             <template v-slot:[`item.BO_created_datetime`]="{item}">
            <p class="mb-0" style="width: 120px">{{ item.BO_created_datetime != "" ? item.BO_created_datetime : item.manual_datetime }}</p>
          </template>
          <template v-slot:[`item.com_date`]="{item}">
            <p class="mb-0" style="width: 120px">{{ item.com_date ? item.com_date.slice(0, 16) : item.com_date }}</p>
          </template>
          <template v-slot:[`item.rejection_date_time`]="{item}">
            <p class="mb-0" style="width: 120px">{{ item.rejection_date_time ? item.rejection_date_time.slice(0, 16) : item.rejection_date_time }}</p>
          </template>
          <template v-slot:[`item.email_time_after_esign`]="{item}">
            <p class="mb-0" style="width: 120px">{{ item.email_time_after_esign ? item.email_time_after_esign.slice(0, 16) : item.email_time_after_esign }}</p>
          </template>

  <template v-slot:[`item.autoverfy`]="{item}">
        <v-btn elevation="0" color="primary" small class="text-none" @click="autoverifydata(item)">Auto Verify</v-btn>
          </template>

          <template v-slot:[`item.cdslapi`]="{item}">
            <!-- item.instbo ? setCdslInsta(item) : setCDSLapi(item) -->
             <!-- {{ item.instbo }} -->
            <v-btn
              @click="protype ? getManCDSLdata(item) : isRekycClient(item) ? getCdslReactiveCheck(item) : setCdslInsta(item)"
              v-if="isBtnEnabled(item,'cdslapi') && item.segment != 'Commodity' && (!item.instbo || (item.segment && item.segment.includes('Cash')))"
              small
              :color="item.instbo ? '#3F51B5' : 'warning'"
              class="elevation-0 rounded-md"
            >
              <span class="white--text text-none">{{ protype ? "Man" : "" }} Complete {{ item.instbo ? "InstBO" : "CDSL" }}</span>
            </v-btn>
            <v-btn v-else small color="warning" disabled class="elevation-0 rounded-md">
              <span class="white--text text-none">{{ protype ? "Man" : "" }} Complete {{ item.instbo ? "InstBO" : "CDSL" }}</span>
            </v-btn>
          </template>
          <template v-slot:[`item.cdsl`]="{item}">
            <!-- item.instbo ? setInstaRes(item) : setCDSL(item) -->
            <v-btn
              @click="setInstaRes(item)"
              v-if="isBtnEnabled(item,'cdsl')"
              small
              :color="item.instbo ? '#3F51B5' : 'warning'"
              class="elevation-0 rounded-md"
            >
              <span class="white--text text-none">Response {{ item.instbo ? "InstBO" : "CDSL" }}</span>
            </v-btn>
            <v-btn v-else small color="warning" disabled class="elevation-0 rounded-md">
              <span class="white--text text-none">Response {{ item.instbo ? "InstBO" : "CDSL" }}</span>
            </v-btn>
          </template>
          <template v-slot:[`item.backoffice`]="{item}">
            <v-btn
              @click="protype ? getManBackofficedata(item) : setBackoffice(item)"
              small
              v-if="isBtnEnabled(item,'backoffice')"
              color="#0037B7"
              class="elevation-0 rounded-md"
            >
              <span class="white--text text-none">{{ protype ? "Man" : "" }} Complete BackOffice</span>
            </v-btn>
            <v-btn small v-else color="#0037B7" disabled class="elevation-0 rounded-md">
              <span class="white--text text-none">{{ protype ? "Man" : "" }} Complete BackOffice</span>
            </v-btn>
          </template>
          <template v-slot:[`item.uccgen`]="{item}">
            <v-btn @click="setUCCgen(item)" small v-if="item.data_type.mfcompleted != '0'" color="#FFEB3B" class="elevation-0 rounded-md">
              <span class="black--text text-none">Complete UCC</span>
            </v-btn>
            <v-btn small v-else color="#0037B7" disabled class="elevation-0 rounded-md">
              <span class="white--text text-none">Complete UCC</span>
            </v-btn>
          </template>
          <template v-slot:[`item.autopush`]="{item}">
            <div class="d-flex">
          <v-btn
             :disabled="isDisabled(item) || item.data_type.rekyc == 'Yes'"
              small
              color="#0037B7"
              class="elevation-0 rounded-md"
             @click="autopusapi(item)" 
            >
              <span class="white--text text-none"> Auto Push    </span>


            </v-btn>
             <v-btn
       v-if="(typeof item.auto_push_resp === 'object' && item.auto_push_resp !== null)"
         
         icon
          @click="atupushdiall(item)"
        >
          <v-icon> mdi-information-outline</v-icon>
       
        </v-btn>

             <!-- <v-tooltip style="width:10vh" color="black" bottom v-if="(typeof item.auto_push_resp === 'object' && item.auto_push_resp !== null)">
      <template  v-slot:activator="{ on, attrs }">
        <v-btn
       v-if="(typeof item.auto_push_resp === 'object' && item.auto_push_resp !== null)"
          v-bind="attrs"
          v-on="on"
         icon
          @click="atupushdiall(item)"
        >
          <v-icon> mdi-information-outline</v-icon>
       
        </v-btn>
      </template>
      <div>
        <div style="width: 300px; white-space: normal;">
    <div v-for="(value, key) in item.auto_push_resp" :key="key">
      {{ key }}: {{ value }}
    </div>
    </div>
  </div>
    </v-tooltip> -->
    <!-- <v-btn @click="atupushdiall(item)">test</v-btn> -->
              </div>
           
           </template>
          <template v-slot:[`item.manual`]="{item}">
            <v-btn @click="bfoManual(item)" v-if="item.changes == 'reviewcomplete' || item.changes == 'manualcomplete'" small color="#795548" disabled class="elevation-0 rounded-md">
              <span class="white--text text-none">Manual Complete</span>
            </v-btn>
            <v-btn @click="bfoManual(item)" v-else small color="#795548" class="elevation-0 rounded-md">
              <span class="white--text text-none">Manual Complete</span>
            </v-btn>
          </template>

          <template v-slot:[`item.stamp`]="{item}">
            <v-btn :disabled="item.stamp_paper_status == 'success'" v-if="item.declaration && item.declaration.DDPI" @click="setStamppaper(item)" small color="yellow" class="elevation-0 rounded-md">
              <span class="black--text text-none">Send mail</span>
            </v-btn>
            <span class="font-weight-medium" style="white-space: pre !important" v-else>DDPI isn't enabled.</span>
          </template>
          <template v-slot:[`item.KRA_view`]="{item}">
            <v-btn @click="setKRAvalidation(item)" small color="#2196F3" :disabled="item.data_type.kra == 'true'" class="elevation-0 rounded-md">
              <span class="white--text text-none">KRA valid</span>
            </v-btn>
            <!-- <span class="font-weight-medium" style="white-space: pre !important" v-else>DDPI isn't enabled.</span> -->
          </template>

          <template v-slot:[`item.exchs`]="{item}">
            <div class="d-inline-flex">
              <v-btn @click="setExchange(item, 'nse', !protype)" small color="#FF5722" class="elevation-0 rounded-md">
                <span class="white--text text-none">{{ protype ? "Man" : "" }} NSE</span>
              </v-btn>

              <v-btn @click="setExchange(item, 'bse', !protype)" small color="#FF5722" class="elevation-0 rounded-md mx-4">
                <span class="white--text text-none">{{ protype ? "Man" : "" }} BSE</span>
              </v-btn>

              <v-btn @click="setExchange(item, 'mcx', !protype)" small color="#FF5722" class="elevation-0 rounded-md">
                <span class="white--text text-none">{{ protype ? "Man" : "" }} MCX</span>
              </v-btn>
            </div>
          </template>

          <template v-slot:[`item.rmcode`]="{item}">
            <span :class="item.data_type && item.data_type.rekyc == 'Yes' ? 'warning--text font-weight-bold' : ''"> {{ item.data_type && item.data_type.rekyc == "Yes" ? "Re-active" : item.rmcode }}</span>
          </template>

          <template v-slot:[`item.app_status`]="{item}">
            <div v-if="tab == 2">
              <span>{{ item.app_status }}</span>
            </div>
            <div v-else-if="tab == 1">
              <span v-if="item.changes == 'reviewcomplete'">{{ item.data_type ? (item.data_type.app_status == "Manually updated" ? "Manually Completed" : "Completed") : "Completed" }}</span>
              <span v-else-if="item.CDSLComplete == '1' && item.changes != 'reviewcomplete' && item.app_status == 'approved'">{{ item.instbo ? "InstBO" : "CDSL" }} Completed</span>
              <!-- same CDSLResponse field the CDSL buttons read; a null/empty response means nothing was pushed yet -->
              <span v-else-if="item.CDSLResponse && (typeof item.CDSLResponse != 'object' || Object.keys(item.CDSLResponse).length != 0) && item.CDSLComplete == '' && item.changes != 'reviewcomplete' && item.app_status == 'approved'">{{ item.instbo ? "InstBO" : "CDSL" }} initiated</span>
              <span v-else>{{ item.app_status }}</span>
            </div>
            <div v-else-if="tab == 4">
              <span class="font-weight-bold" style="white-space: pre !important" :class="item.data_type.mfcompleted == '0' ? 'success--text' : 'warning--text'">{{ item.data_type.mfcompleted == "0" ? "Enabled" : "Not enable" }}</span>
            </div>
            <div v-else>
              <span>{{ item.app_status }}</span>
            </div>
          </template>
          <template v-slot:[`item.view`]="{item}">
            <v-btn v-if="item.app_status && item.app_status != 'email' && item.app_status != 'mobile'" small @click="getSingledata(item)" :color="item.data_type && item.data_type.kra == 'true' ? 'primary lighten-3' : '#0037B7'" class="elevation-0 rounded-md">
              <span class="white--text text-none">{{ tab == 0 ? "Verify" : "View" }}</span>
            </v-btn>
          </template>
          <template v-slot:[`item.del`]="{item}">
            <v-btn small @click="delSingledata(item)" color="#FF1717" class="elevation-0 rounded-md">
              <span class="white--text text-none">Delete</span>
            </v-btn>
          </template>
        </v-data-table>
          <div class="text-center pt-2" >
             <v-row justify="center">
        <v-col cols="8">
          <v-container class="max-width">
           <v-pagination
      circle
        v-model="page"
        :length="pageCount"
        @input="handlePageChange"
      ></v-pagination>
          </v-container>
        </v-col>
      </v-row>
    
    </div>
      </v-card>
    </v-container>
    <v-bottom-sheet class="btmsheetclass" v-model="btmsheet" hide-overlay persistent>
      <v-sheet class="text-center" height="100vh">
        <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar" timeout="5000" :value="true" :color="snackbarclr" absolute outlined top right>
          <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
          {{ snackmsgbar }}
          <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
        </v-snackbar>
        <v-toolbar dense flat>
          <img src="@/assets/Zebu Logo.svg" width="90px" />

          <v-spacer></v-spacer>

          <v-btn v-if="tab == 3" :loading="bosigload" small elevation="0" @click="cdsl_signdata()" :disabled="bocodisabled" color="primary rounded-lg" class="text-none" >Signature ReUpload</v-btn>

          <v-tooltip bottom color="#000">
            <template v-slot:activator="{on, attrs}">
              <v-btn :disabled="restorebtnrest" v-bind="attrs" v-on="on" v-if="tab == 1 || tab == 2" icon :loading="mainloader || bottomload" @click="setStatusUP()">
                <v-icon color="#000">mdi-backup-restore</v-icon>
              </v-btn>
            </template>
            <span>Restore to View stage</span>
          </v-tooltip>

          <v-btn icon :loading="mainloader" @click="downloadFile('single')">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn icon :disabled="mainloader" @click="getSingledata(btmdata)">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn icon @click="btmsheet = false , bocodisabled = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="py-3 px-3">
          <v-row no-glutters style="border-bottom: thin solid #2a2a2a30">
            <v-col cols="4" class="pa-0">
              <v-tabs
                v-model="btmltab"
                show-arrows
                @change="stageFind(), btmltab == 2 ? (btmrtab = 1) : btmltab == 3 ? (btmrtab = 2) : btmltab == 5 ? (btmrtab = 3) : btmltab == 6 ? (btmrtab = 4) : btmltab == 7 ? (btmrtab = 5) : btmltab == 8 ? (btmrtab = 6) : btmltab == 11 ? (btmrtab = 7) : (btmrtab = 0)"
              >
                <v-tab class="text-none" :class="stagewise.mobile == 'yes' ? 'stage_yes' : stagewise.mobile == 'no' ? 'stage_no' : ''">Mobile</v-tab>
                <v-tab class="text-none" :class="stagewise.email == 'yes' ? 'stage_yes' : stagewise.email == 'no' ? 'stage_no' : ''">Email</v-tab>
                <v-tab class="text-none" :class="stagewise.pan == 'yes' && stagewise.panproof == 'yes' ? 'stage_yes' : stagewise.pan == 'no' || stagewise.panproof == 'no' ? 'stage_no' : ''">PAN</v-tab>
                <v-tab class="text-none" :class="stagewise.digilocker == 'yes' ? 'stage_yes' : stagewise.digilocker == 'no' ? 'stage_no' : ''">Verification</v-tab>
                <v-tab class="text-none" :class="stagewise.personal == 'yes' ? 'stage_yes' : stagewise.personal == 'no' ? 'stage_no' : ''">Personal</v-tab>
                <v-tab class="text-none" :class="stagewise.bank == 'yes' && stagewise.bankproof == 'yes' ? 'stage_yes' : stagewise.bank == 'no' || stagewise.bankproof == 'no' ? 'stage_no' : ''">Bank</v-tab>
                <v-tab class="text-none" :class="stagewise.segment == 'yes' ? 'stage_yes' : stagewise.segment == 'no' ? 'stage_no' : ''">Segment</v-tab>
                <!-- <v-tab class="text- :class="stagewise.email == 'yes' ? 'stage_yes' : stagewise.mobile == 'no' ? 'stage_no' : ''"none">Declartaion</v-tab> -->
                <v-tab class="text-none" :class="stagewise.signature == 'yes' ? 'stage_yes' : stagewise.signature == 'no' ? 'stage_no' : ''">Signature</v-tab>
                <v-tab class="text-none" :class="stagewise.selfie == 'yes' ? 'stage_yes' : stagewise.selfie == 'no' ? 'stage_no' : ''">Selfie</v-tab>
                <v-tab class="text-none" :class="stagewise.nominee == 'yes' ? 'stage_yes' : stagewise.nominee == 'no' ? 'stage_no' : ''">Nominee</v-tab>
                <v-tab class="text-none">Other</v-tab>
                <v-tab class="text-none" :class="stagewise.KRA == 'yes' ? 'stage_yes' : stagewise.KRA == 'no' ? 'stage_no' : ''">KRA</v-tab>
                <v-tabs-slider :color="btmdata.appv == 'y' ? '#43A833' : btmdata.appv == 'n' ? '#FF1717' : ''"></v-tabs-slider>
              </v-tabs>
            </v-col>
            <v-col cols="8" class="pa-0">
              <v-tabs
                v-model="btmrtab"
                show-arrows
                @change="
                  btmrtab == 1
                    ? btmltab == 2
                      ? (btmltab = 2)
                      : (btmltab = 3)
                    : btmrtab == 2
                    ? btmltab == 3
                      ? (btmltab = 3)
                      : (btmltab = 2)
                    : btmrtab == 3
                    ? btmltab == 5
                      ? (btmltab = 5)
                      : (btmltab = 6)
                    : btmrtab == 4
                    ? btmltab == 6
                      ? (btmltab = 6)
                      : (btmltab = 5)
                    : btmrtab == 5
                    ? (btmltab = 7)
                    : btmrtab == 6
                    ? (btmltab = 8)
                    : btmrtab == 7
                    ? (btmltab = 11)
                    : btmrtab == 8
                    ? (btmltab = 10)
                    : (btmrtab = 0),
                    stageFind()
                "
              >
                <v-tab class="text-none" :class="tab == 1 ? 'stage_yes' : tab == 2 ? 'stage_no' : ''">e-sign document</v-tab>
                <v-tab class="text-none" :class="stagewise.pan == 'yes' && stagewise.panproof == 'yes' ? 'stage_yes' : stagewise.pan == 'no' || stagewise.panproof == 'no' ? 'stage_no' : ''">PAN proof</v-tab>
                <v-tab class="text-none" :class="stagewise.digilocker == 'yes' ? 'stage_yes' : stagewise.digilocker == 'no' ? 'stage_no' : ''">Aadhar proof</v-tab>
                <v-tab class="text-none" :class="stagewise.bank == 'yes' && stagewise.bankproof == 'yes' ? 'stage_yes' : stagewise.bank == 'no' || stagewise.bankproof == 'no' ? 'stage_no' : ''">Bank proof</v-tab>
                <v-tab class="text-none" :class="stagewise.segment == 'yes' ? 'stage_yes' : stagewise.segment == 'no' ? 'stage_no' : ''">Income proof</v-tab>
                <v-tab class="text-none" :class="stagewise.signature == 'yes' ? 'stage_yes' : stagewise.signature == 'no' ? 'stage_no' : ''">Signature proof</v-tab>
                <v-tab class="text-none" :class="stagewise.selfie == 'yes' ? 'stage_yes' : stagewise.selfie == 'no' ? 'stage_no' : ''">Selfie proof</v-tab>
                <v-tab class="text-none" :class="stagewise.KRA == 'yes' ? 'stage_yes' : stagewise.KRA == 'no' ? 'stage_no' : ''">KRA proof</v-tab>
                <v-tab class="text-none" :class="stagewise.digilocker == 'yes' ? 'stage_yes' : stagewise.digilocker == 'no' ? 'stage_no' : ''">Aadhar XML/CDSL|Instabo</v-tab>
                <v-tabs-slider :color="btmrtab == 0 ? (tab == 1 ? '#43A833' : tab == 2 ? '#FF1717' : '') : btmdata.appv == 'y' ? '#43A833' : btmdata.appv == 'n' ? '#FF1717' : ''"></v-tabs-slider>
              </v-tabs>
            </v-col>
          </v-row>
          <v-row no-glutters>
            <v-col cols="4" class="pa-0" style="height: calc(100vh - 140px); overflow: scroll; border-right: thin solid #2a2a2a30">
              <v-card v-if="btmdata.data_type && btmdata.data_type.kra == 'true'" class="elevation-0 rounded-0 py-1" width="100%" color="primary lighten-4">
                <p class="white--text mb-0 text-left mx-2 caption"><span class="white--text font-weight-bold">KRA verified code.</span></p>
              </v-card>
              <v-card v-if="btmdata.data_type && btmdata.data_type.rekyc == 'Yes'" class="elevation-0 rounded-0 py-1" width="100%" color="warning">
                <p class="white--text mb-0 text-left mx-2 caption"><span class="white--text font-weight-bold">Re-activation code</span></p>
              </v-card>
              <v-card
                v-if="
                  (btmdata.declaration && (btmdata.declaration.days == '30 days' || btmdata.declaration.DDPI || btmdata.IPVrange || (btmdata.declaration.standing_instructions && (btmdata.declaration.standing_instructions.DIS || btmdata.declaration.standing_instructions.bsda)))) ||
                  btmdata.politically_exposed == 'I am' ||
                  btmdata.politically_exposed == 'Related to'
                "
                class="elevation-0 rounded-0 py-1"
                width="100%"
                color="#B71C1C"
              >
                <p v-if="btmdata.declaration.standing_instructions && btmdata.declaration.standing_instructions.DIS" class="white--text mb-0 text-left mx-2 caption">
                  <span class="white--text font-weight-bold">{{ btmdata.declaration.standing_instructions.DIS }}</span> Delivery Instruction Slip (DIS).
                </p>
                <v-divider class="my-1" v-if="btmdata.declaration.standing_instructions.bsda" color="#fff"></v-divider>
                <p v-if="btmdata.declaration.standing_instructions.bsda == 'Yes'" class="white--text mb-0 text-left mx-2 caption">
                  <span class="white--text font-weight-bold">Yes</span>
                  I Would like to open a Basic Services Demat Account
                </p>
                <v-divider class="my-1" v-if="btmdata.declaration.DDPI" color="#fff"></v-divider>
                <p v-if="btmdata.declaration.DDPI" class="white--text mb-0 text-left mx-2 caption"><span class="white--text font-weight-bold">Enable</span> DDPI to sell stocks instantly</p>
                <v-divider class="my-1" v-if="btmdata.declaration.days == '30 days'" color="#fff"></v-divider>
                <p v-if="btmdata.declaration.days == '30 days'" class="white--text mb-0 text-left mx-2 caption">Settle the account once every calendar <span class="white--text font-weight-bold">Quarterly</span>.</p>
                <v-divider class="my-1" v-if="btmdata.politically_exposed == 'I am' || btmdata.politically_exposed == 'Related to'" color="#fff"></v-divider>
                <p v-if="btmdata.politically_exposed == 'I am' || btmdata.politically_exposed == 'Related to'" class="white--text mb-0 text-left mx-2 caption">
                  This client is <span class="white--text font-weight-bold">{{ btmdata.politically_exposed == "I am" ? "Politically Exposed Person" : "Related to a politically Exposed Person" }}</span
                  >.
                </p>
                <v-divider class="my-1" v-if="btmdata.data_type && btmdata.data_type.MTf" color="#fff"></v-divider>
                <p v-if="btmdata.data_type.MTf == 'Yes'" class="white--text mb-0 text-left mx-2 caption">
                  <span class="white--text font-weight-bold">Yes</span>
                  I Would you like to enable a Margin Trading Facility (MTF)
                </p>
                <v-divider class="my-1" v-if="btmdata.IPVrange" color="#fff"></v-divider>
                <p v-if="btmdata.IPVrange" class="white--text mb-0 text-left mx-2 caption">
                  User<span class="white--text font-weight-bold"> <a class="white--text" :href="btmdata.userLocationData" target="_blank"> IPV</a></span> location is outside the country
                </p>
              </v-card>
              <div class="pa-3">
                <div v-if="btmltab == 0" class="text-left">
                  <p class="grey--text mb-0">Mobile</p>
                  <p class="black--text font-weight-bold">{{ btmdata.mobile_no ? btmdata.mobile_no : "-" }}</p>
                  <p class="grey--text mb-0">Mobile verify</p>
                  <p class="black--text font-weight-bold">{{ btmdata.mobileVerify ? btmdata.mobileVerify : "-" }}</p>
                  <p class="grey--text mb-0">Mobile verify time</p>
                  <p class="black--text font-weight-bold">{{ btmdata.mobileVerifyTime ? btmdata.mobileVerifyTime : "-" }}</p>
                </div>
                <div v-if="btmltab == 1" class="text-left">
                  <p class="grey--text mb-0">Email</p>
                  <p class="black--text font-weight-bold">{{ btmdata.client_email ? btmdata.client_email : "-" }}</p>
                  <p class="grey--text mb-0">Email verify</p>
                  <p class="black--text font-weight-bold">{{ btmdata.emailVerify ? (btmdata.emailVerify == "yes" ? btmdata.emailVerify : btmdata.emailVerify == "no" ? btmdata.emailVerify : JSON.parse(btmdata.emailVerify).email_verified == true ? "yes" : "no") : "-" }}</p>
                  <p class="grey--text mb-0">Email verify time</p>
                  <p class="black--text font-weight-bold">{{ btmdata.emailVerifyTime ? btmdata.emailVerifyTime : "-" }}</p>
                  <!--    "email_dependency": "",
      "email_time_after_esign": "",
      "email_time_before_esign": "", -->
                </div>
                <div v-if="btmltab == 2" class="text-left">
                  <p class="grey--text mb-0">Name in PAN</p>
                  <p class="black--text font-weight-bold">{{ btmdata.client_name ? btmdata.client_name : "-" }}</p>
                  <p class="grey--text mb-0">PAN number</p>
                  <p class="black--text font-weight-bold">{{ btmdata.client_pan ? btmdata.client_pan : "-" }}</p>
                  <p class="grey--text mb-0">Aadhar number</p>
                  <p class="black--text font-weight-bold">{{ btmdata.aadharNumber ? btmdata.aadharNumber : "-" }}</p>
                  <p class="grey--text mb-0">PAN / Aadhar - seeding status</p>
                  <p class="black--text font-weight-bold">{{ btmdata.aadhar_seeding_status ? btmdata.aadhar_seeding_status : "-" }}</p>
                  <p class="grey--text mb-0">PAN number verify</p>
                  <p class="black--text font-weight-bold">{{ btmdata.panVerify ? btmdata.panVerify : "-" }}</p>
                  <p class="grey--text mb-0">PAN number verify time</p>
                  <p class="black--text font-weight-bold">{{ btmdata.panVerifyTime ? btmdata.panVerifyTime : "-" }}</p>
                  <p class="grey--text mb-0">PAN proof type</p>
                  <p class="black--text font-weight-bold">{{ btmdata.pan_is ? (btmdata.pan_is == "y" ? "Digitallocker download" : "Manual upload") : " - " }}</p>
                  <p class="grey--text mb-0">PAN download response</p>
                  <p class="black--text font-weight-bold">{{ btmdata.pandownresp ? btmdata.pandownresp : "-" }}</p>
                </div>
                <div v-if="btmltab == 3" class="text-left">
                  <p class="grey--text mb-0">Aadhar number</p>
                  <p class="black--text font-weight-bold">{{ btmdata.aadhar_no ? btmdata.aadhar_no : "-" }}</p>
                  <p class="grey--text mb-0">Name in {{ btmdata.verif }}</p>
                  <p class="black--text font-weight-bold">{{ btmdata.adhar_name ? btmdata.adhar_name : "-" }}</p>
                  <p class="grey--text mb-0">DOB in {{ btmdata.verif }}</p>
                  <p class="black--text font-weight-bold">{{ btmdata.adhar_dob ? btmdata.adhar_dob : "-" }}</p>
                  <p class="grey--text mb-0">Gender in {{ btmdata.verif }}</p>
                  <p class="black--text font-weight-bold">{{ btmdata.adhar_gender ? btmdata.adhar_gender : "-" }}</p>
                  <p class="grey--text mb-0">Father Name in {{ btmdata.verif }}</p>
                  <p class="black--text font-weight-bold">{{ btmdata.adhar_fathername ? btmdata.adhar_fathername : "-" }}</p>
                  <p class="grey--text mb-0">Address in {{ btmdata.verif }}</p>
                  <p class="black--text font-weight-bold">{{ btmdata.aadhar_address ? btmdata.aadhar_address : "-" }}</p>
                  <p class="grey--text mb-0">{{ btmdata.verif }} verify</p>
                  <p class="black--text font-weight-bold">{{ btmdata.digilockerVerify ? btmdata.digilockerVerify : "-" }}</p>
                  <p class="grey--text mb-0">{{ btmdata.verif }} verify time</p>
                  <p class="black--text font-weight-bold">{{ btmdata.digilockerVerifyTime ? btmdata.digilockerVerifyTime : "-" }}</p>
                </div>
                <div v-if="btmltab == 4" class="text-left">
                  <p class="grey--text mb-0">Father/Spouse name</p>
                  <p class="black--text font-weight-bold">{{ btmdata.fathername ? btmdata.fathername : "-" }}</p>
                  <p class="grey--text mb-0">Mother name</p>
                  <p class="black--text font-weight-bold">{{ btmdata.mothername ? btmdata.mothername : "-" }}</p>
                  <p class="grey--text mb-0">Marital status</p>
                  <p class="black--text font-weight-bold">{{ btmdata.marital_status ? btmdata.marital_status : "-" }}</p>
                  <p class="grey--text mb-0">Trading experience</p>
                  <p class="black--text font-weight-bold">{{ btmdata.TradingExperience ? btmdata.TradingExperience : "-" }}</p>
                  <p class="grey--text mb-0">Annual Income</p>
                  <p class="black--text font-weight-bold">{{ btmdata.annual_income ? btmdata.annual_income : "-" }}</p>
                  <p class="grey--text mb-0">Occupation</p>
                  <p class="black--text font-weight-bold">{{ btmdata.Occupation ? btmdata.Occupation : "-" }}</p>
                </div>
                <div v-if="btmltab == 5" class="text-left">
                  <p class="grey--text mb-0">Bank AC no</p>
                  <p class="black--text font-weight-bold">{{ btmdata.BankAccountNumber ? btmdata.BankAccountNumber : "-" }}</p>
                  <p class="grey--text mb-0">Bank IFSC code</p>
                  <p class="black--text font-weight-bold">{{ btmdata.IFSC ? btmdata.IFSC : "-" }}</p>
                  <p class="grey--text mb-0">Bank MICR code</p>
                  <p class="black--text font-weight-bold">{{ btmdata.MICR ? btmdata.MICR : "-" }}</p>
                  <p class="grey--text mb-0">Bank Account type</p>
                  <p class="black--text font-weight-bold">{{ btmdata.bank_account_type ? btmdata.bank_account_type : "-" }}</p>
                  <p class="grey--text mb-0">Bank name</p>
                  <p class="black--text font-weight-bold">{{ btmdata.BankName ? btmdata.BankName : "-" }}</p>
                  <p class="grey--text mb-0">Bank address</p>
                  <p class="black--text font-weight-bold">{{ btmdata.BankAddress ? btmdata.BankAddress : "-" }}</p>
                  <p class="grey--text mb-0">Bank branch name</p>
                  <p class="black--text font-weight-bold">{{ btmdata.BranchName ? btmdata.BranchName : "-" }}</p>
                  <p class="grey--text mb-0">Bank verify</p>
                  <p class="black--text font-weight-bold">{{ btmdata.bankverify ? btmdata.bankverify : "-" }}</p>
                  <p class="grey--text mb-0">Penny drop verify</p>
                  <p class="black--text font-weight-bold">{{ btmdata.peenydropVerify ? btmdata.peenydropVerify : "-" }}</p>
                  <v-btn v-if="tab == 0 && btmdata.peenydropVerify && btmdata.peenydropVerify != 'yes'" @click="getUserPDstat(btmdata)" color="warning" class="white--text font-weight-bold mb-2 text-none" block>Status check</v-btn>
                  <p class="grey--text mb-0">Penny drop verify time</p>
                  <p class="black--text font-weight-bold">{{ btmdata.peenydropVerifyTime ? btmdata.peenydropVerifyTime : "-" }}</p>
                  <div v-if="btmdata.pennyresponse && btmdata.pennyresponse.status == 'BAV_REVERSE_PENNY_DROP_PAYMENT_SUCCESSFUL'">
                    <p class="grey--text mb-0">Reverse penny drop status</p>
                    <p class="black--text font-weight-bold">{{ btmdata.pennyresponse ? btmdata.pennyresponse.data.ifscDetails.upi : "-" }}</p>
                    <p class="grey--text mb-0">Reverse penny drop reg name</p>
                    <p class="black--text font-weight-bold">{{ btmdata.pennyresponse ? btmdata.pennyresponse.data.bankAccountName : "-" }}</p>
                  </div>
                  <div v-else>
                    <p class="grey--text mb-0">Penny drop status</p>
                    <p class="black--text font-weight-bold">{{ btmdata.pennyresponse ? btmdata.pennyresponse.results.account_status : "-" }}</p>
                    <p class="grey--text mb-0">Penny drop reg name</p>
                    <p class="black--text font-weight-bold">{{ btmdata.pennyresponse ? btmdata.pennyresponse.results.registered_name : "-" }}</p>
                  </div>
                  <p class="grey--text mb-0">Bank proof type</p>
                  <p class="black--text font-weight-bold">{{ btmdata.bankProofType ? btmdata.bankProofType : "-" }}</p>
                </div>
                <div v-if="btmltab == 6" class="text-left">
                  <!-- <p class="grey--text mb-0">Future and Options</p>
                <p class="black--text font-weight-bold">{{ btmdata.fno ? btmdata.fno : '-' }}</p> -->
                  <p class="grey--text mb-0">Segments selection</p>
                  <p class="black--text font-weight-bold">{{ btmdata.segment ? btmdata.segment : "-" }}</p>
                  <p class="grey--text mb-0">Segments proof type</p>
                  <p class="black--text font-weight-bold">{{ btmdata.incometype ? (btmdata.incometype == 'AA Bank Statement' ? 'HyperVerge’s Bank Statement' : btmdata.incometype ) : "-" }}</p>

                  <!-- <v-chip-group v-if="btmdata.segment" column>
                  <v-chip class="black--text font-weight-bold" small v-for="(l, k) in btmdata.segment" :key="k">
                    {{ l }}
                  </v-chip>
                </v-chip-group> -->
                </div>
                <div v-if="btmltab == 7" class="text-left">
                  <!-- {{btmdata.hyvress}} -->
                  <div v-if="btmdata.hyvress && btmdata.hyvress != null">
                    <p class="grey--text mb-0">Signature Detection Status</p>
                    <p class="black--text font-weight-bold">{{ btmdata.hyvress.Wet_Signature_Signature_Detection_Status ? btmdata.hyvress.Wet_Signature_Signature_Detection_Status : "-" }}</p>

                    <p class="grey--text mb-0">Signature Mode</p>
                    <p class="black--text font-weight-bold">{{ btmdata.hyvress.Wet_Signature_Signature_Mode ? btmdata.hyvress.Wet_Signature_Signature_Mode : "-" }}</p>

                    <p class="grey--text mb-0">Signature Detection API Message</p>
                    <p class="black--text font-weight-bold">{{ btmdata.hyvress.Wet_Signature_Signature_Detection_API_Message ? btmdata.hyvress.Wet_Signature_Signature_Detection_API_Message : "-" }}</p>

                    <p class="grey--text mb-0">transactionId</p>
                    <p class="black--text font-weight-bold d-flex align-items-center cursor-pointer" @click="copyToClipboard(btmdata.hyvress_trxid_sig)">
                      {{ btmdata.hyvress_trxid_sig ? btmdata.hyvress_trxid_sig : "-" }}
                      <v-icon small class="ml-2">mdi-content-copy</v-icon>
                    </p>
                  </div>

                  <p class="grey--text mb-0">Signature type</p>
                  <p class="black--text font-weight-bold">{{ btmdata.data_type ? (btmdata.data_type.signtype.includes("digital") ? "Digital signed" : "Manual upload") : "-" }}</p>
                </div>
                <!--<div v-if="btmltab == 8" class="text-left">

              </div> -->
                <div v-if="btmltab == 8" class="text-left">
                  <div v-if="btmdata.hyv_ipv_res && (btmdata.hyv_ipv_res != null || Object.keys(btmdata.hyv_ipv_res) != 0  )">
                    <p class="grey--text mb-0">Selfie Liveness Score  </p>
                    <p class="black--text font-weight-bold">{{ (btmdata.hyv_ipv_res.details && btmdata.hyv_ipv_res.details.Selfie_Liveness_Score) || (btmdata.hyv_ipv_res.result && btmdata.hyv_ipv_res.result.userDetails && btmdata.hyv_ipv_res.result.userDetails.Selfie_Liveness_Score) || btmdata.hyv_ipv_res.Selfie_Liveness_Score || "-" }}</p>
                    <p class="grey--text mb-0">Geolocation</p>
                    <p class="black--text font-weight-bold">
                      {{ (btmdata.hyv_ipv_res.details && btmdata.hyv_ipv_res.details.Geolocation_From_IP_City) || (btmdata.hyv_ipv_res.result && btmdata.hyv_ipv_res.result.userDetails && btmdata.hyv_ipv_res.result.userDetails.Geolocation_From_IP_City) || btmdata.hyv_ipv_res.Geolocation_From_IP_City || "-" }} - {{ (btmdata.hyv_ipv_res.details && btmdata.hyv_ipv_res.details.Geolocation_From_IP_Zip_Code) || (btmdata.hyv_ipv_res.result && btmdata.hyv_ipv_res.result.userDetails && btmdata.hyv_ipv_res.result.userDetails.Geolocation_From_IP_Zip_Code) || btmdata.hyv_ipv_res.Geolocation_From_IP_Zip_Code || "-" }},
                      {{ (btmdata.hyv_ipv_res.details && btmdata.hyv_ipv_res.details.Geolocation_From_IP_Country) || (btmdata.hyv_ipv_res.result && btmdata.hyv_ipv_res.result.userDetails && btmdata.hyv_ipv_res.result.userDetails.Geolocation_From_IP_Country) || btmdata.hyv_ipv_res.Geolocation_From_IP_Country || "-" }}
                    </p>
                  </div>
                  <p class="grey--text mb-0">IP address</p>
                  <p class="black--text font-weight-bold">{{ btmdata.IPaddress ? btmdata.IPaddress : "-" }}</p>
                  <p class="grey--text mb-0">Geolocation on selfie</p>
                  <!-- <p class="black--text font-weight-bold">
                    <a :href="btmdata.userLocationData ? btmdata.userLocationData : ''" target="_blank">{{ btmdata.userLocationData ? btmdata.userLocationData : "-" }}</a>
                  </p> -->
                  <iframe v-if="btmdata.hyvres && btmdata.hyvres != null" width="100%" height="200px" style="border: 0" loading="lazy" allowfullscreen :src="`${btmdata.userLocationData ? btmdata.userLocationData.replace('search?', 'maps?') : ''}&hl=es;z=14&output=embed`"> </iframe>

                  <p class="grey--text mb-0">transactionId</p>
                  <p class="black--text font-weight-bold d-flex align-items-center cursor-pointer" @click="copyToClipboard(btmdata.hyvres_trxid_ipv)">
                    {{ btmdata.hyvres_trxid_ipv ? btmdata.hyvres_trxid_ipv : "-" }}
                    <v-icon small class="ml-2">mdi-content-copy</v-icon>
                  </p>
                </div>
                <div v-if="btmltab == 9" class="text-left">
                  <p class="grey--text mb-0">Nominee for investment</p>
                  <p class="black--text font-weight-bold">{{ btmdata.nominee_check ? (btmdata.nominee_check == "no" ? "No, i will do it later" : btmdata.nominee_check) : "-" }}</p>
                  <iframe height="500px"  v-if="btmdata.nominee_check && btmdata.nominee_check == 'No'" :src="`${apivideononul}/nominee_opt_out_video/${btmdata.mobile_no ? btmdata.mobile_no : ''}`"></iframe> 
                  <v-expansion-panels class="elevation-0">
                    <v-expansion-panel class="exp-sty">
                      <v-expansion-panel-header class="px-0" :class="btmdata.nominee1_name ? (btmdata.nominee1_name.length > 0 ? 'font-weight-bold' : 'font-weight-regular') : ''">1st Nominee </v-expansion-panel-header>
                      <v-expansion-panel-content class="px-0 text-left">
                        <p class="grey--text mb-0">Nominee name</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee1_name ? btmdata.nominee1_name : "-" }}</p>
                        <p class="grey--text mb-0">Nominee relation</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee1_relation ? btmdata.nominee1_relation : "-" }}</p>
                        <p class="grey--text mb-0">Nominee percentage</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee1_percentage ? btmdata.nominee1_percentage : "-" }}</p>
                        <p class="grey--text mb-0">Nominee DOB</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee1_DOB ? btmdata.nominee1_DOB : "-" }}</p>
                        <p class="grey--text mb-0">Nominee address</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee1_address1 ? btmdata.nominee1_address1 : "-" }}</p>
                        <p class="grey--text mb-0">Nominee city</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee1_city ? btmdata.nominee1_city : "-" }}</p>
                        <p class="grey--text mb-0">Nominee pincode</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee1_pincode ? btmdata.nominee1_pincode : "-" }}</p>
                        <p class="grey--text mb-0">Nominee state</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee1_state ? btmdata.nominee1_state : "-" }}</p>
                        <p class="grey--text mb-0">Nominee country</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee1_country ? btmdata.nominee1_country : "-" }}</p>
                        <p class="grey--text mb-0">Nominee email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_email ?
                        btmdata.nominee1_email : '-' }}</p>
                      <p class="grey--text mb-0">Nominee mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_mobile ?
                        btmdata.nominee1_mobile : '-' }}</p>

                           <p class="grey--text mb-0">Nominee Proof Type</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_Select_id ?
                        btmdata.nominee1_Select_id == 'PROOF OF IDENTITY' || btmdata.nominee1_Select_id == 'PROFF OF IDENTITY' ? 'Driving Licence Number' : btmdata.nominee1_Select_id : '-' }}</p>

                        <p class="grey--text mb-0">Nominee {{ btmdata.nominee1_Select_id }} Number</p>
                      <p class="black--text font-weight-bold"><span v-if="btmdata.nominee1_Select_id == 'AADHAR'">XXXX-XXXX-</span>{{ btmdata.Nominee1_PAN ?
                        btmdata.Nominee1_PAN : '-' }}</p>
                        <p class="grey--text mb-0">guardian name</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_name ? btmdata.guardian_name : "-" }}</p>
                        <p class="grey--text mb-0">guardian relation</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_relation ? btmdata.guardian_relation : "-" }}</p>
                        <p class="grey--text mb-0">guardian DOB</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_dob ? btmdata.guardian_dob : "-" }}</p>
                        <p class="grey--text mb-0">guardian address</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_address ? btmdata.guardian_address : "-" }}</p>
                        <p class="grey--text mb-0">guardian city</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_city ? btmdata.guardian_city : "-" }}</p>
                        <p class="grey--text mb-0">guardian state</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_state ? btmdata.guardian_state : "-" }}</p>
                        <p class="grey--text mb-0">guardian pincode</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_pincode ? btmdata.guardian_pincode : "-" }}</p>
                        <p class="grey--text mb-0">guardian country</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_country ? btmdata.guardian_country : "-" }}</p>
                        <!-- <p class="grey--text mb-0">guardian email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_email ?
                        btmdata.guardian_email : '-' }}</p>
                      <p class="grey--text mb-0">guardian mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_mobile ?
                        btmdata.guardian_mobile : '-' }}</p> -->
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel class="exp-sty" :class="btmdata.nominee2_name ? (btmdata.nominee2_name.length > 0 ? 'font-weight-bold' : 'font-weight-regular') : ''">
                      <v-expansion-panel-header class="px-0">2nd Nominee </v-expansion-panel-header>
                      <v-expansion-panel-content class="px-0 text-left">
                        <p class="grey--text mb-0">Nominee name</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee2_name ? btmdata.nominee2_name : "-" }}</p>
                        <p class="grey--text mb-0">Nominee relation</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee2_relation ? btmdata.nominee2_relation : "-" }}</p>
                        <p class="grey--text mb-0">Nominee percentage</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee2_percentage ? btmdata.nominee2_percentage : "-" }}</p>
                        <p class="grey--text mb-0">Nominee DOB</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee2_DOB ? btmdata.nominee2_DOB : "-" }}</p>
                        <p class="grey--text mb-0">Nominee address</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee2_address1 ? btmdata.nominee2_address1 : "-" }}</p>
                        <p class="grey--text mb-0">Nominee city</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee2_city ? btmdata.nominee2_city : "-" }}</p>
                        <p class="grey--text mb-0">Nominee pincode</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee2_pincode ? btmdata.nominee2_pincode : "-" }}</p>
                        <p class="grey--text mb-0">Nominee state</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee2_state ? btmdata.nominee2_state : "-" }}</p>
                        <p class="grey--text mb-0">Nominee country</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee2_country ? btmdata.nominee2_country : "-" }}</p>
                        <p class="grey--text mb-0">Nominee email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_email ?
                        btmdata.nominee2_email : '-' }}</p>
                      <p class="grey--text mb-0">Nominee mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_mobile ?
                        btmdata.nominee2_mobile : '-' }}</p>
                         <p class="grey--text mb-0">Nominee Proof Type</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_Select_id ?
                        btmdata.nominee2_Select_id == 'PROOF OF IDENTITY' || btmdata.nominee1_Select_id == 'PROFF OF IDENTITY' ? 'Driving Licence Number' : btmdata.nominee2_Select_id : '-' }}</p>

                        <p class="grey--text mb-0">Nominee {{ btmdata.nominee2_Select_id }} Number</p>
                      <p class="black--text font-weight-bold"><span v-if="btmdata.nominee2_Select_id == 'AADHAR'">XXXX-XXXX-</span>{{ btmdata.Nominee2_PAN ?
                        btmdata.Nominee2_PAN : '-' }}</p>
                        <p class="grey--text mb-0">guardian name</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_name2 ? btmdata.guardian_name2 : "-" }}</p>
                        <p class="grey--text mb-0">guardian relation</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_relation2 ? btmdata.guardian_relation2 : "-" }}</p>
                        <p class="grey--text mb-0">guardian DOB</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_dob2 ? btmdata.guardian_dob2 : "-" }}</p>
                        <p class="grey--text mb-0">guardian address</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_address2 ? btmdata.guardian_address2 : "-" }}</p>
                        <p class="grey--text mb-0">guardian city</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_city2 ? btmdata.guardian_city2 : "-" }}</p>
                        <p class="grey--text mb-0">guardian state</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_state2 ? btmdata.guardian_state2 : "-" }}</p>
                        <p class="grey--text mb-0">guardian pincode</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_pincode2 ? btmdata.guardian_pincode2 : "-" }}</p>
                        <p class="grey--text mb-0">guardian country</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_country2 ? btmdata.guardian_country2 : "-" }}</p>
                        <!-- <p class="grey--text mb-0">guardian email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_email2 ?
                        btmdata.guardian_email2 : '-' }}</p>
                      <p class="grey--text mb-0">guardian mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_mobile2 ?
                        btmdata.guardian_mobile2 : '-' }}</p> -->
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel class="exp-sty" :class="btmdata.nominee3_name ? (btmdata.nominee3_name.length > 0 ? 'font-weight-bold' : 'font-weight-regular') : ''">
                      <v-expansion-panel-header class="px-0">3rd Nominee </v-expansion-panel-header>
                      <v-expansion-panel-content class="px-0 text-left">
                        <p class="grey--text mb-0">Nominee name</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee3_name ? btmdata.nominee3_name : "-" }}</p>
                        <p class="grey--text mb-0">Nominee relation</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee3_relation ? btmdata.nominee3_relation : "-" }}</p>
                        <p class="grey--text mb-0">Nominee percentage</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee3_percentage ? btmdata.nominee3_percentage : "-" }}</p>
                        <p class="grey--text mb-0">Nominee DOB</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee3_DOB ? btmdata.nominee3_DOB : "-" }}</p>
                        <p class="grey--text mb-0">Nominee address</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee3_address1 ? btmdata.nominee3_address1 : "-" }}</p>
                        <p class="grey--text mb-0">Nominee city</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee3_city ? btmdata.nominee3_city : "-" }}</p>
                        <p class="grey--text mb-0">Nominee pincode</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee3_pincode ? btmdata.nominee3_pincode : "-" }}</p>
                        <p class="grey--text mb-0">Nominee state</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee3_state ? btmdata.nominee3_state : "-" }}</p>
                        <p class="grey--text mb-0">Nominee country</p>
                        <p class="black--text font-weight-bold">{{ btmdata.nominee3_country ? btmdata.nominee3_country : "-" }}</p>
                        <p class="grey--text mb-0">Nominee email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_email ?
                        btmdata.nominee3_email : '-' }}</p>
                      <p class="grey--text mb-0">Nominee mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_mobile ?
                        btmdata.nominee3_mobile : '-' }}</p>
                         <p class="grey--text mb-0">Nominee Proof Type</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_Select_id ?
                        btmdata.nominee3_Select_id == 'PROOF OF IDENTITY' || btmdata.nominee1_Select_id == 'PROFF OF IDENTITY' ? 'Driving Licence Number' : btmdata.nominee3_Select_id : '-' }}</p>

                        <p class="grey--text mb-0">Nominee {{ btmdata.nominee3_Select_id }} Number</p>
                      <p class="black--text font-weight-bold"><span v-if="btmdata.nominee3_Select_id == 'AADHAR'">XXXX-XXXX-</span>{{ btmdata.Nominee3_PAN ?
                        btmdata.Nominee3_PAN : '-' }}</p>
                        <p class="grey--text mb-0">guardian name</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_name3 ? btmdata.guardian_name3 : "-" }}</p>
                        <p class="grey--text mb-0">guardian relation</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_relation3 ? btmdata.guardian_relation3 : "-" }}</p>
                        <p class="grey--text mb-0">guardian DOB</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_dob3 ? btmdata.guardian_dob3 : "-" }}</p>
                        <p class="grey--text mb-0">guardian address</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_address3 ? btmdata.guardian_address3 : "-" }}</p>
                        <p class="grey--text mb-0">guardian city</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_city3 ? btmdata.guardian_city3 : "-" }}</p>
                        <p class="grey--text mb-0">guardian state</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_state3 ? btmdata.guardian_state3 : "-" }}</p>
                        <p class="grey--text mb-0">guardian pincode</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_pincode3 ? btmdata.guardian_pincode3 : "-" }}</p>
                        <p class="grey--text mb-0">guardian country</p>
                        <p class="black--text font-weight-bold">{{ btmdata.guardian_country3 ? btmdata.guardian_country3 : "-" }}</p>
                        <!-- <p class="grey--text mb-0">guardian email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_email3 ?
                        btmdata.guardian_email3 : '-' }}</p>
                      <p class="grey--text mb-0">guardian mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_mobile3 ?
                        btmdata.guardian_mobile3 : '-' }}</p> -->
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                <div v-if="btmltab == 10" class="text-left">
                  <p class="grey--text mb-0">DPID</p>
                  <p class="black--text font-weight-bold">{{ btmdata.dpid ? btmdata.dpid : "-" }}</p>
                  <p class="grey--text mb-0">Client Id</p>
                  <p class="black--text font-weight-bold">{{ btmdata.client_id ? btmdata.client_id : "-" }}</p>
                  <p class="grey--text mb-0">RM-code</p>
                  <p class="black--text font-weight-bold">{{ btmdata.rmcode ? btmdata.rmcode : "-" }}</p>
                  <p class="grey--text mb-0">Login type</p>
                  <p class="black--text font-weight-bold">{{ btmdata.login_type ? btmdata.login_type : "-" }}</p>
                  <p class="grey--text mb-0">Coupon code</p>
                  <p class="black--text font-weight-bold">{{ btmdata.cuponcode ? btmdata.cuponcode : "-" }}</p>
                  <p class="grey--text mb-0">Unused funds to be settled after every _____?</p>
                  <p class="black--text font-weight-bold">{{ btmdata.declaration ? btmdata.declaration.days : "-" }}</p>
                  <p class="grey--text mb-0">CDSL File Path BO</p>
                  <p class="black--text font-weight-bold">{{ btmdata.CDSLfile_path_bo ? btmdata.CDSLfile_path_bo.split('/').pop() : "-" }}</p>
                </div>
                <div v-if="btmltab == 11" class="text-left">
                  <p class="grey--text mb-0">KRA Esigned</p>
                  <p class="black--text font-weight-bold">{{ btmdata.kra_esigned ? btmdata.kra_esigned : "-" }}</p>
                  <p class="grey--text mb-0">KRA Esigned time</p>
                  <p class="black--text font-weight-bold">{{ btmdata.kra_esigned_time ? btmdata.kra_esigned_time : "-" }}</p>
                  <p class="grey--text mb-0">KRA</p>
                  <p class="black--text font-weight-bold">{{ btmdata.kra ? btmdata.kra : "-" }}</p>
                  <p class="grey--text mb-0">Complete KRA</p>
                  <p class="black--text font-weight-bold">{{ btmdata.complete_kra ? btmdata.complete_kra : "-" }}</p>
                  <p class="grey--text mb-0">KRA Document Uploaded</p>
                  <p class="black--text font-weight-bold">{{ btmdata.kraDocumentUploaded ? btmdata.kraDocumentUploaded : "-" }}</p>
                  <p class="grey--text mb-0">KRA Link</p>
                  <p class="black--text font-weight-bold">{{ btmdata.kra_link ? btmdata.kra_link : "-" }}</p>
                  <p class="grey--text mb-0">KRA Hash</p>
                  <p class="black--text font-weight-bold">{{ btmdata.kra_hash ? btmdata.kra_hash : "-" }}</p>
                  <p class="grey--text mb-0">KRA Transaction Id</p>
                  <p class="black--text font-weight-bold">{{ btmdata.transaction_id_kra ? btmdata.transaction_id_kra : "-" }}</p>
                  <v-divider class="mb-4"></v-divider>
                  <div v-if="btmdata.kradata && btmdata.kradata.cor_addr">
                    <div v-for="(n, l) in btmdata.kradata.cor_addr" :key="l">
                      <p class="grey--text mb-0">{{ l ? l : "-" }}</p>
                      <p class="black--text font-weight-bold">{{ n ? n : "-" }}</p>
                    </div>
                  </div>
                  <v-divider class="mb-4"></v-divider>
                  <div v-if="btmdata.kradata && btmdata.kradata.per_addr">
                    <div v-for="(n, l) in btmdata.kradata.per_addr" :key="l">
                      <p class="grey--text mb-0">{{ l ? l : "-" }}</p>
                      <p class="black--text font-weight-bold">{{ n ? n : "-" }}</p>
                    </div>
                  </div>
                  <v-divider class="mb-4"></v-divider>
                  <div v-if="btmdata.kradata && btmdata.kradata.personal_details">
                    <div v-for="(n, l) in btmdata.kradata.personal_details" :key="l">
                      <p class="grey--text mb-0">{{ l ? l : "-" }}</p>
                      <p class="black--text font-weight-bold">{{ n ? n : "-" }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="8" style="height: calc(100vh - 140px); overflow: scroll" class="pa-0">
              <v-tabs-items v-model="btmrtab">
                <v-tab-item>
                  <iframe style="border: none; border-radius: 0; height: calc(100vh - 160px)" :src="btmdata.e_signed_pdf_path ? btmdata.e_signed_pdf_path : ''" width="100%"></iframe>
                </v-tab-item>
                <v-tab-item style="position: relative">
                  <p class="text-center pt-16" v-if="btmdata.verif == 'KRA'">For KRA flow, PAN proof is not required.</p>
                  <div v-else>
                    <iframe v-if="btmdata.pan_is == 'y'" style="border: none; border-radius: 0; height: calc(100vh - 160px)" :src="btmdata.uploadPAN ? btmdata.uploadPAN : ''" width="100%"></iframe>
                    <img
                      v-else
                      :style="`transform: rotate(${panrot.rot}deg) scaleX(${panrot.flip == 0 ? -1 : 1}) !important; padding: ${panrot.pad / 3}px ${panrot.pad}px !important; ${
                        panrot.rot == 90 ? 'height:calc(100vh - 160px) !important;' : panrot.rot == 270 ? 'height:calc(100vh - 160px) !important;' : ''
                      }`"
                      :src="btmdata.uploadPAN ? btmdata.uploadPAN : ''"
                      :width="panrot.rot == 0 || panrot.rot == 180 ? '80%' : '100%'"
                      :alt="btmdata.uploadPAN"
                    />

                    <div v-if="btmdata.pan_is != 'y'" style="position: fixed !important; top: 112px; right: 8px; display: grid !important">
                      <v-btn @click="panrot.rot != 270 ? (panrot.rot = panrot.rot + 90) : (panrot.rot = 0)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-right</v-icon></v-btn>
                      <v-btn class="mt-2" @click="panrot.pad = panrot.pad + 16" fab small color="#2a2a2a"><v-icon color="#fff">mdi-minus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="panrot.pad != 0 ? (panrot.pad = panrot.pad - 16) : 0" fab small color="#2a2a2a"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="panrot.flip == 0 ? (panrot.flip = 1) : (panrot.flip = 0)" fab small color="#2a2a2a"
                        ><v-icon color="#fff">{{ panrot.flip == 0 ? "mdi-rotate-left-variant" : "mdi-rotate-right-variant" }}</v-icon></v-btn
                      >
                      <v-btn class="mt-2" @click="(panrot.flip = 1), (panrot.rot = 0), (panrot.pad = 0)" fab small color="#fff"><v-icon color="#000">mdi-close</v-icon></v-btn>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item>
                  <p class="text-center pt-16" v-if="btmdata.verif == 'KRA'">For KRA flow, Aadhar proof is not required.</p>
                  <div v-else>
                    <iframe style="border: none; border-radius: 0; height: calc(100vh - 160px)" :src="btmdata.adhar_file ? btmdata.adhar_file : ''" width="100%"></iframe>
                  </div>
                </v-tab-item>
                <v-tab-item style="position: relative">
                  <div v-if="btmdata.uploadBankproof == '' && (btmdata.incometype == 'Bank statement' || btmdata.incometype == 'AA Bank statement')" class="pt-6">
                    <p>In the segment stage, the income-proof; <b>Bank statement</b> is uploaded, so bank proof is not required.</p>
                    <iframe v-if="btmdata.income_is == 'y'" style="border: none; border-radius: 0; height: calc(100vh - 216px)" :src="btmdata.uploadFinancialproof ? btmdata.uploadFinancialproof : ''" width="100%"></iframe>
                    <img
                      v-else
                      :style="`transform: rotate(${incrot.rot}deg) scaleX(${incrot.flip == 0 ? -1 : 1}) !important; padding: ${incrot.pad / 3}px ${incrot.pad}px !important; ${
                        incrot.rot == 90 ? 'height:calc(100vh - 160px) !important;' : incrot.rot == 270 ? 'height:calc(100vh - 160px) !important;' : ''
                      }`"
                      :src="btmdata.uploadFinancialproof ? btmdata.uploadFinancialproof : ''"
                      :width="incrot.rot == 0 || incrot.rot == 180 ? '80%' : '100%'"
                      :alt="btmdata.uploadFinancialproof"
                    />

                    <div v-if="btmdata.income_is != 'y'" style="position: fixed !important; top: 112px; right: 8px; display: grid !important">
                      <v-btn @click="incrot.rot != 270 ? (incrot.rot = incrot.rot + 90) : (incrot.rot = 0)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-right</v-icon></v-btn>
                      <v-btn class="mt-2" @click="incrot.pad = incrot.pad + 16" fab small color="#2a2a2a"><v-icon color="#fff">mdi-minus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="incrot.pad != 0 ? (incrot.pad = incrot.pad - 16) : 0" fab small color="#2a2a2a"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="incrot.flip == 0 ? (incrot.flip = 1) : (incrot.flip = 0)" fab small color="#2a2a2a"
                        ><v-icon color="#fff">{{ incrot.flip == 0 ? "mdi-rotate-left-variant" : "mdi-rotate-right-variant" }}</v-icon></v-btn
                      >
                      <v-btn class="mt-2" @click="(incrot.flip = 1), (incrot.rot = 0), (incrot.pad = 0)" fab small color="#fff"><v-icon color="#000">mdi-close</v-icon></v-btn>
                    </div>
                  </div>
                  <div v-else>
                    <iframe v-if="btmdata.bank_is == 'y'" style="border: none; border-radius: 0; height: calc(100vh - 160px)" :src="btmdata.uploadBankproof ? btmdata.uploadBankproof : ''" width="100%"></iframe>
                    <img
                      v-else
                      :style="`transform: rotate(${bankrot.rot}deg) scaleX(${bankrot.flip == 0 ? -1 : 1}) !important; padding: ${bankrot.pad / 3}px ${bankrot.pad}px !important; ${
                        bankrot.rot == 90 ? 'height:calc(100vh - 160px) !important;' : bankrot.rot == 270 ? 'height:calc(100vh - 160px) !important;' : ''
                      }`"
                      :src="btmdata.uploadBankproof ? btmdata.uploadBankproof : ''"
                      :width="bankrot.rot == 0 || bankrot.rot == 180 ? '80%' : '100%'"
                      :alt="btmdata.uploadBankproof"
                    />
                    <div v-if="btmdata.bank_is != 'y'" style="position: fixed !important; top: 112px; right: 8px; display: grid !important">
                      <v-btn @click="bankrot.rot != 270 ? (bankrot.rot = bankrot.rot + 90) : (bankrot.rot = 0)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-right</v-icon></v-btn>
                      <v-btn class="mt-2" @click="bankrot.pad = bankrot.pad + 16" fab small color="#2a2a2a"><v-icon color="#fff">mdi-minus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="bankrot.pad != 0 ? (bankrot.pad = bankrot.pad - 16) : 0" fab small color="#2a2a2a"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="bankrot.flip == 0 ? (bankrot.flip = 1) : (bankrot.flip = 0)" fab small color="#2a2a2a"
                        ><v-icon color="#fff">{{ bankrot.flip == 0 ? "mdi-rotate-left-variant" : "mdi-rotate-right-variant" }}</v-icon></v-btn
                      >
                      <v-btn class="mt-2" @click="(bankrot.flip = 1), (bankrot.rot = 0), (bankrot.pad = 0)" fab small color="#fff"><v-icon color="#000">mdi-close</v-icon></v-btn>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item style="position: relative">
                  <div v-if="btmdata.segment == 'Cash,F&O,Currency,Commodity' && btmdata.uploadFinancialproof == '' && (btmdata.bankProofType == 'Bank Statement' || btmdata.bankProofType == 'AA Bank Statement') && btmdata.data_type.cam_segis == true">
                    <p class="pa-8">CAMS status failed; in the bank stage, the bank-proof <b>Bank statement</b> is uploaded, so income proof is not required.</p>
                    <iframe v-if="btmdata.bank_is == 'y'" style="border: none; border-radius: 0; height: calc(100vh - 216px)" :src="btmdata.uploadBankproof ? btmdata.uploadBankproof : ''" width="100%"></iframe>
                    <img
                      v-else
                      :style="`transform: rotate(${bankrot.rot}deg) scaleX(${bankrot.flip == 0 ? -1 : 1}) !important; padding: ${bankrot.pad / 3}px ${bankrot.pad}px !important; ${
                        bankrot.rot == 90 ? 'height:calc(100vh - 160px) !important;' : bankrot.rot == 270 ? 'height:calc(100vh - 160px) !important;' : ''
                      }`"
                      :src="btmdata.uploadBankproof ? btmdata.uploadBankproof : ''"
                      :width="bankrot.rot == 0 || bankrot.rot == 180 ? '80%' : '100%'"
                      :alt="btmdata.uploadBankproof"
                    />
                    <div v-if="btmdata.bank_is != 'y'" style="position: fixed !important; top: 112px; right: 8px; display: grid !important">
                      <v-btn @click="bankrot.rot != 270 ? (bankrot.rot = bankrot.rot + 90) : (bankrot.rot = 0)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-right</v-icon></v-btn>
                      <v-btn class="mt-2" @click="bankrot.pad = bankrot.pad + 16" fab small color="#2a2a2a"><v-icon color="#fff">mdi-minus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="bankrot.pad != 0 ? (bankrot.pad = bankrot.pad - 16) : 0" fab small color="#2a2a2a"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="bankrot.flip == 0 ? (bankrot.flip = 1) : (bankrot.flip = 0)" fab small color="#2a2a2a"
                        ><v-icon color="#fff">{{ bankrot.flip == 0 ? "mdi-rotate-left-variant" : "mdi-rotate-right-variant" }}</v-icon></v-btn
                      >
                      <v-btn class="mt-2" @click="(bankrot.flip = 1), (bankrot.rot = 0), (bankrot.pad = 0)" fab small color="#fff"><v-icon color="#000">mdi-close</v-icon></v-btn>
                    </div>
                  </div>
                  <div v-else-if="btmdata.fno != 'Yes'" class="py-16">
                    <p>
                      In the segment stage, the Future and Options is <b>{{ btmdata.fno ? btmdata.fno : "-" }}</b
                      >, so proof is not required.
                    </p>
                  </div>
                  <div v-else>
                    <iframe v-if="btmdata.income_is == 'y'" style="border: none; border-radius: 0; height: calc(100vh - 160px)" :src="btmdata.uploadFinancialproof ? btmdata.uploadFinancialproof : ''" width="100%"></iframe>
                    <img
                      v-else
                      :style="`transform: rotate(${incrot.rot}deg) scaleX(${incrot.flip == 0 ? -1 : 1}) !important; padding: ${incrot.pad / 3}px ${incrot.pad}px !important; ${
                        incrot.rot == 90 ? 'height:calc(100vh - 160px) !important;' : incrot.rot == 270 ? 'height:calc(100vh - 160px) !important;' : ''
                      }`"
                      :src="btmdata.uploadFinancialproof ? btmdata.uploadFinancialproof : ''"
                      :width="incrot.rot == 0 || incrot.rot == 180 ? '80%' : '100%'"
                      :alt="btmdata.uploadFinancialproof"
                    />

                    <div v-if="btmdata.income_is != 'y'" style="position: fixed !important; top: 112px; right: 8px; display: grid !important">
                      <v-btn @click="incrot.rot != 270 ? (incrot.rot = incrot.rot + 90) : (incrot.rot = 0)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-right</v-icon></v-btn>
                      <v-btn class="mt-2" @click="incrot.pad = incrot.pad + 16" fab small color="#2a2a2a"><v-icon color="#fff">mdi-minus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="incrot.pad != 0 ? (incrot.pad = incrot.pad - 16) : 0" fab small color="#2a2a2a"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="incrot.flip == 0 ? (incrot.flip = 1) : (incrot.flip = 0)" fab small color="#2a2a2a"
                        ><v-icon color="#fff">{{ incrot.flip == 0 ? "mdi-rotate-left-variant" : "mdi-rotate-right-variant" }}</v-icon></v-btn
                      >
                      <v-btn class="mt-2" @click="(incrot.flip = 1), (incrot.rot = 0), (incrot.pad = 0)" fab small color="#fff"><v-icon color="#000">mdi-close</v-icon></v-btn>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item style="position: relative">
                  <iframe v-if="btmdata.data_type && btmdata.data_type.signtype && btmdata.data_type.signtype.includes('digital')" style="border: none; border-radius: 0; height: calc(100vh - 160px)" :src="btmdata.uploadSignature ? btmdata.uploadSignature : ''" width="100%" height="500px"></iframe>

                  <img
                    v-else
                    :style="`transform: rotate(${sigrot.rot}deg) scaleX(${sigrot.flip == 0 ? -1 : 1}) !important; padding: ${sigrot.pad / 3}px ${sigrot.pad}px !important; ${
                      sigrot.rot == 90 ? 'height:calc(100vh - 160px) !important;' : sigrot.rot == 270 ? 'height:calc(100vh - 160px) !important;' : ''
                    }`"
                    :src="btmdata.uploadSignature ? btmdata.uploadSignature : ''"
                    :width="sigrot.rot == 0 || sigrot.rot == 180 ? '80%' : '100%'"
                    :alt="btmdata.uploadSignature"
                  />

                  <div v-if="btmdata.data_type && btmdata.data_type.signtype && !btmdata.data_type.signtype.includes('digital')" style="position: fixed !important; top: 112px; right: 8px; display: grid !important">
                    <v-btn @click="sigrot.rot != 270 ? (sigrot.rot = sigrot.rot + 90) : (sigrot.rot = 0)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-right</v-icon></v-btn>
                    <v-btn class="mt-2" @click="sigrot.pad = sigrot.pad + 16" fab small color="#2a2a2a"><v-icon color="#fff">mdi-minus</v-icon></v-btn>
                    <v-btn class="mt-2" @click="sigrot.pad != 0 ? (sigrot.pad = sigrot.pad - 16) : 0" fab small color="#2a2a2a"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                    <v-btn class="mt-2" @click="sigrot.flip == 0 ? (sigrot.flip = 1) : (sigrot.flip = 0)" fab small color="#2a2a2a"
                      ><v-icon color="#fff">{{ sigrot.flip == 0 ? "mdi-rotate-left-variant" : "mdi-rotate-right-variant" }}</v-icon></v-btn
                    >
                    <v-btn class="mt-2" @click="(sigrot.flip = 1), (sigrot.rot = 0), (sigrot.pad = 0)" fab small color="#fff"><v-icon color="#000">mdi-close</v-icon></v-btn>
                  </div>
                </v-tab-item>
                <v-tab-item>
                  <iframe style="border: none; border-radius: 0; height: calc(100vh - 160px)" :src="btmdata.clientimage ? btmdata.clientimage : ''" width="100%"></iframe>
                </v-tab-item>
                <v-tab-item>
                  <p class="text-center pt-16" v-if="btmdata.verif == 'KRA'">For KRA flow, KRA proof is not required.</p>
                  <div v-else>
                    <iframe v-if="btmdata.KRA_file_path" style="border: none; border-radius: 0; height: calc(100vh - 160px)" :src="btmdata.KRA_file_path ? btmdata.KRA_file_path : ''" width="100%"></iframe>
                    <p class="py-16" v-else>Completely verify all stages, and then only KRA will generate</p>
                  </div>
                </v-tab-item>
                <v-tab-item class="py-16">
                  <v-btn class="text-none my-4 elevation-0" target="_blank" :disabled="btmdata.aadharxmlfile ? false : true" :href="btmdata.aadharxmlfile">Download Aadhar XML</v-btn>
                  <br />
                  <v-btn v-if="!protype" class="text-none my-4 elevation-0" @click="getcdslfiledownload(btmdata, 'auto')">Download CDSL|InstaBO</v-btn>
                  <v-btn v-else class="text-none my-4 elevation-0" target="_blank" @click="getcdslfiledownload(btmdata,'man')">Man-Download CDSL|InstaBO</v-btn>
                  <!-- <v-btn class="text-none my-4 elevation-0" target="_blank" :disabled="btmdata.stamp_paper_path ? false : true" :href="btmdata.stamp_paper_path">Get Stamp Paper</v-btn> -->
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </div>
        <v-footer style="position: absolute; width: 100%; bottom: 0; overflow: hidden !important">
          <v-row>
            <v-col v-if="btmltab <= 9" style="border-right: 1px solid #ddd !important" cols="4" :class="btmdata.appv == 'y' ? 'pa-0' : btmdata.appv == 'n' ? 'pa-0' : 'pa-3'">
              <v-card v-if="btmdata.appv == 'y' || btmdata.appv == 'n'" width="100%" :color="btmdata.appv == 'y' ? '#43A833' : '#FF1717'" class="text-center pt-5 pb-3 elevation-0 rounded-0 white--text font-weight-medium">
                <v-icon color="white" size="28" class="mr-3">{{ btmdata.appv == "y" ? "mdi-checkbox-multiple-marked-circle-outline" : "mdi-close-circle-outline" }}</v-icon>
                <span>{{ btmdata.sts }} stage, as {{ btmdata.appv == "y" ? "Approved" : "Rejected" }}</span>

                <v-tooltip top color="#000" v-if="btmltab != 0 && btmltab != 1 && tab == 0">
                  <template v-slot:activator="{on, attrs}">
                    <v-btn v-bind="attrs" v-on="on" class="float-right mr-3 mt-n2" small fab @click="setStageUP('')">
                      <v-icon color="#000">mdi-backup-restore</v-icon>
                    </v-btn>
                  </template>
                  <span>Restore this stage</span>
                </v-tooltip>
              </v-card>
              <v-row v-else-if="btmdata.app_status == 'e-signed completed' || btmdata.app_status == 're-e-signed completed'" no-glutters>
                <v-col cols="6">
                  <v-btn @click="dialogTrig()" height="40px" block color="#DDD" :disabled="stagebtn" class="elevation-0 rounded-lg mr-4">
                    <span class="black--text text-none">Reject</span>
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn @click="setStageUP((v = 'yes'))" height="40px" block :disabled="completebtn || stagebtn" :loading="completebtn || stagebtn" color="#FB8C00" class="elevation-0 rounded-lg">
                    <span class="white--text text-none">verify</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="px-0 py-2" :cols="btmltab <= 9 ? '8' : '12'">
              <v-toolbar dense flat color="transparent">
                <p class="grey--text mb-0 text-left">
                  App status :
                  <span class="black--text font-weight-bold" v-if="tab == 1">{{ btmdata.data_type && btmdata.data_type.app_status == "Manually updated" ? "Manually Completed" : btmdata.app_status }}</span>
                  <span class="black--text font-weight-bold" v-else-if="tab == 0">{{ btmdata.data_type && btmdata.data_type.stage ? btmdata.data_type.stage : "-" }}</span>

                  <span class="black--text font-weight-bold" v-else>{{ btmdata.app_status ? btmdata.app_status : "-" }}</span>

                  <span v-if="tab == 2" class="ml-4">
                    reason : <span class="black--text font-weight-bold">{{ btmdata.rejected_reason ? btmdata.rejected_reason : "-" }}</span>
                  </span>
                  <span class="ml-4" v-if="tab == 1 && btmdata.app_status == 'Manually updated'">
                    reason : <span class="black--text font-weight-bold">{{ btmdata.data_type ? btmdata.data_type.manually_res : "-" }}</span>
                  </span>
                </p>

                <v-spacer></v-spacer>

                <v-btn
                  v-if="tab == 0"
                  @click="bfoRejection(), (rejdialog = true)"
                  :disabled="btmdata.app_status != 'e-signed completed' && btmdata.app_status != 're-e-signed completed' && btmdata.app_status != 'e-signed pending' && btmdata.app_status != 're-e-signed pending'"
                  color="#FF1717"
                  class="elevation-0 rounded-lg mr-4"
                >
                  <span class="white--text text-none">Decline</span>
                </v-btn>
                <v-btn
                  v-if="tab == 0"
                  @click="comdialog = true"
                  :disabled="(btmdata.app_status != 'e-signed completed' && btmdata.app_status != 're-e-signed completed') || (btmdata.kra_esigned != 'Yes' && btmdata.kra_code != 'yes')"
                  :loading="completebtn"
                  color="#43A833"
                  class="elevation-0 rounded-lg"
                >
                  <span class="white--text text-none">Approve</span>
                </v-btn>
              </v-toolbar>
            </v-col>
          </v-row>
        </v-footer>
      </v-sheet>
    </v-bottom-sheet>
    <v-dialog persistent v-model="rejdialog" max-width="400">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Enter the decline reason</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="rejbtn" icon @click="rejdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4">
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="setReject()">
            <v-text-field required :rules="[(v) => !!v || 'Reason is required']" v-model="rejectreason" ref="reje" :readonly="rejbtn" label="Decline reason" class="rounded-lg" outlined clearable></v-text-field>

            <v-btn :disabled="!valid" type="submit" :loading="rejbtn" block color="#FF1717" large class="elevation-0 rounded-lg mb-4">
              <span class="white--text text-none">Decline this request</span>
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="mandialog" max-width="400">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Enter the approve reason</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="manbtn" icon @click="mandialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4">
          <v-form ref="formm" v-model="manvalid" lazy-validation @submit.prevent="setManual()">
            <v-text-field required :rules="[(v) => !!v || 'Reason is required']" v-model="manreason" ref="mane" :readonly="manbtn" label="Manual approve reason" class="rounded-lg" outlined clearable></v-text-field>

            <v-btn :disabled="!manvalid" type="submit" :loading="manbtn" block color="#795548" large class="elevation-0 rounded-lg mb-4">
              <span class="white--text text-none">Manual approve</span>
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="comdialog" max-width="400">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Request account opening</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="completebtn" icon @click="comdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4 text-center">
          <p class="mb-4">
            Are you sure the <b>{{ btmdata.client_name }}</b> application account opening confirmation request to <b>CDSL</b> ?
          </p>

            <v-text-field
            outlined
            class="mb-2"
            dense
            v-model="branchid"
            @keypress="$event.key.match(/[^a-zA-Z0-9]/) && $event.preventDefault()"
            label="Enter Branch Id"
          ></v-text-field>

           <v-text-field
           dense
            outlined
            class="mb-2"
            v-model="rmcoden"
            oninput="this.value = this.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()"
            label="Enter RM Code"
            
          ></v-text-field>

           <v-text-field
           dense
            outlined
            class="mb-2"
            v-model="refrelcoden"
            oninput="this.value = this.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()"
            label="Enter Referal Code"
            
          ></v-text-field>

           <v-text-field
           dense
            outlined
            class="mb-4"
            v-model="remisiercoden"
            oninput="this.value = this.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()"
            label="Enter Remisier Code"
          ></v-text-field>

           <v-text-field
           dense
            outlined
            class="mb-4"
            v-model="terminalidd"
            oninput="this.value = this.value.replace(/[^a-zA-Z0-9,]/g, '').toUpperCase()"
            label="Enter Terminal Id"
          ></v-text-field>


          <v-row no-glutters>
            <v-col cols="6">
              <v-btn @click="comdialog = false" block :disabled="completebtn" color="#eeeeee" class="elevation-0 rounded-lg">
                <span class="text-none">No</span>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn @click="setComplete()" block :disabled="completebtn || branchid == ''" :loading="completebtn" color="#43A833" class="elevation-0 rounded-lg">
                <span class="white--text text-none">Yes</span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="stgrejdialog" max-width="400">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Enter the stage rejection reason</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="stagebtn" icon @click="stgrejdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="px-4 pb-4 pt-2">
          <v-form ref="formo" v-model="stgvalid" lazy-validation @submit.prevent="setstgReject()">
            <p class="font-weight-bold mb-1">* {{ btmdata.sts }} stage</p>
            <v-row v-if="btmdata.sts == 'PAN' || btmdata.sts == 'Bank'">
              <v-col cols="6">
                <v-checkbox v-model="fielddoc" :label="`Select if you reject ${btmdata.sts} data`"></v-checkbox>
              </v-col>
              <v-col cols="6">
                <v-checkbox v-model="proofdoc" :label="`Select if you reject ${btmdata.sts} proof`"></v-checkbox>
              </v-col>
            </v-row>
            <v-text-field required :rules="[(v) => !!v || 'Reason is required']" type="text" ref="stgrj" v-model="stgrejectreason" :readonly="stagebtn" label="Reject reason" class="rounded-lg" outlined clearable></v-text-field>

            <v-btn v-if="btmdata.sts == 'PAN' || btmdata.sts == 'Bank'" :disabled="!stgvalid || (!fielddoc && !proofdoc)" type="submit" :loading="stagebtn" block color="#FF1717" large class="elevation-0 rounded-lg mb-4">
              <span class="white--text text-none"
                >Reject this <b>{{ btmdata.sts }}</b> stage</span
              >
            </v-btn>

            <v-btn v-else :disabled="!stgvalid" type="submit" :loading="stagebtn" block color="#FF1717" large class="elevation-0 rounded-lg mb-4">
              <span class="white--text text-none"
                >Reject this <b>{{ btmdata.sts }}</b> stage</span
              >
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="deldialog" max-width="400">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Enter the deletion reason</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="delbtn" icon @click="deldialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4 text-left">
          <v-form ref="formd" v-model="delvalid" lazy-validation @submit.prevent="setDelete()">
            <p>
              Are you sure you want to delete <b>{{ btmdata.client_id }}</b> application ?
            </p>
            <v-text-field required :rules="[(v) => !!v || 'Reason is required']" ref="delrj" v-model="delrejectreason" :readonly="delbtn" label="Delete reason" class="rounded-lg" outlined clearable></v-text-field>
            <v-row no-glutters>
              <v-col cols="6">
                <v-btn @click="deldialog = false" block :disabled="delbtn" color="#DDD" class="elevation-0 rounded-lg">
                  <span class="text-none">No</span>
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn type="submit" block :disabled="delbtn" :loading="delbtn" color="#FF1717" class="elevation-0 rounded-lg">
                  <span class="white--text text-none">Yes</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="responsdialog" class="overflow-hidden" max-width="800">
      <v-card class="rounded-xl overflow-hidden elevation-0">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">{{ respdialogmode == "cd" ? "CDSL" : respdialogmode == "bo" ? "Backoffice" : respdialogmode == "ex" ? "Exchange" : "" }} data conformation</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="completebtn" icon @click="responsdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="pa-4" style="height: calc(100vh - 166px); overflow-y: scroll">
          <div v-for="(w, e, r) in responsdatas" :key="r">
            <div v-if="respdialogmode == 'cd'">
              <p class="font-weight-bold">{{ e.split("||")[0] }}</p>
              <div>
                <v-row v-for="(t, y, u) in w" :key="u" no-glutters>
                  <v-col class="pt-0 subtitle-2" cols="4">{{ y }}</v-col>
                  <v-col class="pt-0" cols="8">
                    <v-text-field :disabled="!respdatamode" color="#fb8c00" dense v-model="responsdatas[e][y]" class="rounded-lg" label="" single-line hide-details> </v-text-field>
                  </v-col>
                </v-row>
              </div>
              <v-divider class="my-2"></v-divider>
            </div>
            <div v-if="respdialogmode == 'bo'">
              <v-row no-glutters class="mb-3">
                <v-col class="pt-0 subtitle-2" cols="4">{{ e }}</v-col>
                <v-col class="pt-0" cols="8">
                  <v-text-field :disabled="!respdatamode" color="#fb8c00" dense v-model="responsdatas[e]" class="rounded-lg" label="" single-line hide-details :readonly="typeof w != 'string'"> </v-text-field>
                </v-col>
              </v-row>
            </div>

            <div v-if="respdialogmode == 'ex'">
              <v-row no-glutters class="mb-3">
                <v-col class="pt-0 subtitle-2" cols="4">{{ e }}</v-col>
                <v-col class="pt-0" cols="8">
                  <v-text-field :disabled="!respdatamode" color="#fb8c00" dense v-model="responsdatas[e]" class="rounded-lg" label="" single-line hide-details :readonly="typeof w != 'string'"> </v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <v-divider></v-divider>
        <v-toolbar dense flat>
          <v-text-field required v-if="respdatamode" :rules="[(v) => !!v || 'Reason is required']" hide-details type="text" v-model="respdatareason" label="modification reason" class="rounded-lg" clearable></v-text-field>
          <v-spacer></v-spacer>
          <v-btn v-if="!respdatamode" @click="respdatamode = !respdatamode" class="elevation-0 rounded-md mr-4 text-none font-weight-bold" text>
            <span><v-icon>mdi-grease-pencil</v-icon> edit</span>
          </v-btn>

          <v-btn
            :loading="completebtn"
            :disabled="respdatamode ? (respdatareason ? false : true) : false"
            @click="respdialogmode == 'cd' ? setManCDSLdata(responsdatas, btmsheet) : respdialogmode == 'bo' ? setManBackoffice(responsdatas) : respdialogmode == 'ex' ? setExchange(btmdata, btmdata.exch, true) : ''"
            :color="btmdata.instbo ? '#3F51B5' : 'warning'"
            class="elevation-0 rounded-md"
          >
            <span class="white--text text-none">{{ respdialogmode == "cd" ? `Response ${btmdata.instbo ? "InstBO" : "CDSL"}` : respdialogmode == "bo" ? "Complete BackOffice" : respdialogmode == "ex" ? "Submit" : "" }}</span>
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-dialog>
    <!-- re-active clients only: read-only cdsl_reactive_check result shown before the real Complete CDSL push -->
    <v-dialog persistent v-model="cdslchkdialog" class="overflow-hidden" max-width="900">
      <v-card class="rounded-xl overflow-hidden elevation-0">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">CDSL check – {{ cdslchkdata.client_id || cdslchkitem.client_id }}</p>
          <v-chip v-if="cdslchkdata.flow" small label outlined class="ml-3 font-weight-bold">{{ cdslchkdata.flow }}</v-chip>
          <v-spacer></v-spacer>
          <v-btn :disabled="cdslchkbtn" icon @click="cdslchkdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="pa-4 text-left" style="max-height: calc(100vh - 166px); overflow-y: auto">
          <!-- 1. what Complete CDSL will do. A Blocked client shows only this box (with its Details) and the summary row:
               What changed, What will be sent, Please note and the comparison are all hidden -->
          <v-alert text :color="cdslChkStatus.color" class="mb-4 body-2">
            {{ cdslChkStatus.text }}
            <div v-if="cdslChkStatus.details" class="caption grey--text text--darken-1 mt-2">Details: {{ cdslChkStatus.details }}</div>
          </v-alert>

          <!-- 2. client summary -->
          <div class="d-flex flex-wrap body-2 mb-4">
            <span v-for="(s, i) in cdslChkSummary" :key="s.label" class="mr-2">
              <span class="grey--text">{{ s.label }}:</span> <b>{{ s.value }}</b><span v-if="i < cdslChkSummary.length - 1" class="grey--text ml-2">·</span>
            </span>
          </div>

          <!-- every detail that differs from back office, sent or not; hidden when the check gave no list (e.g. it failed) -->
          <div v-if="cdslChkChanged && !cdslChkBlocked && cdslchkdata.flow == 'BO Modify'" class="d-flex flex-wrap align-center body-2 mb-4">
            <span class="grey--text mr-2">What changed:</span>
            <span v-if="!cdslChkChanged.length" class="success--text d-inline-flex align-center"><v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>No changes – all details match back office</span>
            <v-chip v-for="c in cdslChkChanged" :key="c" x-small label color="orange darken-1" text-color="white" class="font-weight-bold mr-1 my-1">{{ c }}</v-chip>
          </div>

          <!-- exactly what the push sends; only filled for a BO Modify that sends something -->
          <template v-if="cdslChkToCdsl.length && !cdslChkBlocked">
            <p class="font-weight-bold mb-2">What will be sent to CDSL</p>
            <v-card v-for="(s, i) in cdslChkToCdsl" :key="i" outlined class="rounded-lg mb-3">
              <div class="d-flex align-center px-3 pt-2 pb-1">
                <span class="font-weight-bold body-2">{{ s.section }}</span>
                <v-chip v-if="s.chip" x-small label :color="s.chip" text-color="white" class="font-weight-bold ml-2">{{ s.action }}</v-chip>
              </div>
              <v-divider></v-divider>
              <div class="px-3 py-2 body-2">
                <div v-if="s.removeText">{{ s.removeText }}</div>
                <template v-else>
                  <v-row v-for="(f, j) in s.fields" :key="j" no-gutters class="py-1">
                    <v-col cols="5" class="grey--text text--darken-1 pr-2">
                      <!-- the CDSL column name is for the operations team only, so it stays in the tooltip -->
                      <v-tooltip top :disabled="!f.column">
                        <template v-slot:activator="{on, attrs}">
                          <span v-bind="attrs" v-on="on">{{ f.field }}</span>
                        </template>
                        <span>{{ f.column }}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="7" class="font-weight-medium">{{ f.display }}</v-col>
                  </v-row>
                </template>
              </div>
            </v-card>
          </template>

          <!-- 3. please note -->
          <v-alert v-if="cdslChkWarnings.length && !cdslChkBlocked" text color="amber darken-3" class="mb-4 body-2">
            <p class="font-weight-bold mb-1">Please note</p>
            <div v-for="(w, i) in cdslChkWarnings" :key="i">• {{ w }}</div>
          </v-alert>

          <!-- 4. comparison with back office -->
          <template v-if="(cdslChkRows.length || cdslchkdata.comparison_error) && !cdslChkBlocked">
            <p class="font-weight-bold mb-2">Client's new details vs back office</p>
            <p v-if="!cdslChkRows.length" class="body-2 grey--text">Couldn't compare with back office right now.</p>
            <v-simple-table v-else dense style="border: thin solid #e0e0e0">
              <thead>
                <tr>
                  <th>Detail</th>
                  <th>Client gave</th>
                  <th>Back office has</th>
                  <th>Result</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in cdslChkRows" :key="r.key" :style="r.sent_to_cdsl ? 'background: #fff3e0' : ''">
                  <td class="font-weight-bold py-2" style="vertical-align: top">{{ r.label }}</td>
                  <td class="py-2" style="vertical-align: top">
                    <div v-for="(l, i) in cdslChkCell(r.key, 'requested', r.requested)" :key="i">{{ l }}</div>
                  </td>
                  <td class="py-2" style="vertical-align: top">
                    <div v-for="(l, i) in cdslChkCell(r.key, 'back_office', r.back_office)" :key="i">{{ l }}</div>
                  </td>
                  <td class="py-2" style="vertical-align: top">
                    <span v-if="r.result" :class="cdslChkTextClass(cdslChkResult(r).color)" class="caption font-weight-bold d-inline-flex align-center text-no-wrap"><v-icon size="8" class="mr-1" :color="cdslChkResult(r).color">mdi-circle</v-icon>{{ cdslChkResult(r).text }}</span>
                    <div v-if="r.note" class="caption grey--text mt-1">{{ cdslChkNote(r.note) }}</div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>
        </div>
        <v-divider></v-divider>
        <v-toolbar dense flat>
          <v-spacer></v-spacer>
          <v-btn :loading="cdslchkbtn" :disabled="!cdslChkStatus.canPush || cdslchkbtn" @click="setCdslReactivePush()" color="warning" class="elevation-0 rounded-md">
            <span class="white--text text-none">Complete CDSL</span>
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="emaildialog" max-width="420">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Send email to client</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="delbtn" icon @click="(emaildialog = false), (btmdata = [])">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4 text-left">
          <v-row no-glutters>
            <v-col cols="6">
              <v-text-field clearable dense label="Mobile" class="rounded-lg" max="9999999999" min="6666666666" @keyup="emailmobile.length == 10 && emailmobile.slice(0, 1) >= 6 ? getemaildata() : (btmdata = [])" v-model="emailmobile" outlined></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field dense label="Client ID" class="rounded-lg" readonly :value="btmdata.client_id" outlined></v-text-field>
            </v-col>
          </v-row>
          <v-text-field hide-details dense readonly label="Email" class="rounded-lg" :value="btmdata.client_email" outlined></v-text-field>
          <v-switch class="mt-3" color="none" v-model="emailstatus" :label="`Email for: ${emailstatus ? 'Approve' : 'Reject'}`"></v-switch>
          <v-textarea outlined name="input-7-4" label="message textarea" auto-grow rows="1" row-height="16" clearable v-model="emailmsg"></v-textarea>
          <v-row no-glutters>
            <v-col cols="6">
              <v-btn @click="(emaildialog = false), (btmdata = [])" block :disabled="delbtn" color="#DDD" class="elevation-0 rounded-lg">
                <span class="text-none">cancel</span>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn @click="setSinglemail()" block v-if="emailmsg && emailmsg.length >= 4 && btmdata.client_email && emailmobile.length == 10" :loading="delbtn" color="#FF1717" class="elevation-0 rounded-lg">
                <span class="white--text text-none">Send</span>
              </v-btn>
              <v-btn v-else block disabled :loading="delbtn" color="#FF1717" class="elevation-0 rounded-lg">
                <span class="white--text text-none">Send</span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="columndialog" max-width="420">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Select the columns to download</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="delbtn" icon @click="(columndialog = false), (downloadcolumns = [])">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4 text-left">
          <v-autocomplete outlined clearable deletable-chips multiple small-chips color="#fb8c00" v-model="colushowdata" class="rounded-lg mb-3" :items="downloadcolumns" hide-details :disabled="mainloader" label="select column" block> </v-autocomplete>
          <v-btn @click="tab == 3 ? downloadFile('column') : downloadFile('columnview')" block :disabled="colushowdata.length == 0" :loading="delbtn" color="#FF1717" class="elevation-0 rounded-lg">
            <span class="white--text text-none">Download ({{ colushowdata ? colushowdata.length : "0" }})</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="kradialog" max-width="700">
      <v-card class="rounded-xl overflow-hidden">
        <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar" timeout="5000" :value="true" :color="snackbarclr" absolute outlined top right>
          <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
          {{ snackmsgbar }}
          <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
        </v-snackbar>
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">KRA setup</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="delbtn" icon @click="(kradialog = false), (btmdata = [])">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div>
          <v-row class="mb-0 px-4" no-glutters>
            <v-col cols="3" class="pb-1">
              <v-text-field :value="btmdata.client_id" hide-details dense readonly label="Client ID" class="rounded-lg" outlined></v-text-field>
            </v-col>
            <v-col cols="4" class="pb-1">
              <v-text-field :value="btmdata.client_pan" hide-details dense readonly label="PAN" class="rounded-lg" outlined></v-text-field>
            </v-col>
            <v-col cols="5" class="pb-1">
              <v-text-field :value="btmdata.client_name" hide-details dense readonly label="Name" class="rounded-lg" outlined></v-text-field>
            </v-col>
          </v-row>
          <v-stepper v-model="el" class="elevation-0">
            <v-stepper-header dense height="40px">
              <v-stepper-step class="px-3 py-2" :complete="el > 1" step="1"> Validation </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step class="px-3 py-2" :complete="el > 2" step="2"> Upload </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step class="px-3 py-2" step="3"> Completed </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1" class="py-2 px-3">
                <v-row no-glutters class="mt-0">
                  <v-col cols="6">
                    <p class="black--text font-weight-regular caption mb-0">
                      <v-chip color="red lighten-5" x-small class="elevation-0 pa-2"></v-chip> KRA values <v-btn color="red lighten-5" @click="setKRAfiledchanges('all', 1)" class="text-none px-1 elevation-1" x-small>select all</v-btn> <span class="float-right">Accepting</span
                      ><v-chip color="green lighten-5" x-small class="elevation-0 pa-2 float-right"></v-chip>
                    </p>
                  </v-col>
                  <v-col cols="6">
                    <p class="black--text font-weight-regular caption mb-0">
                      <v-chip color="blue lighten-5" x-small class="elevation-0 pa-2"></v-chip> New values <v-btn color="blue lighten-5" @click="setKRAfiledchanges('all', 0)" class="text-none px-1 elevation-1" x-small>select all</v-btn> <span class="float-right">Accepting</span
                      ><v-chip color="green lighten-5" x-small class="elevation-0 pa-2 float-right"></v-chip>
                    </p>
                  </v-col>
                </v-row>
                <div class="py-3 overflow-y-auto overflow-x-hidden" style="height: 336px !important">
                  <div v-for="(s, m) in [cor_addr, per_addr, per_details]" :key="m">
                    <div v-if="s">
                      <div v-for="(n, l) in s" :key="l">
                        <p class="grey--text mb-0 caption">
                          {{ l ? l : "-" }} <span v-if="n[4] != null" :class="n[3] ? 'black--text' : 'primary--text'" class="font-weight-medium">{{ n[3] ? "" : ` ${n[4] == 0 ? " >>> Accept new" : " <<< Accept KRA"} change` }}</span>
                        </p>
                        <v-row no-glutters class="mb-0">
                          <v-col cols="6" class="pr-1">
                            <v-card @click="(n[4] = 1), setKRAfiledchanges(l, 1, n, m)" class="elevation-0 pa-1" :disabled="n[3] || (n[4] != null && n[4] != 0)" :color="!n[3] ? (n[4] == null ? 'red lighten-5' : n[4] == 1 ? 'green lighten-5' : 'red lighten-5') : 'none'">
                              <p class="black--text font-weight-bold subtitle-2 mb-0" :style="`height: ${n[4] == 1 ? '42px' : '22px'} !important`">{{ n ? n[1] : "-" }}</p>
                              <p v-if="!n[3] && n[4] != 1" class="black--text font-weight-regular caption text-right mb-0">Accept KRA changes</p>
                            </v-card>
                          </v-col>
                          <v-col cols="6" class="pl-1">
                            <v-card @click="(n[4] = 0), setKRAfiledchanges(l, 0, n, m)" class="elevation-0 pa-1" :disabled="n[3] || (n[4] != null && n[4] != 1)" :color="!n[3] ? (n[4] == null ? 'blue lighten-5' : n[4] == 0 ? 'green lighten-5' : 'blue lighten-5') : 'none'">
                              <p class="black--text font-weight-bold subtitle-2 mb-0" :style="`height: ${!n[3] && n[4] == 0 ? '42px' : '22px'} !important`">{{ n ? n[0] : "-" }}</p>
                              <p v-if="!n[3] && n[4] != 0" class="black--text font-weight-regular caption text-right mb-0">Accept new changes</p>
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-divider class="mb-2"></v-divider>
                      </div>
                    </div>
                  </div>
                </div>
                <v-toolbar class="pt-1" flat>
                  <span class="caption font-weight-regular"
                    >KRA Provider: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_kra ? btmdata.reskra.kra_status.app_kra : "-" }} | {{ btmdata ? (btmdata.mode ? "Modify" : "New") : "" }}</b> <br />
                    KRA status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_status_message ? btmdata.reskra.kra_status.app_status_message : "-" }}</b> <br />
                    KRA Update Status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_update_status_message ? btmdata.reskra.kra_status.app_update_status_message : "-" }}</b></span
                  >
                  <v-spacer></v-spacer>
                  <v-btn @click="setKRApushedit()" :disabled="btmdata.valid && btmdata.valid.length != 0" class="text-none elevation-0 rounded-lg white--text" :loading="delbtn" color="blue"> Push to KRA </v-btn>
                </v-toolbar>
              </v-stepper-content>

              <v-stepper-content step="2">
                <div class="overflow-y-auto overflow-x-hidden" style="height: 346px !important" v-if="btmdata.reskra && btmdata.reskra.kra_status">
                  <div v-for="(n, l) in btmdata.reskra.kra_status" :key="l">
                    <p class="grey--text mb-0">{{ l ? l : "-" }}</p>
                    <p class="black--text font-weight-bold">{{ n ? n : "-" }}</p>
                  </div>
                </div>
                <v-toolbar class="pt-1 px-0" dense flat>
                  <span class="caption font-weight-regular"
                    >KRA Provider: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_kra ? btmdata.reskra.kra_status.app_kra : "-" }} | {{ btmdata ? (btmdata.mode ? "Modify" : "New") : "" }}</b> <br />
                    KRA status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_status_message ? btmdata.reskra.kra_status.app_status_message : "-" }}</b> <br />
                    KRA Update Status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_update_status_message ? btmdata.reskra.kra_status.app_update_status_message : "-" }}</b></span
                  >
                  <v-spacer></v-spacer>
                  <v-btn @click="setUPloadKra()" class="text-none elevation-0 rounded-lg white--text" :loading="delbtn" color="blue"> Upload KRA </v-btn>
                </v-toolbar>
              </v-stepper-content>

              <v-stepper-content step="3">
                <div class="overflow-y-auto overflow-x-hidden" style="height: 346px !important" v-if="btmdata.reskra && btmdata.reskra.kra_status">
                  <div v-for="(n, l) in btmdata.reskra.kra_status" :key="l">
                    <p class="grey--text mb-0">{{ l ? l : "-" }}</p>
                    <p class="black--text font-weight-bold">{{ n ? n : "-" }}</p>
                  </div>
                </div>
                <v-toolbar class="pt-1" dense flat height="78px" style="height: 68px !important;">
                  <span class="caption font-weight-regular"
                    >KRA Provider: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_kra ? btmdata.reskra.kra_status.app_kra : "-" }} | {{ btmdata ? (btmdata.mode ? "Modify" : "New") : "" }}</b> <br />
                    KRA status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_status_message ? btmdata.reskra.kra_status.app_status_message : "-" }}</b> <br />
                    KRA Update Status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_update_status_message ? btmdata.reskra.kra_status.app_update_status_message : "-" }}</b></span
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
          <!-- {{ krastatdata.kra }} {{ kraDocumentUploaded }} -->
          <v-btn v-if="krastatdata.kra == '1' && krastatdata.kraDocumentUploaded == '1'" elevation="0" color="primary" class="text-none ml-7 mb-5" @click="dialogkraconf = true" dense >RE-initiate KRA</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-overlay :value="bottomload" class="rounded-0">
      <div class="text-center">
        <v-progress-circular :size="60" :width="4" color="#0037B7" indeterminate></v-progress-circular>
        <p v-if="kraform" class="font-weight-bold fs-18 white--text mt-2">fetching your KRA...</p>
      </div>
    </v-overlay>

 <v-bottom-sheet class="btmsheetclass" v-model="btmsheetnew"  persistent>
      <v-sheet class="" height="100vh" style="overflow: scroll;">
        <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar" timeout="5000" :value="true" :color="snackbarclr" absolute outlined top right>
          <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
          {{ snackmsgbar }}
          <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
        </v-snackbar>
        <v-toolbar dense flat>
          <img src="@/assets/Zebu Logo.svg" width="90px" />

          <v-spacer></v-spacer>

      
          <v-btn icon @click="btmsheetnew = false , closetabnew()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar> 
        <v-divider></v-divider>

<v-card
  class="pa-3 ma-3 rounded-xl"
 elevation="0"

 outlined

>
  <div class="d-flex justify-space-between align-center">

    <!-- Left Section (4 columns) -->
    <div class="d-flex" style="width: 85%; justify-content: space-between;">
      
      <div>
        <div class="font-weight-bold mb-1">Client ID</div>
        <div>{{ datanew.client_id }}</div>
      </div>

      <div>
        <div class="font-weight-bold mb-1">Name</div>
        <div>{{ datanew.client_name }}</div>
      </div>

      <div>
        <div class="font-weight-bold mb-1">PAN</div>
        <div>{{ datanew.client_pan }}</div>
      </div>

      <div>
        <div class="font-weight-bold mb-1">Mobile</div>
        <div>{{ datanew.mobile_no }}</div>
      </div>

       <div>
        <div class="font-weight-bold mb-1">Score</div>
        <div>{{ datanew.overall_score }}</div>
      </div>
    </div>
  </div>
</v-card>
      <!-- <v-divider class="my-4"></v-divider> -->
       <v-card elevation="0 pa-4">

       <p class="font-weight-bold title mb-6">
      <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
      10-Point Validation Checklist - Overall Score: {{ datanew.overall_score }}/100
       </p>

    <!-- Grid Layout -->
     <v-row>
      <v-col cols="4">
  <v-card height="70vh" elevation="0" style="overflow: scroll;">
<v-row  v-if="datanew && datanew.validation_response">
  <v-col 
    v-for="(item, i) in filteredValidation"
    :key="i"
    cols="12"
 lg="12"
    class="mb-4"
    
  >
    <v-card    :style="
    selectedIndex === i
      ? 'border:0px solid #2962FF !important; background:#E3F2FD !important;'
      : 'border:1px solid #E0E0E0; background:#FFFFFF;'
  " @click="openValidationDialog(item),selectedIndex = i" class="pa-4 rounded-lg elevation-0" outlined>

      <!-- Number + Status Badge -->
      <div class="d-flex justify-space-between align-center mb-3">
        <div class="number-circle"> <span class="font-weight-bold text-subtitle-1 mb-2">{{ item.check_name }}</span></div>

        <v-chip
          :color="statusColor(item.status)"
          dark
          small
          class="font-weight-bold"
        >
          <v-icon left small>{{ statusIcon(item.status) }}</v-icon>
          {{ item.status }}
        </v-chip>
      </div>

      <!-- Title -->
      <!-- <h3 class="font-weight-bold text-subtitle-1 mb-2">
        {{ item.check_name }}
      </h3> -->

      <!-- Message -->
      <div v-if="item.message" v-html="formatMessage(item.message)"></div>

      <!-- <div v-if="item.check_name == 'Email, Mobile & PAN Existence'  ">
<p class="mt-2 mb-1"><v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">Email Verified:</span> <span class="ml-2 font-weight-semibold black--text">{{ datanew.request_data.emailVerify }}</span></p>
<p class=" mb-1"> <v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">Mobile Verified: </span> <span class="ml-2 font-weight-semibold black--text">{{ datanew.request_data.mobileVerify }}</span></p>
<p class="mb-1"><v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">PAN  Verified:</span> <span class="ml-2 font-weight-semibold black--text">{{ datanew.request_data.panVerify }}</span></p>

      </div> -->

            <!-- <div v-if="item.check_name == 'PAN Name Validation'  ">
<p class="mt-2 mb-1"><v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">Form PAN:</span> <span class="ml-2 font-weight-semibold black--text">{{ datanew.request_data.client_pan }}</span></p>
<p class=" mb-1"> <v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">Extracted PAN: </span> <span class="ml-2 font-weight-semibold black--text">{{ item.details.pan_data.llmpanNo }}</span></p>
<p class="mb-1"><v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">Form Name: </span> <span class="ml-2 font-weight-semibold black--text">{{ datanew.request_data.client_name }}</span></p>
<p class="mt-2 mb-1"><v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">Extracted  Name:</span> <span class="ml-2 font-weight-semibold black--text">{{ item.details.pan_data.llmpanname }}</span></p>
<p class=" mb-1"> <v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">Form DOB:  </span> <span class="ml-2 font-weight-semibold black--text">{{ datanew.request_data.DOB }}</span></p>
<p class="mb-1"><v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">Extracted DOB: </span> <span class="ml-2 font-weight-semibold black--text">{{ item.details.pan_data.llmdob }}</span></p>

      </div> -->

      <!-- <div v-if="item.check_name == 'DOB Validation'  ">
<p class=" mb-1"> <v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">Form DOB:  </span> <span class="ml-2 font-weight-semibold black--text">{{ datanew.request_data.DOB }}</span></p>
<p class=" mb-1"> <v-icon>mdi-circle-small</v-icon> <span class="grey--text subtitle-1">Extracted PAN: </span> <span class="ml-2 font-weight-semibold black--text">{{ item.details.pan_data.llmpanNo }}</span></p>

      </div> -->

      <!-- DETAILS -->
      <!-- <div v-if="item.details" class="mt-3 details-list">
        <ul>
          <li v-for="(val, key) in parseDetails(item.details)" :key="key">
            <strong>{{ key }}:</strong> {{ val }}
          </li>
        </ul>
      </div> -->

    </v-card>
  </v-col>
</v-row>
</v-card>
</v-col>
<v-col cols="8">

<div v-if="selectedIndex == 0">
  <v-simple-table
    fixed-header
    style="border:1px solid #E0E0E0"
    width="300px"
  >
    <template v-slot:default>
      <tbody>

        <tr>
          <td style="font-weight:600 !important; font-size:13px !important;">
            Client Mobile Number
          </td>
          <td style="font-weight:700 !important; font-size:15px !important;">
            {{ datanew?.mobile_no }}
          </td>
        </tr>

        <tr>
          <td style="font-weight:600 !important; font-size:13px !important;">
            Client Email Id
          </td>
          <td style="font-weight:700 !important; font-size:15px !important;">
            {{ datanew?.request_data?.client_email }}
          </td>
        </tr>

        <tr>
          <td style="font-weight:600 !important; font-size:13px !important;">
            Client Pan
          </td>
          <td style="font-weight:700 !important; font-size:15px !important;">
            {{ datanew?.client_pan }}
          </td>
        </tr>

      </tbody>
    </template>
  </v-simple-table>
</div>




<div v-if="selectedIndex == 1">

  <v-simple-table v-if="datanew?.request_data" style="border:1px solid #E0E0E0 !important;">
    <thead>
      <tr>
        <th style="font-weight:700 !important; font-size:14px !important;">Field</th>
        <th style="font-weight:700 !important; font-size:14px !important;">Original Input</th>
        <th style="font-weight:700 !important; font-size:14px !important;">LLM Extracted</th>
        <th style="font-weight:700 !important; font-size:14px !important;">Status</th>
      </tr>
    </thead>

    <tbody>

      <!-- PAN Number -->
      <tr>
        <td style="font-weight:600 !important; font-size:13px !important;">
          PAN Number
        </td>

        <td style="font-weight:700 !important; font-size:15px !important;">
          {{ datanew?.request_data?.client_pan }}
        </td>

        <td style="font-weight:700 !important; font-size:15px !important;">
          {{ datanew?.validation_response?.validations[1]?.details?.pan_data?.llmpanNo }}
        </td>

        <td
          v-if="datanew.request_data.client_pan === datanew?.validation_response?.validations[1]?.details?.pan_data?.llmpanNo"
          style="font-weight:700 !important; font-size:14px !important; color:green !important;">
          MATCH
        </td>

        <td
          v-else
          style="font-weight:700 !important; font-size:14px !important; color:red !important;">
          NOT MATCH
        </td>
      </tr>

      <!-- PAN Name -->
      <tr>
        <td style="font-weight:600 !important; font-size:13px !important;">
          PAN Name
        </td>

        <td style="font-weight:700 !important; font-size:15px !important;">
          {{ datanew?.request_data?.client_name }}
        </td>

        <td style="font-weight:700 !important; font-size:15px !important;">
          {{ datanew?.validation_response?.validations[1]?.details?.pan_data?.llmpanname }}
        </td>

       <td
  v-if="
    datanew?.request_data?.client_name?.trim()?.toUpperCase() ==
    datanew?.validation_response?.validations[1]?.details?.pan_data?.llmpanname?.trim()?.toUpperCase()
  "
  style="font-weight:700 !important; font-size:14px !important; color:green !important;"
>
  MATCH
</td>

<td
  v-else
  style="font-weight:700 !important; font-size:14px !important; color:red !important;"
>
  NOT MATCH
</td>

      </tr>

      <!-- DOB -->
      <tr>
        <td style="font-weight:600 !important; font-size:13px !important;">
          DOB
        </td>

        <td style="font-weight:700 !important; font-size:15px !important;">
          {{ datanew?.request_data?.DOB }}
        </td>

        <td style="font-weight:700 !important; font-size:15px !important;">
          {{ datanew?.validation_response?.validations[1]?.details?.pan_data?.llmdob }}
        </td>
<td
  v-if="normalizeDate(datanew.request_data.DOB) === normalizeDate(datanew?.validation_response?.validations[1]?.details?.pan_data?.llmdob)"
  style="font-weight:700 !important; font-size:14px !important; color:green !important;"
>
  MATCH
</td>

<td
  v-else
  style="font-weight:700 !important; font-size:14px !important; color:red !important;"
>
  NOT MATCH
</td>

      </tr>

    </tbody>
  </v-simple-table>

  <iframe
    class="mt-5"
    :src="'https://ekycbe.mynt.in/file?path=' + datanew?.request_data?.uploadPAN"
    width="100%"
    style="border:none !important; height:50vh !important;">
  </iframe>

</div>



   <!-- <div v-if="selectedIndex == 2">
     <v-simple-table
    fixed-header
    style="border:1px solid #E0E0E0"
    width="300px"
  >
    <template v-slot:default>
  
      <tbody>
        <tr
        
        >
                <td>Client DOB</td>
       <td>{{ datanew?.request_data?.DOB }}</td>

        </tr>
        <tr>
             <td>LLM Verfiy DOB</td>
                <td>{{ datanew?.validation_response?.validations[2].message }}</td>
   
        </tr>
       
      </tbody>
    </template>
  </v-simple-table>
  </div> -->

  <div v-if="selectedIndex == 2">
  <v-simple-table fixed-header style="border:1px solid #E0E0E0" width="300px">
    <template v-slot:default>
      <tbody>
        <tr>
          <td style="font-weight:600 !important; font-size:13px !important;">Client Gender</td>
          <td style="font-weight:700 !important; font-size:15px !important;">{{ datanew?.request_data?.adhar_gender }}</td>
        </tr>

        <tr>
          <td style="font-weight:600 !important; font-size:13px !important;">LLM Verify Gender</td>
          <td style="font-weight:700 !important; font-size:15px !important;">{{ datanew?.validation_response?.validations[3].message }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>

  <iframe class="mt-5"
    :src="'https://ekycbe.mynt.in/file?path=' + datanew?.request_data?.clientimage"
    width="100%"
    style="border:none !important; height:50vh !important;">
  </iframe>
</div>


   <div v-if="selectedIndex == 3">
<v-simple-table fixed-header height="300px" style="border:1px solid #E0E0E0">
  <template v-slot:default>

    <thead>
      <tr>
        <th class="text-left">Field</th>
        <th class="text-left">Original Input</th>
        <th class="text-left">LLM Extracted</th>
        <th class="text-left">Match Status</th>
      </tr>
    </thead>

    <tbody>

      <!-- Aadhar Number -->
      <tr>
        <td style="font-weight:600 !important;">Aadhar Number</td>
        <td style="font-weight:700 !important;">{{ datanew.request_data.aadharNumber }}</td>
        <td style="font-weight:700 !important;">{{ datanew.request_data.aadharNumber }}</td>

        <td
          :style="{
            fontWeight: '700 !important',
            fontSize: '14px !important',
            color:
              (datanew.request_data?.aadharNumber?.trim().toUpperCase() ===  datanew.request_data?.aadharNumber?.trim().toUpperCase())
                ? 'green !important'
                : 'red !important'
          }"
        >
          {{
            (datanew.request_data?.aadharNumber?.trim().toUpperCase() === datanew.request_data?.aadharNumber?.trim().toUpperCase())
              ? 'MATCH'
              : 'NOT MATCH'
          }}
        </td>
      </tr>

      <!-- Address -->
      <tr>
        <td style="font-weight:600 !important;">Address</td>
        <td style="font-weight:700 !important;">{{ datanew.request_data.aadhar_address }}</td>
        <td style="font-weight:700 !important;">{{ selectedValidation.details.llmaddress }}</td>

        <td
          :style="{
            fontWeight: '700 !important',
            fontSize: '14px !important',
            color:
              (datanew.request_data?.aadhar_address?.trim().toUpperCase() ===
              selectedValidation?.details?.llmaddress?.trim().toUpperCase())
                ? 'green !important'
                : 'red !important'
          }"
        >
          {{
            (datanew.request_data?.aadhar_address?.trim().toUpperCase() ===
            selectedValidation?.details?.llmaddress?.trim().toUpperCase())
              ? 'MATCH'
              : 'NOT MATCH'
          }}
        </td>
      </tr>

      <!-- Father's Name -->
      <tr>
        <td style="font-weight:600 !important;">Father's Name</td>
        <td style="font-weight:700 !important;">{{ datanew.request_data.adhar_fathername }}</td>
        <td style="font-weight:700 !important;">{{ selectedValidation.details.llmfathername }}</td>

        <td
          :style="{
            fontWeight: '700 !important',
            fontSize: '14px !important',
            color:
              (datanew.request_data?.adhar_fathername?.trim().toUpperCase() ===
              selectedValidation?.details?.llmfathername?.trim().toUpperCase())
                ? 'green !important'
                : 'red !important'
          }"
        >
          {{
            (datanew.request_data?.adhar_fathername?.trim().toUpperCase() ===
            selectedValidation?.details?.llmfathername?.trim().toUpperCase())
              ? 'MATCH'
              : 'NOT MATCH'
          }}
        </td>
      </tr>

      <!-- Gender -->
      <tr>
        <td style="font-weight:600 !important;">Gender</td>
        <td style="font-weight:700 !important;">
          {{ datanew.request_data.adhar_gender ? datanew.request_data.adhar_gender : datanew.request_data.kra_gender }}
        </td>
        <td style="font-weight:700 !important;">{{ selectedValidation.details.llmgender }}</td>

        <td
          :style="{
            fontWeight: '700 !important',
            fontSize: '14px !important',
            color:
              (
                (datanew.request_data.adhar_gender
                  ? datanew.request_data.adhar_gender
                  : datanew.request_data.kra_gender)?.trim().toUpperCase()
                === selectedValidation?.details?.llmgender?.trim().toUpperCase()
              )
                ? 'green !important'
                : 'red !important'
          }"
        >
          {{
            (
              (datanew.request_data.adhar_gender
                ? datanew.request_data.adhar_gender
                : datanew.request_data.kra_gender)?.trim().toUpperCase()
              === selectedValidation?.details?.llmgender?.trim().toUpperCase()
            )
              ? 'MATCH'
              : 'NOT MATCH'
          }}
        </td>
      </tr>

    </tbody>

  </template>
</v-simple-table>




  <iframe class="mt-5"
    :src="'https://ekycbe.mynt.in/file?path=' + datanew?.request_data?.adharimg"
    width="100%"
    style="border:none !important; height:50vh !important;">
  </iframe>
</div>


<div v-if="selectedIndex == 4">
  <v-simple-table fixed-header style="border:1px solid #E0E0E0" width="300px">
    <template v-slot:default>
      <tbody>
        <tr>
          <td style="font-weight:600 !important;">Client Father Name</td>
          <td style="font-weight:700 !important;">{{ datanew?.request_data?.fathername }}</td>
        </tr>

        <tr>
          <td style="font-weight:600 !important;">LLM Verify Father Name</td>
          <td style="font-weight:700 !important;">{{ datanew?.validation_response?.validations[5].message }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</div>


 <div v-if="selectedIndex == 5">
 <v-simple-table style="border:1px solid #E0E0E0">
  <thead>
    <tr>
      <th>Field</th>
      <th>Original Input</th>
      <th>LLM Extracted</th>
      <th>Status</th>
    </tr>
  </thead>

  <tbody>

    <!-- Account Holder Name -->
    <tr>
      <td style="font-weight:600 !important;">Account Holder Name</td>
      <td style="font-weight:700 !important;">{{ datanew?.request_data?.client_name }}</td>
      <td style="font-weight:700 !important;">
        {{ datanew?.validation_response?.validations[6]?.details?.penny_drop?.name }}
      </td>

      <td
        :style="{
          fontWeight: '700 !important',
          fontSize: '14px !important',
          color:
            (datanew?.request_data?.client_name?.trim()?.toLowerCase() ==
            datanew?.validation_response?.validations[6]?.details?.penny_drop?.name?.trim()?.toLowerCase())
              ? 'green !important'
              : 'red !important'
        }"
      >
        {{
          (datanew?.request_data?.client_name?.trim()?.toLowerCase() ==
          datanew?.validation_response?.validations[6]?.details?.penny_drop?.name?.trim()?.toLowerCase())
            ? 'MATCH'
            : 'NOT MATCH'
        }}
      </td>
    </tr>

    <!-- Account Number -->
    <tr>
      <td style="font-weight:600 !important;">Account Number</td>
      <td style="font-weight:700 !important;">{{ datanew?.request_data?.BankAccountNumber }}</td>
      <td style="font-weight:700 !important;">
        {{ datanew?.validation_response?.validations[6]?.details?.penny_drop?.account_number }}
      </td>

      <td
        :style="{
          fontWeight: '700 !important',
          fontSize: '14px !important',
          color:
            (datanew?.request_data?.BankAccountNumber?.trim()?.toLowerCase() ==
            datanew?.validation_response?.validations[6]?.details?.penny_drop?.account_number?.trim()?.toLowerCase())
              ? 'green !important'
              : 'red !important'
        }"
      >
        {{
          (datanew?.request_data?.BankAccountNumber?.trim()?.toLowerCase() ==
          datanew?.validation_response?.validations[6]?.details?.penny_drop?.account_number?.trim()?.toLowerCase())
            ? 'MATCH'
            : 'NOT MATCH'
        }}
      </td>
    </tr>

    <!-- IFSC -->
    <tr>
      <td style="font-weight:600 !important;">IFSC</td>
      <td style="font-weight:700 !important;">{{ datanew?.request_data?.IFSC }}</td>
      <td style="font-weight:700 !important;">
        {{ datanew?.validation_response?.validations[6]?.details?.penny_drop?.ifsc_code }}
      </td>

      <td
        :style="{
          fontWeight: '700 !important',
          fontSize: '14px !important',
          color:
            (datanew?.request_data?.IFSC?.trim()?.toLowerCase() ==
            datanew?.validation_response?.validations[6]?.details?.penny_drop?.ifsc_code?.trim()?.toLowerCase())
              ? 'green !important'
              : 'red !important'
        }"
      >
        {{
          (datanew?.request_data?.IFSC?.trim()?.toLowerCase() ==
          datanew?.validation_response?.validations[6]?.details?.penny_drop?.ifsc_code?.trim()?.toLowerCase())
            ? 'MATCH'
            : 'NOT MATCH'
        }}
      </td>
    </tr>

  </tbody>
</v-simple-table>


  <iframe class="mt-5" v-if="datanew?.request_data?.segment != 'Cash'"
    :src="'https://ekycbe.mynt.in/file?path=' + datanew?.request_data?.uploadFinancialproof"
    width="100%"
    style="border:none !important; height:50vh !important;">
  </iframe>
</div>


  <div v-if="selectedIndex == 6">
  <v-simple-table fixed-header style="border:1px solid #E0E0E0" width="300px">
    <template v-slot:default>
      <tbody>
        <tr>
          <td style="font-weight:600 !important;">Client choose segment</td>
          <td style="font-weight:700 !important;">{{ datanew?.request_data?.segment }}</td>
        </tr>

        <tr>
          <td style="font-weight:600 !important;">Client Income Type</td>
          <td style="font-weight:700 !important;">{{ datanew?.request_data?.incometype }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</div>


<div v-if="selectedIndex == 7">
  <v-simple-table fixed-header style="border:1px solid #E0E0E0" width="300px">
    <template v-slot:default>
      <tbody>
        <tr>
          <td style="font-weight:600 !important;">LLM Verify Nominee</td>
          <td style="font-weight:700 !important;">{{ datanew?.validation_response?.validations[8].message }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>

  <v-simple-table style="border:1px solid #E0E0E0">
    <template v-slot:default>
      <tbody>
        <tr v-for="(value, key) in datanew?.validation_response?.validations[8]?.details" :key="key">
          <td style="font-weight:600 !important;">{{ key }}</td>
          <td style="font-weight:700 !important;">{{ value }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</div>



<div v-if="selectedIndex == 8">
  <v-simple-table fixed-header style="border:1px solid #E0E0E0" width="300px">
    <template v-slot:default>
      <tbody>
        <tr>
          <td style="font-weight:600 !important;">LLM Verify Signature</td>
          <td style="font-weight:700 !important;">{{ datanew?.validation_response?.validations[9].message }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>

  <iframe class="mt-5"
    :src="'https://ekycbe.mynt.in/file?path=' + datanew?.request_data?.uploadSignature"
    width="100%"
    style="border:none !important; height:50vh !important;">
  </iframe>
</div>


</v-col>
</v-row>
</v-card>

<v-dialog v-model="autostageverify1" width="80%">
  <v-card class="pa-4">
  <h3 class="font-weight-bold text-h6 mb-4">
      {{ selectedValidation?.check_name }}
    </h3>

        <div v-if="selectedValidation?.message"
         v-html="formatMessage(selectedValidation.message)"
         class="mb-4">
    </div>
    <div v-if="selectedValidation?.check_name == 'PAN Name Validation'">

      <div v-if="selectedValidation?.details">
      <!-- <h4 class="font-weight-medium mb-2">Details</h4> -->

      <v-simple-table
    fixed-header
    height="300px"
  >
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            
          </th>
          <th class="text-left">
            Original Input
          </th>
           <th class="text-left">
            LLM Extracted
          </th>
           <th class="text-left">
            Match Status
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>PAN Number</td>
          <td>{{ datanew.request_data.client_pan }}</td>
          <td>{{ selectedValidation.details.pan_data.llmpanNo }}</td>
 <td>
    {{ (datanew.request_data?.client_pan?.trim().toUpperCase() === selectedValidation?.details?.pan_data?.llmpanNo?.trim().toUpperCase()) ? 'Matched' : 'Not Matched' }}
  </td>
        </tr>
         <tr>
          <td>Name Of Pan </td>

          <td>{{ datanew.request_data.client_name }} </td>
          <td>{{ selectedValidation.details.pan_data.llmpanname }} </td>
 <td>
    {{ (datanew.request_data?.client_name?.trim().toUpperCase() === selectedValidation?.details?.pan_data?.llmpanname?.trim().toUpperCase()) ? 'Matched' : 'Not Matched' }}
  </td>
        </tr>
         <tr>
           <td>DOB</td>

           <td>{{ datanew.request_data.DOB }}</td>

           <td>{{ selectedValidation.details.pan_data.llmdob }}</td>
            <td>
    {{ (datanew.request_data?.DOB?.replace(/-/g,'/') === selectedValidation?.details?.pan_data?.llmdob?.replace(/-/g,'/')) ? 'Matched' : 'Not Matched' }}
  </td>
        </tr>

          <tr>

</tr>

      </tbody>
    </template>
  </v-simple-table>
    </div>

    </div>

        <div v-if="selectedValidation?.check_name == 'Personal Details Validation (Aadhar)'">

      <div v-if="selectedValidation?.details">
      <!-- <h4 class="font-weight-medium mb-2">Details</h4> -->

      <v-simple-table
    fixed-header
    height="300px"
  >
    <template v-slot:default>
<thead>
  <tr>
    <th class="text-left"></th>
    <th class="text-left">Original Input</th>
    <th class="text-left">LLM Extracted</th>
    <th class="text-left">Match Status</th>
  </tr>
</thead>

<tbody>

  <!-- Aadhar Number -->
  <tr>
    <td>Aadhar Number</td>
    <td>{{ datanew.request_data.aadharNumber }}</td>
    <td>Masked for security</td>
    <td>
      {{ (datanew.request_data?.aadharNumber?.trim().toUpperCase() === 'MASKED FOR SECURITY')
          ? 'Matched' 
          : 'Not Matched' 
      }}
    </td>
  </tr>

  <!-- Address -->
  <tr>
    <td>Address</td>
    <td>{{ datanew.request_data.aadhar_address }}</td>
    <td>{{ selectedValidation.details.llmaddress }}</td>
    <td>
      {{ (datanew.request_data?.aadhar_address?.trim().toUpperCase() ===
          selectedValidation?.details?.llmaddress?.trim().toUpperCase())
          ? 'Matched'
          : 'Not Matched'
      }}
    </td>
  </tr>

  <!-- Father's Name -->
  <tr>
    <td>Father's Name</td>
    <td>{{ datanew.request_data.adhar_fathername }}</td>
    <td>{{ selectedValidation.details.llmfathername }}</td>
    <td>
      {{ (datanew.request_data?.adhar_fathername?.trim().toUpperCase() ===
          selectedValidation?.details?.llmfathername?.trim().toUpperCase())
          ? 'Matched'
          : 'Not Matched'
      }}
    </td>
  </tr>

  <!-- Gender -->
  <tr>
    <td>Gender</td>
    <td>{{ datanew.request_data.adhar_gender ? datanew.request_data.adhar_gender : datanew.request_data.kra_gender }}</td>
    <td>{{ selectedValidation.details.llmgender }}</td>
    <td>
      {{ ((datanew.request_data.adhar_gender ? datanew.request_data.adhar_gender : datanew.request_data.kra_gender)?.trim().toUpperCase() ===
          selectedValidation?.details?.llmgender?.trim().toUpperCase())
          ? 'Matched'
          : 'Not Matched'
      }}
    </td>
  </tr>

  <!-- DOB -->


</tbody>

    </template>
  </v-simple-table>
    </div>





    </div>


          <div v-if="selectedValidation?.check_name == 'Bank Details Validation'">

  <div v-if="selectedValidation?.details">

    <v-simple-table fixed-header height="300px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"></th>
            <th class="text-left">Original Input</th>
            <th class="text-left">LLM Extracted</th>
            <th class="text-left">Match Status</th>
          </tr>
        </thead>

        <tbody>

          <!-- Account Holder Name -->
          <tr>
            <td>Account Holder Name</td>
            <td>{{ datanew.request_data.client_name }}</td>
            <td>{{ selectedValidation.details.penny_drop.llmbankusername }}</td>
            <td>
              {{
                (datanew.request_data?.client_name?.trim().toUpperCase() ===
                 selectedValidation?.details?.penny_drop.llmbankusername?.trim().toUpperCase())
                ? 'Matched' : 'Not Matched'
              }}
            </td>
          </tr>
       <!-- Account Number -->
          <tr>
            <td>Account Number</td>
            <td>{{ datanew.request_data.BankAccountNumber }}</td>
            <td>{{ selectedValidation.details.penny_drop.account_number }}</td>
            <td>
              {{
                (datanew.request_data?.BankAccountNumber?.trim().toUpperCase() ===
                 selectedValidation?.details?.penny_drop.account_number?.trim().toUpperCase())
                ? 'Matched' : 'Not Matched'
              }}
            </td>
          </tr>

          <!-- IFSC Code -->
          <tr>
            <td>IFSC Code</td>
            <td>{{ datanew.request_data.IFSC }}</td>
            <td>{{ selectedValidation.details.penny_drop.ifsc_code }}</td>
            <td>
              {{
                (datanew.request_data?.IFSC?.trim().toUpperCase() ===
                 selectedValidation?.details?.penny_drop.ifsc_code?.trim().toUpperCase())
                ? 'Matched' : 'Not Matched'
              }}
            </td>
          </tr>
   

        </tbody>

      </template>
    </v-simple-table>
  </div>

</div>

          <div v-if="selectedValidation?.check_name == 'Data & Proof Verification (Signature)'">

  <div >

    <v-simple-table fixed-header height="300px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"></th>
            <th class="text-left">Original Input</th>
            <th class="text-left">LLM Extracted</th>
            <th class="text-left">Match Status</th>
          </tr>
        </thead>

        <tbody>

          <!-- Account Holder Name -->
          <tr>
            <td>Signature Detected</td>
            <td>{{ datanew.request_data?.hyv_sig_res?.details?.Wet_Signature_Signature_Detection_Status }}</td>
            <td>{{ datanew.request_data?.hyv_sig_res?.details?.Wet_Signature_Signature_Detection_Status == 'success' ? 'Pass' : datanew.request_data?.hyv_sig_res?.details?.Wet_Signature_Signature_Detection_Status }}</td>
            <td>
             ---
            </td>
          </tr>
       <!-- Account Number -->
          <tr>
            <td>Selfie Gender (Form)</td>
            <td>{{ datanew.request_data.adhar_gender ? datanew.request_data.adhar_gender : datanew.request_data.kra_gender  }}</td>
    <td>{{ datanew.request_data.adhar_gender ? datanew.request_data.adhar_gender : datanew.request_data.kra_gender }}</td>
    <td>
      {{ ((datanew.request_data.adhar_gender ? datanew.request_data.adhar_gender : datanew.request_data.kra_gender)?.trim().toUpperCase() ===
          (datanew.request_data.adhar_gender ? datanew.request_data.adhar_gender : datanew.request_data.kra_gender)?.trim().toUpperCase())
          ? 'Matched'
          : 'Not Matched'
      }}
    </td>
          </tr>

      
   

        </tbody>

      </template>
    </v-simple-table>
  </div>

</div>

   <v-tabs
      v-model="tab"
    >
      <v-tab>
       Pan verification
      </v-tab>
      <v-tab>
       Aadhar  verification
      </v-tab>
      <v-tab>
       Bank Statement verification
      </v-tab>
      <v-tab>
       Signature  verification
      </v-tab>
      <v-tab>
       Selfie  verification
      </v-tab>
    </v-tabs>




    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="rounded-lg black"
        dense
        class="elevation-0 text-none white--text"
        @click="autostageverify = false"
      >
        Close
      </v-btn>

    </v-card-actions>
</v-card>
</v-dialog>


<v-dialog v-model="autostageverify" persistent  width="90%">
  <v-card class="pa-4 rounded-lg">

    <!-- Title -->
     <div class="d-flex">
    <h3 class="font-weight-bold text-h6 ml-3 mb-4">
      Verification Details
    </h3>
    <div class="ml-auto">
<v-btn icon @click="autostageverify = false"><v-icon>mdi-close</v-icon></v-btn>
    </div>
</div>
    <v-divider></v-divider>

    <v-container fluid>
      <v-row>
        <!-- LEFT SIDE : FILE PREVIEW -->
        <v-col cols="5">
          <div class="pa-0" style="border:1px solid #ccc;border-radius:8px;">

                   
    <iframe v-if="tabnew == 4"
  :src="   datanew?.validation_response?.validations[4]?.details?.selfie_url
          "
  width="100%"
  height="500px"
  style="border:none;"
></iframe>
           
    <iframe v-else
  :src=" 'https://ekycbe.mynt.in/file?path=' + (tabnew == 0
        ? datanew?.request_data?.uploadPAN
        : tabnew == 1
          ? datanew?.request_data?.adharimg : tabnew == 3
          ? datanew?.request_data?.uploadSignature : '')"
  width="100%"
  height="500px"
  style="border:none;"
></iframe>


            <!-- <div v-else class="grey--text text-center">
              No preview available
            </div> -->
          </div>
        </v-col>

        <!-- RIGHT SIDE : DATA -->
        <v-col cols="7">

          <!-- Tabs -->
          <v-tabs v-model="tabnew" background-color="white" grow>
            <v-tab class="text-none"> PAN Verification </v-tab>
            <v-tab class="text-none"> Aadhar Verification </v-tab>
             <v-tab class="text-none"> Bank Verification </v-tab>
             <v-tab class="text-none"> Signature Verification </v-tab>
              <v-tab class="text-none"> Selfie Verification </v-tab>
          </v-tabs>

          <!-- TAB CONTENT -->
          <v-tabs-items v-model="tabnew">

            <!-- PAN TAB -->
            <v-tab-item>
              <v-simple-table v-if="datanew?.request_data" style="border:1px solid #E0E0E0">
                <thead>
                  <tr>
                    <th>Field</th><th>Original Input</th><th>LLM Extracted</th><th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>PAN Number</td>
                    <td>{{ datanew?.request_data?.client_pan }}</td>
                    <td>{{ datanew?.validation_response?.validations[2]?.details?.pan_data?.llmpanNo }}</td>
                    <td>
                      {{ datanew.request_data.client_pan === datanew?.validation_response?.validations[2]?.details?.pan_data?.llmpanNo
                          ? 'MATCH'
                          : 'NOT MATCH'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>PAN Name</td>
                    <td>{{ datanew?.request_data?.client_name }}</td>
                    <td>{{ datanew?.validation_response?.validations[2]?.details?.pan_data?.llmpanname }}</td>
                    <td>
                      {{
                        datanew.request_data.client_name === datanew?.validation_response?.validations[2]?.details?.pan_data?.llmpanname
                          ? 'MATCH'
                          : 'NOT MATCH'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>DOB</td>
                    <td>{{ datanew?.request_data?.DOB }}</td>
                    <td>{{ datanew?.validation_response?.validations[2].details?.pan_data?.llmdob }}</td>
                    <td>
                      {{
                        datanew.request_data.DOB === datanew?.validation_response?.validations[2]?.details?.pan_data?.llmdob
                          ? 'MATCH'
                          : 'NOT MATCH'
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>


            <v-tab-item>
              <v-simple-table style="border:1px solid #E0E0E0">
                <thead>
                  <tr>
                    <th>Field</th><th>Original Input</th><th>LLM Extracted</th><th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Aadhar Number</td>
                    <td>{{ datanew?.request_data?.aadharNumber }}</td>
                    <td>Masked for security</td>
                    <td>Not Compared</td>
                  </tr>

                  <tr>
                    <td>Address</td>
                    <td>{{ datanew?.request_data?.aadhar_address }}</td>
                    <td>{{ datanew?.validation_response?.validations[5].details?.llmaddress }}</td>
<td>
  {{
    datanew?.request_data?.aadhar_address === datanew?.validation_response?.validations[5]?.details?.llmaddress
      ? 'MATCH'
      : 'NOT MATCH'
  }}
</td>
                  </tr>

                  <tr>
                    <td>Father Name</td>
                    <td>{{ datanew?.request_data?.adhar_fathername }}</td>
                    <td>{{ datanew?.validation_response?.validations[5].details?.llmfathername }}</td>
<td>
  {{ (datanew?.request_data?.adhar_fathername == datanew?.validation_response?.validations[5]?.details?.llmfathername) ? 'match' : 'not match' }}
</td>
                  </tr>

                  <tr>
                    <td>Gender</td>
                    <td>{{ datanew?.request_data?.adhar_gender || datanew?.request_data?.kra_gender }}</td>
                    <td>{{ datanew?.validation_response?.validations[5].details?.llmgender }}</td>
<td>
  {{
    (
      (datanew?.request_data?.adhar_gender || datanew?.request_data?.kra_gender)
      == datanew?.validation_response?.validations[5]?.details?.llmgender
    )
    ? 'match'
    : 'not match'
  }}
</td>
                  </tr>

                </tbody>
              </v-simple-table>
            </v-tab-item>


              <v-tab-item>
              <v-simple-table style="border:1px solid #E0E0E0">
                <thead>
                  <tr>
                    <th>Field</th><th>Original Input</th><th>LLM Extracted</th><th>Status</th>
                  </tr>
                </thead>
          <tbody>
  <!-- Account Holder Name -->
  <tr>
    <td>Account Holder Name</td>

    <td>{{ datanew?.request_data?.client_name }}</td>

    <td>{{ datanew?.validation_response?.validations[7]?.details?.penny_drop?.name }}</td>

    <td>
      {{
        (
          datanew?.request_data?.client_name?.toString()?.trim()?.toLowerCase()
          ==
          datanew?.validation_response?.validations[7]?.details?.penny_drop?.name?.toString()?.trim()?.toLowerCase()
        )
        ? 'match'
        : 'not match'
      }}
    </td>
  </tr>

  <!-- Account Number -->
  <tr>
    <td>Account Number</td>

    <td>{{ datanew?.request_data?.BankAccountNumber }}</td>

    <td>{{ datanew?.validation_response?.validations[7]?.details?.penny_drop?.account_number }}</td>

    <td>
      {{
        (
          datanew?.request_data?.BankAccountNumber?.toString()?.trim()?.toLowerCase()
          ==
          datanew?.validation_response?.validations[7]?.details?.penny_drop?.account_number?.toString()?.trim()?.toLowerCase()
        )
        ? 'match'
        : 'not match'
      }}
    </td>
  </tr>

  <!-- IFSC -->
  <tr>
    <td>IFSC</td>

    <td>{{ datanew?.request_data?.IFSC }}</td>

    <td>{{ datanew?.validation_response?.validations[7]?.details?.penny_drop?.ifsc_code }}</td>

    <td>
      {{
        (
          datanew?.request_data?.IFSC?.toString()?.trim()?.toLowerCase()
          ==
          datanew?.validation_response?.validations[7]?.details?.penny_drop?.ifsc_code?.toString()?.trim()?.toLowerCase()
        )
        ? 'match'
        : 'not match'
      }}
    </td>
  </tr>
</tbody>

              </v-simple-table>
            </v-tab-item>

              <v-tab-item>
              <v-simple-table style="border:1px solid #E0E0E0">
                <thead>
                  <tr>
                    <th>Field</th><th>Value</th><th>LLM Extracted</th><th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Signature Detected</td>
                    <td>{{ datanew.request_data?.hyv_sig_res?.details?.Wet_Signature_Signature_Detection_Status }}</td>
                    <td>{{ datanew.request_data?.hyv_sig_res?.details?.Wet_Signature_Signature_Detection_Status }}</td>
                    <td>---</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>

               <v-tab-item>
              <v-simple-table style="border:1px solid #E0E0E0">
                <thead>
                  <tr>
                    <th>Field</th><th>Original</th><th>Extracted</th><th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Selfie Gender</td>
                    <td>{{ datanew?.request_data?.adhar_gender || datanew?.request_data?.kra_gender }}</td>
                    <td>{{ datanew?.request_data?.adhar_gender || datanew?.request_data?.kra_gender }}</td>
                   <td>
  {{
    (
      (datanew?.request_data?.adhar_gender || datanew?.request_data?.kra_gender)
        ?.toString()
        ?.trim()
        ?.toLowerCase()
      ==
      datanew?.validation_response?.validations[5]?.details?.llmgender
        ?.toString()
        ?.trim()
        ?.toLowerCase()
    )
    ? 'match'
    : 'not match'
  }}
</td>

                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>


            <!-- <v-tab-item>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Field</th><th>Original Input</th><th>LLM Extracted</th><th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Aadhar Number</td>
                    <td>{{ datanew.request_data.aadharNumber }}</td>
                    <td>Masked for security</td>
                    <td>Not Compared</td>
                  </tr>

                  <tr>
                    <td>Address</td>
                    <td>{{ datanew.request_data.aadhar_address }}</td>
                    <td>{{ selectedValidation.details?.llmaddress }}</td>
                    <td>{{ match(datanew.request_data.aadhar_address, selectedValidation.details?.llmaddress) }}</td>
                  </tr>

                  <tr>
                    <td>Father Name</td>
                    <td>{{ datanew.request_data.adhar_fathername }}</td>
                    <td>{{ selectedValidation.details?.llmfathername }}</td>
                    <td>{{ match(datanew.request_data.adhar_fathername, selectedValidation.details?.llmfathername) }}</td>
                  </tr>

                  <tr>
                    <td>Gender</td>
                    <td>{{ datanew.request_data.adhar_gender || datanew.request_data.kra_gender }}</td>
                    <td>{{ selectedValidation.details?.llmgender }}</td>
                    <td>{{ match(datanew.request_data.adhar_gender || datanew.request_data.kra_gender, selectedValidation.details?.llmgender) }}</td>
                  </tr>

                </tbody>
              </v-simple-table>
            </v-tab-item>


            <v-tab-item>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Field</th><th>Original Input</th><th>LLM Extracted</th><th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Account Holder Name</td>
                    <td>{{ datanew.request_data.client_name }}</td>
                    <td>{{ selectedValidation.details?.penny_drop?.llmbankusername }}</td>
                    <td>{{ match(datanew.request_data.client_name, selectedValidation.details?.penny_drop?.llmbankusername) }}</td>
                  </tr>

                  <tr>
                    <td>Account Number</td>
                    <td>{{ datanew.request_data.BankAccountNumber }}</td>
                    <td>{{ selectedValidation.details?.penny_drop?.account_number }}</td>
                    <td>{{ match(datanew.request_data.BankAccountNumber, selectedValidation.details?.penny_drop?.account_number) }}</td>
                  </tr>

                  <tr>
                    <td>IFSC</td>
                    <td>{{ datanew.request_data.IFSC }}</td>
                    <td>{{ selectedValidation.details?.penny_drop?.ifsc_code }}</td>
                    <td>{{ match(datanew.request_data.IFSC, selectedValidation.details?.penny_drop?.ifsc_code) }}</td>
                  </tr>

                </tbody>
              </v-simple-table>
            </v-tab-item>

            <v-tab-item>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Field</th><th>Value</th><th>LLM Extracted</th><th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Signature Detected</td>
                    <td>{{ datanew.request_data?.hyv_sig_res?.details?.Wet_Signature_Signature_Detection_Status }}</td>
                    <td>{{ datanew.request_data?.hyv_sig_res?.details?.Wet_Signature_Signature_Detection_Status }}</td>
                    <td>---</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>


            <v-tab-item>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Field</th><th>Original</th><th>Extracted</th><th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Selfie Gender</td>
                    <td>{{ datanew.request_data.adhar_gender || datanew.request_data.kra_gender }}</td>
                    <td>{{ datanew.request_data.adhar_gender || datanew.request_data.kra_gender }}</td>
                    <td>Matched</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item> -->

          </v-tabs-items>

        </v-col>
      </v-row>
    </v-container>

    <!-- <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="black" dark @click="autostageverify = false">Close</v-btn>
    </v-card-actions> -->

  </v-card>
</v-dialog>





        </v-sheet>
        </v-bottom-sheet>

    <template>
  <v-row>
    <v-dialog
      v-model="dialogkraconf"
      persistent
      max-width="300"
    >
  
      <v-card class="pa-4">
        <p class="title font-weight-semibold">
          Are you Want to Re-initiate the KRA Process
        </p>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="rounded-lg black"
            dense
            class="elevation-0 text-none white--text"
            @click="dialogkraconf = false"
          >
            No
          </v-btn>
          <v-btn
            color="primary"
            dense
            class="elevation-0 rounded-lg text-none white--text"
            :loading="krareverload"
            @click="revertkrastatus()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="passwordDialog" max-width="500">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Update Password</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="passwordUpdateLoading" icon @click="closePasswordDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="pa-4">
          <v-text-field
            v-model="passwordForm.username"
            :readonly="!passwordEditMode"
            label="Username"
            outlined
            dense
            class="mb-3"
            hide-details
          ></v-text-field>
          <v-text-field
            v-model="passwordForm.passworducc"
            :readonly="!passwordEditMode"
            label="Password UCC"
            outlined
            dense
            class="mb-3"
            hide-details
            type="text"
          ></v-text-field>
          <v-text-field
            v-model="passwordForm.memberid"
            :readonly="!passwordEditMode"
            label="Member ID"
            outlined
            dense
            class="mb-3"
            hide-details
          ></v-text-field>
          <v-text-field
            v-model="passwordForm.pass_key"
            :readonly="!passwordEditMode"
            label="Pass Key"
            outlined
            dense
            class="mb-3"
            hide-details
            type="text"
          ></v-text-field>
          <v-row no-glutters>
            <v-col cols="6" class="pr-2">
              <v-btn
                v-if="!passwordEditMode"
                @click="enablePasswordEdit()"
                block
                color="primary"
                class="elevation-0 rounded-lg text-none white--text"
              >
                <v-icon class="mr-1">mdi-pencil</v-icon>
                Edit
              </v-btn>
              <v-btn
                v-else
                @click="cancelPasswordEdit()"
                block
                color="#DDD"
                class="elevation-0 rounded-lg text-none"
              >
                Cancel
              </v-btn>
            </v-col>
            <v-col cols="6" class="pl-2">
              <v-btn
                v-if="passwordEditMode"
                @click="updatePassword()"
                :loading="passwordUpdateLoading"
                :disabled="passwordUpdateLoading"
                block
                color="#43A833"
                class="elevation-0 rounded-lg text-none white--text"
              >
                <v-icon class="mr-1">mdi-check</v-icon>
                Update
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
     <v-dialog
      v-model="autopushdia"
      persistent
      max-width="600"
    >
  
      <v-card class="pa-4">
        <div class="d-flex">
    <p class="font-weight-bold">Auto Push Responce</p>
<v-btn icon class="ml-auto" @click="autopushdia = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <template>
  <v-container>
  <v-timeline dense align-top>
  <!-- Item 1: CDSL Upload -->
  <v-timeline-item
    :color="autpusfin.auto_push_resp && typeof autpusfin.auto_push_resp === 'object'
      ? autpusfin.auto_push_resp.cdsl_upload_error
        ? 'red'
        : autpusfin.auto_push_resp.cdsl_upload
          ? 'green'
          : 'orange'
      : 'orange'"
    :icon="autpusfin.auto_push_resp && typeof autpusfin.auto_push_resp === 'object'
      ? autpusfin.auto_push_resp.cdsl_upload_error
        ? 'mdi-alert'
        : autpusfin.auto_push_resp.cdsl_upload
          ? 'mdi-check-circle'
          : 'mdi-circle-slice-5'
      : 'mdi-circle-slice-5'"
    fill-dot
  >
    <v-card>
      <v-card-title class="title">CDSL Upload</v-card-title>
      <v-card-text>
        {{
          autpusfin.auto_push_resp
            ? typeof autpusfin.auto_push_resp === 'object'
              ? autpusfin.auto_push_resp.cdsl_upload_error
                ? autpusfin.auto_push_resp.msg
                : autpusfin.auto_push_resp.cdsl_upload || 'Pending'
              : autpusfin.auto_push_resp
            : 'Pending'
        }}
      </v-card-text>
    </v-card>
  </v-timeline-item>

  <!-- Item 2: CDSL Status -->
  <v-timeline-item
    :color="autpusfin.auto_push_resp && typeof autpusfin.auto_push_resp === 'object'
      ? autpusfin.auto_push_resp.cdsl_response_error
        ? 'red'
        : autpusfin.auto_push_resp.cdsl_status
          ? 'green'
          : 'orange'
      : 'orange'"
    :icon="autpusfin.auto_push_resp && typeof autpusfin.auto_push_resp === 'object'
      ? autpusfin.auto_push_resp.cdsl_response_error
        ? 'mdi-alert'
        : autpusfin.auto_push_resp.cdsl_status
          ? 'mdi-check-circle'
          : 'mdi-circle-slice-5'
      : 'mdi-circle-slice-5'"
    fill-dot
  >
    <v-card>
      <v-card-title class="title">CDSL Status</v-card-title>
      <v-card-text>
        {{
          autpusfin.auto_push_resp
            ? typeof autpusfin.auto_push_resp === 'object'
              ? autpusfin.auto_push_resp.cdsl_response_error
                ? autpusfin.auto_push_resp.msg
                : autpusfin.auto_push_resp.cdsl_status || 'Pending'
              : autpusfin.auto_push_resp
            : 'Pending'
        }}
      </v-card-text>
    </v-card>
  </v-timeline-item>

  <!-- Item 3: BO Status -->
  <v-timeline-item
    :color="autpusfin.auto_push_resp && typeof autpusfin.auto_push_resp === 'object'
      ? autpusfin.auto_push_resp.bo_push_error
        ? 'red'
        : autpusfin.auto_push_resp.bo_status
          ? 'green'
          : 'orange'
      : 'orange'"
    :icon="autpusfin.auto_push_resp && typeof autpusfin.auto_push_resp === 'object'
      ? autpusfin.auto_push_resp.bo_push_error
        ? 'mdi-alert'
        : autpusfin.auto_push_resp.bo_status
          ? 'mdi-check-circle'
          : 'mdi-circle-slice-5'
      : 'mdi-circle-slice-5'"
    fill-dot
  >
    <v-card>
      <v-card-title class="title">Back Office Status</v-card-title>
      <v-card-text>
        {{
          autpusfin.auto_push_resp
            ? typeof autpusfin.auto_push_resp === 'object'
              ? autpusfin.auto_push_resp.bo_push_error
                ? autpusfin.auto_push_resp.BoApiMsg
                : autpusfin.auto_push_resp.bo_status || 'Pending'
              : autpusfin.auto_push_resp
            : 'Pending'
        }}
      </v-card-text>
    </v-card>
  </v-timeline-item>

  <!-- Item 4: FO Status -->
  <v-timeline-item
    :color="autpusfin.auto_push_resp && typeof autpusfin.auto_push_resp === 'object'
      ? autpusfin.auto_push_resp.fo_push_error
        ? 'red'
        : autpusfin.auto_push_resp.fo_status
          ? 'green'
          : 'orange'
      : 'orange'"
    :icon="autpusfin.auto_push_resp && typeof autpusfin.auto_push_resp === 'object'
      ? autpusfin.auto_push_resp.fo_push_error
        ? 'mdi-alert'
        : autpusfin.auto_push_resp.fo_status
          ? 'mdi-check-circle'
          : 'mdi-circle-slice-5'
      : 'mdi-circle-slice-5'"
    fill-dot
  >
    <v-card>
      <v-card-title class="title">Front office Status</v-card-title>
      <v-card-text>
        {{
          autpusfin.auto_push_resp
            ? typeof autpusfin.auto_push_resp === 'object'
              ? autpusfin.auto_push_resp.fo_push_error
                ? autpusfin.auto_push_resp.msg
                : autpusfin.auto_push_resp.fo_status || 'Pending'
              : autpusfin.auto_push_resp
            : 'Pending'
        }}
      </v-card-text>
    </v-card>
  </v-timeline-item>
</v-timeline>

  </v-container>
</template>

      </v-card>
    </v-dialog>
  </v-row>
</template>


  </div>
</template>

<script>
import {apiekyc, apidkyc, apiexkyc , apikra} from "../api.js";
// import krajson from "../krajson.json";

import axios from "axios";
import exportFromJSON from "export-from-json";
import LayOut from "../components/LayOut.vue";

export default {
  components: {
    LayOut,
  },

  data: () => ({
    protype: false,
 autopushdia:false,
 autpusfin:[],
    snackbar: false,
    snackbarclr: "default",
    snackmsgbar: "",
    dashboarddata: [],
    showdata: [],
    search: null,
    tab: 0,
    btmltab: 0,
    btmrtab: 0,
    mainloader: true,
    btmsheet: false,
    btmdata: [],
    rejectreason: "",
    rejdialog: false,
    valid: true,
    ipaddress: "",
    geolocation: "",
    mfcount: 0,
    comcount: 0,
    rejcount: 0,
    viewcount: 0,
    reactcount: 0,
    pencount: 0,
    esigncount: 0,
    esignpcount: 0,
    resigncount: 0,
    resignpcount: 0,

    uemail: null,
    uuid: null,
    uname: null,
    completebtn: false,
    rejbtn: false,
    comdialog: false,
    status: ["e-signed completed","re-e-signed completed"],
    request: null,

    alldate: null,
    menu2: false,
    menu22: false,
    menu2to: false,

    dateSelectto: "",
    dateSelect2: "",
    maxDate2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),

    headers: [
      {text: "Initiated Date", value: "date_time"},
      {text: "Action", value: "view", sortable: false},
       {text: "Auto Verify", value: "autoverfy", sortable: false},
      {text: "Mobile", value: "mobile_no", sortable: false},
      {text: "Client Id", value: "client_id", sortable: false},
      {text: "RMcode", value: "rmcode", sortable: false},
      {text: "Name", value: "client_name", sortable: false, width: "8%"},
      {text: "PanNumber", value: "client_pan", sortable: false},
      {text: "Approval", value: "stage_approval", sortable: false},
      {text: "e-signed date", value: "email_time_after_esign", sortable: false},
      {text: "Status", value: "app_status"},
      {text: "file_id", value: "file_id", align: " d-none"},
      {text: "Delete", value: "del", sortable: false},
    ],
    headersc: [
      {text: "Approved Date", value: "approved_datetime"},
      {text: "Action", value: "view", sortable: false},
      {text: "Mobile", value: "mobile_no", sortable: false},
      {text: "Client Id", value: "client_id", sortable: false},
      {text: "RMcode", value: "rmcode", sortable: false},
      {text: "Name", value: "client_name", sortable: false},
      {text: "PanNumber", value: "client_pan", sortable: false},
      {text: "Status", value: "app_status"},
      {text: "Initiated date", value: "date_time"},
      {text: "e-signed date", value: "email_time_after_esign"},
            {text: "KRA", value: "KRA_view", sortable: false},
      {text: "Auto Push", value: "autopush"},
      {text: "CDSL/InstaBO API", value: "cdslapi", sortable: false},
      {text: "CDSL/InstaBO", value: "cdsl", sortable: false},
      // {text: "Exchange", value: "exchs", sortable: false},
      {text: "Back office", value: "backoffice", sortable: false},
      {text: "Manual update", value: "manual", sortable: false},
      {text: "Delete", value: "del", sortable: false},
      {text: "file_id", value: "file_id", align: " d-none"},
    ],
    headersp: [
      {text: "Completed Date", value: "BO_created_datetime"},
      {text: "Action", value: "view", sortable: false},
      {text: "Mobile", value: "mobile_no", sortable: false},
      {text: "Client Id", value: "client_id", sortable: false},
      {text: "RMcode", value: "rmcode", sortable: false},
      {text: "Name", value: "client_name", sortable: false},
      {text: "Approved Date & Time", value: "approved_datetime", sortable: false},
      {text: "PanNumber", value: "client_pan", sortable: false},
      // {text: "Status", value: "app_status"},
      {text: "DDPI", value: "stamp", sortable: false},
      {text: "KRA", value: "KRA_view", sortable: false},
      {text: "Initiated date", value: "date_time"},
      {text: "e-signed date", value: "email_time_after_esign", sortable: false},
      {text: "file_id", value: "file_id", align: " d-none"},
    ],
    headersmf: [
      {text: "Complted Date", value: "BO_created_datetime"},
      {text: "Action", value: "view", sortable: false},
      {text: "Mobile", value: "mobile_no", sortable: false},
      {text: "Client Id", value: "client_id", sortable: false},
      {text: "RMcode", value: "rmcode", sortable: false},
      {text: "Name", value: "client_name", sortable: false},
      {text: "PanNumber", value: "client_pan", sortable: false},
      {text: "Status", value: "app_status"},
      {text: "Initiated date", value: "date_time"},
      {text: "file_id", value: "file_id", align: " d-none"},
      {text: "UCC", value: "uccgen"},
    ],
    headersr: [
      {text: "Rejected Date", value: "rejection_date_time"},
      {text: "Action", value: "view", sortable: false},
      {text: "Mobile", value: "mobile_no", sortable: false},
      {text: "Client Id", value: "client_id", sortable: false},
      {text: "RMcode", value: "rmcode", sortable: false},
      {text: "Name", value: "client_name", sortable: false},
      {text: "PanNumber", value: "client_pan", sortable: false},
      {text: "Status", value: "app_status"},
      {text: "Initiated date", value: "date_time"},
      {text: "file_id", value: "file_id", align: " d-none"},
      {text: "e-signed date", value: "email_time_after_esign", sortable: false},
      {text: "Delete", value: "del", sortable: false},
    ],
    stagewise: {},
    stagebtn: false,

    stgrejdialog: false,
    stgvalid: true,
    stgrejectreason: "",

    deldialog: false,
    delbtn: false,
    delvalid: true,
    delrejectreason: "",
    bottomload: false,
    kraform: null,
    checkbox: null,
    fielddoc: true,
    proofdoc: true,

    kradialog: false,

    mandialog: false,
    manreason: "",
    manvalid: true,
    manbtn: false,

    panrot: {
      rot: 0,
      pad: 0,
      flip: 1,
    },
    bankrot: {
      rot: 0,
      pad: 0,
      flip: 1,
    },
    incrot: {
      rot: 0,
      pad: 0,
      flip: 1,
    },
    sigrot: {
      rot: 0,
      pad: 0,
      flip: 1,
    },

    responsdialog: false,
    responsdatas: [],
    respdialogmode: "",
    respdatamode: false,
    respdatareason: "",

    // re-active "CDSL check" dialog (cdsl_reactive_check result shown before Complete CDSL)
    cdslchkdialog: false,
    cdslchkitem: {},
    cdslchkdata: {},
    cdslchkerror: "", // set when the check request itself failed (network / HTTP 500)
    cdslchkbtn: false, // Complete CDSL from the dialog in flight

    emailmobile: null,
    emaildialog: false,
    emailstatus: false,
    emailmsg: null,

    columndialog: false,
    downloadcolumns: [],
    colushowdata: [],

    restorebtnrest: false,

    cor_addr: {},
    per_details: {},
    per_addr: {},

    el: 1,
    karstatupmob:"",
    dialogkraconf:false,
    krastatdata:[],
    krareverload:false,
      page: 1,
      itemsPerPage: 100,
      pageCount: 1,
      totalItems: 0,
      branchid:"",
      mfpaswodgetdata:[],
      passwordDialog: false,
      passwordEditMode: false,
      passwordUpdateLoading: false,
      passwordForm: {
        username: "",
        passworducc: "",
        memberid: "",
        pass_key: ""
      },
      passwordFormOriginal: {
        username: "",
        passworducc: "",
        memberid: "",
        pass_key: ""
      },
       rmcoden:"",
        refrelcoden:"",
        remisiercoden:"",
        terminalidd:"",
        branchIdList:["BR01","BR03","BR04","BR05","BR06","BR07","BR08","BR09","BR10","BR11","BR13","BR14","BR15","BR16","BR17","BR18","CS1","GH","SM1","ER5","CT","OR01","EKCBE"],
        btmsheetnew:false,
        //  tabnew: 0,
      datanew: {},
      autostageverify:false,
      selectedValidation:[],
      tabnew:0,
      autostageverify1:false,
      datatablerespoce:[],
      selectedIndex:0,
      apivideononul:"",
      bosigload:false,
      bocodisabled:false
  }),
  created() {
    var t = Number(localStorage.getItem("latstable"));
    this.tab = t >= 0 ? t : 0;
    document.title = "Ekyc-dashboard";
  },
  mounted() {
    let list = atob(localStorage.getItem("stapilist"));
    this.uemail = localStorage.getItem("email");
    this.uuid = localStorage.getItem("empcode");
    this.uname = localStorage.getItem("name");
    this.dateSelect2 = new Date(new Date().getFullYear(), new Date().getMonth() - 2, new Date().getDate()).toISOString().slice(0, 10);
    this.dateSelectto = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).toISOString().slice(0, 10);
    if (this.uemail && this.uuid && this.uname && (this.uemail.split("@")[1] == "zebuetrade.com" || (list && this.getemailInList(this.uemail, "emailId", list)))) {
      this.dayCustom();
      this.getPublicIP();
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
      } else {
        this.geolocation = "Not able to get location";
        // console.log(this.geolocation);
      }
        if (this.uuid == "ZE514" || this.uuid == "ZE011" || this.uuid == "ZE785" || this.uuid == "ZE806") {
        this.restorebtnrest = false;
      } else {
        this.restorebtnrest = true;
      }
    } else {
      // this.$router.push("/");
    }
    this.getstatcount()
    this.mfgetpawwdata()
    // this.autoverifydata()
  },
  watch: {
    branchid(val) {
      if (val) {
        var cleaned = val.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
        if (cleaned !== val) {
          this.branchid = cleaned;
          return;
        }
        if (this.branchIdList.includes(cleaned)) {
          this.getTerminalId();
        }
      }
    },
    remisiercoden(val) {
      if (val && val.length >= 2 && this.branchid) {
        this.getTerminalId();
      }
    }
  },
  methods: {
    closetabnew(){
this.selectedIndex = 0
    },
    getTerminalId() {
      if (!this.branchid || !this.branchIdList.includes(this.branchid)) return;
      var axiosThis = this;
      var payload = { "branch_id": this.branchid };
      if (this.remisiercoden) {
        payload["remisier_code"] = this.remisiercoden;
      }
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apidkyc}/terminal_id_mapping`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload)
      };
      axios.request(config)
        .then((response) => {
          if (response.data.status === "match found" && response.data.terminal_id) {
            axiosThis.terminalidd = response.data.terminal_id;
          } else if (response.data.status === "match not found") {
            axiosThis.terminalidd = "";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
     normalizeDate(val) {
    if (!val) return "";
    return val.replaceAll("/", "-"); // convert 15/08/2007 → 15-08-2007
  },
      openValidationDialog(item) {
       // if(item.check_name == 'PAN Name Validation' || item.check_name == 'Personal Details Validation (Aadhar)' ||  item.check_name == 'Bank Details Validation' || item.check_name == 'Data & Proof Verification (Signature)') {

     //   }

         this.selectedValidation = item;
    // this.autostageverify = true;

  },
    autoverifydata(item){
      this.bottomload = true;
this.datatablerespoce = []
const axios = require('axios');
let data = JSON.stringify({
  // "mobNo": '8123999899'
  "mobNo": item.mobile_no

});

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: 'https://app.zebull.in/ekyc/validationData',
  headers: { 
    'Content-Type': 'application/json'
  },
  data : data
};
var axiosThis = this
axios.request(config)
.then((response) => {
      axiosThis.bottomload = false;
if (response.data.data && response.data.data.length > 0) {
    axiosThis.btmsheetnew = true;
    axiosThis.datanew = response.data.data[0];
    axiosThis.bottomload = false;
    const order = [2, 3, 4, 5, 6, 7, 8, 9, 10, 1];

axiosThis.datatablerespoce = 
  response.data.data[0].validation_response.validations.sort((a, b) => {
    return order.indexOf(a.check_number) - order.indexOf(b.check_number);
  });
  console.log("axiosThis.datatablerespoce",axiosThis.datatablerespoce);
  

} else {
    axiosThis.snackbar = true;
    axiosThis.snackbarclr = "#FF1717";
    axiosThis.snackmsgbar = "No data";
    axiosThis.bottomload = false;
}




  // console.log(JSON.stringify(response.data));
})
.catch((error) => {
  console.log(error);
      axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;

});



    },
 statusColor(s) {
      if (s === "PASS") return "green";
      if (s === "FAIL") return "red";
      if (s === "WARNING") return "orange";
      if (s === "SKIPPED") return "blue-grey";
      return "grey";
    },

    statusIcon(s) {
      if (s === "PASS") return "mdi-check-circle";
      if (s === "FAIL") return "mdi-close-circle";
      if (s === "WARNING") return "mdi-alert-circle";
      if (s === "SKIPPED") return "mdi-skip-next-circle";
      return "mdi-help-circle";
    },

   formatMessage(msg) {
  if (!msg || typeof msg !== "string") return "";
  return msg.replace(/✓/g, "✔").replace(/✗/g, "✖");
}
,
 parseDetails(details) {
      if (!details || typeof details !== "object") return {};
      return details;
    },

    mfgetpawwdata(){
      this.mfpaswodgetdata = []
      const axios = require('axios');
      let data = JSON.stringify({
        "status": "get"
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apikra}ucc/mf_bse_password_update`,
        headers: { 
          'Content-Type': 'application/json'
        },
        data : data
      };
var axiosThis = this
      axios.request(config)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        if(response.data.username && response.data.passworducc ){
          axiosThis.mfpaswodgetdata = response.data
        }
      })
      .catch((error) => {
        console.log(error);
           axiosThis.bottomload = false;
         axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
      });

    },
    openPasswordDialog() {
      // Load data from mfpaswodgetdata if available
      if (this.mfpaswodgetdata && this.mfpaswodgetdata.username) {
        this.passwordForm = {
          username: this.mfpaswodgetdata.username || "",
          passworducc: this.mfpaswodgetdata.passworducc || "",
          memberid: this.mfpaswodgetdata.memberid || "",
          pass_key: this.mfpaswodgetdata.pass_key || ""
        };
        this.passwordFormOriginal = { ...this.passwordForm };
      } else {
        // If data not loaded, fetch it first
        this.mfgetpawwdata();
        setTimeout(() => {
          if (this.mfpaswodgetdata && this.mfpaswodgetdata.username) {
            this.passwordForm = {
              username: this.mfpaswodgetdata.username || "",
              passworducc: this.mfpaswodgetdata.passworducc || "",
              memberid: this.mfpaswodgetdata.memberid || "",
              pass_key: this.mfpaswodgetdata.pass_key || ""
            };
            this.passwordFormOriginal = { ...this.passwordForm };
          }
        }, 500);
      }
      this.passwordEditMode = false;
      this.passwordDialog = true;
    },
    closePasswordDialog() {
      this.passwordDialog = false;
      this.passwordEditMode = false;
      this.passwordForm = {
        username: "",
        passworducc: "",
        memberid: "",
        pass_key: ""
      };
    },
    enablePasswordEdit() {
      this.passwordEditMode = true;
      this.passwordFormOriginal = { ...this.passwordForm };
    },
    cancelPasswordEdit() {
      this.passwordEditMode = false;
      this.passwordForm = { ...this.passwordFormOriginal };
    },
    updatePassword() {
      if (!this.passwordForm.username || !this.passwordForm.passworducc || !this.passwordForm.memberid || !this.passwordForm.pass_key) {
        this.snackbar = true;
        this.snackbarclr = "#FF1717";
        this.snackmsgbar = "All fields are required";
        return;
      }

      this.passwordUpdateLoading = true;
      const axios = require('axios');
      let data = JSON.stringify({
        "username": this.passwordForm.username,
        "password": this.passwordForm.passworducc,
        "memberid": this.passwordForm.memberid,
        "status": "update"
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apikra}ucc/mf_bse_password_update`,
        headers: { 
          'Content-Type': 'application/json'
        },
        data: data
      };

      var axiosThis = this;
      axios.request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          axiosThis.passwordUpdateLoading = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#43A833";
          axiosThis.snackmsgbar = response.data.msg || "Password updated successfully";
          axiosThis.passwordEditMode = false;
          axiosThis.passwordFormOriginal = { ...axiosThis.passwordForm };
          // Refresh the data
          axiosThis.passwordDialog = false
          axiosThis.mfgetpawwdata();
        })
        .catch((error) => {
          console.log(error);
          axiosThis.passwordUpdateLoading = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    atupushdiall(item){
this.autpusfin = item
this.autopushdia = true
    },
    autopusapi(item){
      const axios = require('axios');
  this.bottomload = true;
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apikra}dashboard/auto_cdsl_service_start/${item.mobile_no}`,
        headers: { }
      };
var axiosThis = this
      axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
          if (response.data.msg == 'procesing' ) {
            axiosThis.snackbarclr = "#43A833";
            axiosThis.snackmsgbar = response.data ? response.data : response.data.msg;
            axiosThis.getDashboard();
          } else {
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = response.data;
            axiosThis.bottomload = false;
          }
      })
      .catch((error) => {
        console.log(error);
          axiosThis.bottomload = false;
         axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
      });

    },
    getemailInList(email, value, list) {
      const rawData = JSON.parse(list);
      return rawData.some((item) => item[value].toUpperCase() === email.toUpperCase());
    },
    copyToClipboard(text) {
      if (!text) {
        this.snackbar = true;
        this.snackbarclr = "warning";
        this.snackmsgbar = "Nothing to copy!";
        return;
      }

      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.snackbar = true;
          this.snackbarclr = "success";
          this.snackmsgbar = "Copied to clipboard!";
        })
        .catch((err) => {
          console.warn("Failed to copy:", err);
          this.snackbar = true;
          this.snackbarclr = "error";
          this.snackmsgbar = "Failed to copy!";
        });
    },
    setCDSLapi(item) {
      this.bottomload = true;
      let config = {
        method: "post",
        url: `${apiekyc}/cdsl/cdslApi/${item.mobile_no}`,
        headers: {
          "Content-Type": "application/json",
        },
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          axiosThis.snackbar = true;
          // {"success":"True","URN":"8248005079","CRN":"UP0181020231913321764477"}
          if (response.data && response.data.success && response.data.URN && response.data.CRN) {
            axiosThis.snackbarclr = "#43A833";
            axiosThis.snackmsgbar = response.data ? response.data : response.data;
            axiosThis.getDashboard();
          } else {
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = response.data;
            axiosThis.bottomload = false;
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
      // this.bottomload = true;
    },
    setCDSL(item) {
      this.bottomload = true;
      let config = {
        method: "post",
        url: `${apiekyc}/cdsl/CDSL_response/${item.mobile_no}`,
        headers: {
          "Content-Type": "application/json",
        },
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          axiosThis.snackbar = true;
          if (response.data && response.data.success == true) {
            axiosThis.snackbarclr = "#43A833";
            axiosThis.snackmsgbar = response.data ? response.data : response.data;
            axiosThis.getDashboard();
          } else {
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = response.data;
            axiosThis.bottomload = false;
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
      // this.bottomload = true;
    },
    getManCDSLdata(item) {
      // flow
      this.bottomload = true;
        let data = JSON.stringify({
        payload: null,
      });
      // item.instbo || flow ? "cdsl_json_new" : "cdsl_json"
      let config = {
        method: "post",
        url: this.cdslReactiveUrl(`${apikra}cdsl/${"cdslinstabo_new"}/${item.mobile_no}?json=true`, item),
        headers: {
          "Content-Type": "application/json",
        },
          data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data && response.data.FirstHolderDetails) {
            for (const [key, value] of Object.entries(response.data)) {
              if (value && value.length > 0 && value != null) {
                for (let d = 0; d < value.length; d++) {
                  response.data[`${key}||${d}`] = value[d];
                }
                delete response.data[key];
              }
            }
            axiosThis.respdialogmode = "cd";
            axiosThis.responsdatas = response.data;
            axiosThis.responsdialog = true;
            axiosThis.btmdata = item;
          } else {
            axiosThis.snackbar = true;
            axiosThis.responsdatas = [];
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
          }
          axiosThis.bottomload = false;
          axiosThis.respdatamode = false;
          axiosThis.respdatareason = "";
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },

        getcdslfiledownload(item,type) {
      // flow
      this.bottomload = true;
        let data = JSON.stringify({
        payload: null,
      });
      // item.instbo || flow ? "cdsl_json_new" : "cdsl_json"
      let config = {
        method: "post",
        url: this.cdslReactiveUrl(`${apikra}cdsl/${"cdslinstabo_new"}/${item.mobile_no}${type == 'man' ? '_downman' : '_down'}`, item),
        headers: {
          "Content-Type": "application/json",
        },
          data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
           if (response.data && response.data.msg == "file gen success" && response.data.file_path) {
            window.open(`${apikra}/file?path=${response.data.file_path}`);
          } else {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = response.data;
          }
          axiosThis.bottomload = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    
    setManCDSLdata(item, flow) {
      this.completebtn = true;
      for (const [key, value] of Object.entries(item)) {
        if (key.split("||")[1]) {
          if (item[key.split("||")[0]]) {
            item[key.split("||")[0]].push(value);
          } else {
            item[key.split("||")[0]] = [];
            item[key.split("||")[0]].push(value);
          }
          delete item[key];
        }
      }
      let data = JSON.stringify({
        payload: item,
        reason: this.respdatareason,
        log: this.getGenlogs(this.respdatareason),
      });
      //  flow ? "cdsl_Insta_bo_man_new" : this.btmdata.instbo ? "cdsl_Insta_bo_man_new" : "cdslApi_new"
      // old end point cdsl_Insta_bo_man_new
      let config = {
        method: "post",
        url: this.cdslReactiveUrl(`${apikra}cdsl/${"cdslinstabo_new"}/${this.btmdata.mobile_no}${flow ? "_downman" : ""}`, this.btmdata),
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (flow) {
            if (response.data && response.data.msg == "file gen success" && response.data.file_path) {
              window.open(`${apidkyc}/static/${response.data.file_path.split("/static/")[1]}`);
            } else {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#FF1717";
              axiosThis.snackmsgbar = response.data.msg;
            }
          } else {
            axiosThis.snackbar = true;
            if (response.data && (response.data.success == "True" || response.data.msg == "Upload Success")) {
              axiosThis.snackbarclr = "#43A833";
              axiosThis.snackmsgbar = response.data ? response.data : response.data;
            } else {
              axiosThis.snackbarclr = "#FF1717";
              axiosThis.snackmsgbar = response.data;
            }
            axiosThis.getDashboard();
          }
          axiosThis.btmsheet = false;
          axiosThis.respdialogmode = "";
          axiosThis.responsdatas = [];
          axiosThis.responsdialog = false;
          axiosThis.btmdata = [];
          axiosThis.completebtn = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.btmsheet = false;
          axiosThis.respdialogmode = "";
          axiosThis.responsdatas = [];
          axiosThis.responsdialog = false;
          axiosThis.btmdata = [];
          axiosThis.completebtn = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    setCDSLdown() {
      this.bottomload = true;
      let config = {
        method: "post",
        url: this.cdslReactiveUrl(`${apikra}cdsl/cdslinstabo_new/${this.btmdata.mobile_no}_down`, this.btmdata),
        headers: {
          "Content-Type": "application/json",
        },
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data && response.data.msg == "file gen success" && response.data.file_path) {
            window.open(`${apidkyc}/static/${response.data.file_path.split("/static/")[1]}`);
          } else {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = response.data;
          }
          axiosThis.bottomload = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error;
        });
    },
    setBackoffice(item) {
      this.bottomload = true;
      let data = JSON.stringify({
        mobile: item.mobile_no,
      });

      let config = {
        method: "post",
        url: `${apikra}backoffice/backofficekyc`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          axiosThis.snackbar = true;
          if (response.data && response.data.BoApiMsg && (response.data.data == "SUCCESSFULLY OPEN" || response.data.data == "TRUE")) {
            axiosThis.snackbarclr = "#43A833";
            axiosThis.snackmsgbar = response.data.data ? response.data.data : response.data;
            axiosThis.getDashboard();
          } else {
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = response.data;
            axiosThis.bottomload = false;
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    getManBackofficedata(item) {
      this.bottomload = true;
      let data = JSON.stringify({
        mobile: item.mobile_no,
      });

      let config = {
        method: "post",
        url: `${apikra}backoffice/backofficekyc?json=true`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data && response.data.AadharCard) {
            axiosThis.respdialogmode = "bo";
            axiosThis.responsdatas = response.data;
            axiosThis.responsdialog = true;
            axiosThis.btmdata = item;
          } else {
            axiosThis.snackbar = true;
            axiosThis.responsdatas = [];
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
          }
          axiosThis.bottomload = false;
          axiosThis.respdatamode = false;
          axiosThis.respdatareason = "";
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    setManBackoffice(item) {
      this.completebtn = true;
      let data = JSON.stringify({
        mobile: this.btmdata.mobile_no,
        payload: item,
        reason: this.respdatareason,
        log: this.getGenlogs(this.respdatareason, {type: "BO push"}),
      });
      let config = {
        method: "post",
        url: `${apikra}backoffice/backofficekyc?manual=True`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          axiosThis.snackbar = true;
          if (response.data && response.data.BoApiMsg && response.data.data == "TRUE") {
            axiosThis.snackbarclr = "#43A833";
            axiosThis.snackmsgbar = response.data ? response.data : response.data;
          } else {
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = response.data;
          }
          axiosThis.getDashboard();
          axiosThis.respdialogmode = "";
          axiosThis.responsdatas = [];
          axiosThis.responsdialog = false;
          axiosThis.btmdata = [];
          axiosThis.completebtn = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.respdialogmode = "";
          axiosThis.responsdatas = [];
          axiosThis.responsdialog = false;
          axiosThis.btmdata = [];
          axiosThis.completebtn = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },

    setCdslInsta(item) {
      this.bottomload = true;
      let data = JSON.stringify({
        mobile: item.mobile_no,
      });

      let config = {
        method: "post",
        url: this.cdslReactiveUrl(`${apikra}cdsl/${item.instbo ? `cdslinstabo_new/${item.mobile_no}` : `cdslinstabo_new/${item.mobile_no}`}`, item),

        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      // returned so the re-active CDSL check dialog can keep its button loading until this finishes
      return axios
        .request(config)
        .then((response) => {
          axiosThis.snackbar = true;
          // NO_CHANGE (re-active clients only): nothing needed sending and the backend has already marked CDSL complete
          if (response.data && (response.data.msg == "Upload Success" || response.data.cdsl_status == "NO_CHANGE")) {
            axiosThis.snackbarclr = "#43A833";
            axiosThis.getDashboard();
          } else {
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.bottomload = false;
          }
          axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          // error bodies carry a readable msg; fall back to the network error text
          const res = error.response && error.response.data;
          axiosThis.snackmsgbar = res && res.msg ? res.msg : error.message || error;
        });
    },
    isRekycClient(item) {
      return !!(item && item.data_type && item.data_type.rekyc == "Yes");
    },
    // every cdslinstabo_new call for a re-active row must carry reactive=yes: a client going through BO Setup has its
    // BOID read from back office so CDSL never opens a second demat (the backend refuses the call without it)
    cdslReactiveUrl(url, item) {
      if (!this.isRekycClient(item)) return url;
      return `${url}${url.includes("?") ? "&" : "?"}reactive=yes`;
    },
    // read-only: nothing is saved and nothing goes to CDSL, so it is safe to repeat. The dialog opens even when the
    // request fails, showing the error with Complete CDSL disabled
    getCdslReactiveCheck(item) {
      this.bottomload = true;
      let config = {
        method: "get",
        url: `${apikra}cdsl/cdsl_reactive_check/${item.mobile_no}`,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          const ok = response.data && typeof response.data === "object";
          axiosThis.cdslchkdata = ok ? response.data : {};
          axiosThis.cdslchkerror = ok ? "" : "Unexpected response from the server";
        })
        .catch((error) => {
          console.log(error);
          const res = error.response && error.response.data;
          axiosThis.cdslchkdata = res && typeof res === "object" ? res : {};
          axiosThis.cdslchkerror = (res && (res.msg || res.error)) || error.message || "Request failed";
        })
        .finally(() => {
          axiosThis.cdslchkitem = item;
          axiosThis.cdslchkbtn = false;
          axiosThis.cdslchkdialog = true;
          axiosThis.bottomload = false;
        });
    },
    setCdslReactivePush() {
      if (this.cdslchkbtn || !this.cdslChkStatus.canPush) return;
      this.cdslchkbtn = true;
      this.setCdslInsta(this.cdslchkitem).finally(() => {
        this.cdslchkbtn = false;
        this.cdslchkdialog = false;
      });
    },
    // the backend writes " -- " as a separator; show it as ": " for operators
    cdslChkNote(text) {
      return String(text).split(" -- ").join(": ");
    },
    cdslChkEmpty(v) {
      return v === null || v === undefined || v === "";
    },
    cdslChkCash(v) {
      if (this.cdslChkEmpty(v)) return "—";
      return {A: "Active", I: "Inactive", "NOT OPEN": "Not opened"}[v] || v;
    },
    // "YYYY-MM-DD..." (back office adds a time) -> DD-MM-YYYY; anything else as-is
    cdslChkDate(v) {
      if (this.cdslChkEmpty(v)) return "—";
      if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v.slice(0, 10))) {
        const [y, m, d] = v.slice(0, 10).split("-");
        return `${d}-${m}-${y}`;
      }
      return String(v);
    },
    cdslChkResult(r) {
      if (r.result == "Matched") return {text: "Matched", color: "success"};
      if (r.result == "Not matched") return {text: "Not matched", color: r.sent_to_cdsl ? "orange darken-1" : "error"};
      if (r.result == "not_sent") return {text: "Not sent", color: "grey"};
      return {text: r.result, color: "grey"};
    },
    // "orange darken-1" -> "orange--text text--darken-1"
    cdslChkTextClass(color) {
      const [base, shade] = color.split(" ");
      return shade ? `${base}--text text--${shade}` : `${base}--text`;
    },
    // any object as readable "key: value" lines, never braces
    cdslChkObjLines(obj, prefix = "") {
      const lines = [];
      Object.entries(obj || {}).forEach(([k, v]) => {
        const key = prefix ? `${prefix} ${k}` : k;
        if (Array.isArray(v)) {
          lines.push(`${key}: ${v.length ? v.map((x) => (x && typeof x === "object" ? this.cdslChkObjLines(x).join(", ") : x)).join("; ") : "—"}`);
        } else if (v && typeof v === "object") {
          lines.push(...this.cdslChkObjLines(v, key));
        } else {
          lines.push(`${key}: ${this.cdslChkEmpty(v) ? "—" : v}`);
        }
      });
      return lines.length ? lines : ["—"];
    },
    // one comparison cell as a list of display lines
    cdslChkCell(key, side, v) {
      const dash = (x) => (this.cdslChkEmpty(x) ? "—" : String(x));
      // both sides list each nominee as Name / DOB / Relation only; a "Nominee N" line separates them when there are several
      const nomineeLines = (list) => {
        if (!list.length) return ["No nominee"];
        return list.reduce((lines, n, i) => {
          if (list.length > 1) lines.push(`Nominee ${this.cdslChkEmpty(n.serial) ? i + 1 : n.serial}`);
          lines.push(`Name: ${dash(n.name)}`, `DOB: ${this.cdslChkDate(n.dob)}`, `Relation: ${dash(n.relation)}`);
          return lines;
        }, []);
      };
      if (key == "nominee" && side == "requested" && Array.isArray(v)) return nomineeLines(v);
      if (key == "nominee" && side == "back_office" && v && typeof v === "object" && !Array.isArray(v)) {
        return nomineeLines(Array.isArray(v.nominees) ? v.nominees : []);
      }
      if (this.cdslChkEmpty(v)) return ["—"];
      if (key == "dob") return [this.cdslChkDate(v)];
      if (key == "address" && typeof v === "object" && !Array.isArray(v)) {
        const place = [v.address, v.city, v.state].filter((x) => !this.cdslChkEmpty(x)).join(", ");
        const pin = this.cdslChkEmpty(v.pincode) ? "" : v.pincode;
        return [place && pin ? `${place} – ${pin}` : place || pin || "—"];
      }
      if (key == "bank" && side == "requested" && typeof v === "object" && !Array.isArray(v)) {
        return [`Bank: ${dash(v.bank)}`, `A/c: ${dash(v.account)}`, `IFSC: ${dash(v.ifsc)}`];
      }
      if (key == "bank" && side == "back_office" && typeof v === "object" && !Array.isArray(v)) {
        // laid out like the client side; empty lines are skipped
        const lines = [
          ["Bank", v.default_bank],
          ["A/c", v.default_account],
          ["IFSC", v.default_ifsc],
          ["MICR", v.default_micr],
          ["Type", v.default_type],
        ]
          .filter(([, x]) => !this.cdslChkEmpty(x))
          .map(([label, x]) => `${label}: ${x}`);
        const others = (Array.isArray(v.accounts) ? v.accounts : []).filter((a) => !this.cdslChkEmpty(a) && String(a) != String(v.default_account));
        if (others.length) lines.push(`Other accounts: ${others.join(", ")}`);
        return lines.length ? lines : ["—"];
      }
      if (typeof v === "object") return Array.isArray(v) ? v.map((x) => (x && typeof x === "object" ? this.cdslChkObjLines(x).join(", ") : dash(x))) : this.cdslChkObjLines(v);
      return [String(v)];
    },
    setInstaRes(item) {
      this.bottomload = true;
      // var stat = eval("(" + item.CDSLResponse.replace("True", true).replace("False", false) + ")"); old
      var stat = item.CDSLResponse

      //  "CDSLResponse": "{'AcknowledgmentID': 'UP8280820241605413937942', 'success': True}",

      if (stat && stat.success == true) {
        let data = JSON.stringify({
          mobile: item.mobile_no,
          acknowledgmentID: stat.AcknowledgmentID,
        });

        let config = {
          method: "post",
          url: `${apikra}cdsl/cdsl_status_check`,

          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        let axiosThis = this;
        axios
          .request(config)
          .then((response) => {
            axiosThis.snackbar = true;
            // console.log("cobncsdl chenk",response.data && ((response.data.msg.success && response.data.msg.success == true) && (response.data.msg.update_status && response.data.msg.update_status == "Accepted")))
            // console.log("response.data.success",response.data.msg.success);
            // console.log("response.data.update_status",response.data.msg.update_status);
            // console.log("1st cn cnk",response.data.msg.success && response.data.msg.success == true);
            // console.log("2 ncn ck",response.data.msg.update_status && response.data.msg.update_status.trim() === "Accepted");
            // console.log("fulll data",response.data.msg);
            if (response.data && ((response.data.msg.success && response.data.msg.success == true) && (response.data.msg.update_status && response.data.msg.update_status == "Accepted"))) {
              axiosThis.snackbarclr = "#43A833";
              axiosThis.getDashboard();
            } else {
              axiosThis.snackbarclr = "#FF1717";
              axiosThis.bottomload = false;
            }
            axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
          })
          .catch((error) => {
            console.log(error);
            axiosThis.bottomload = false;
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = error;
          });
      } else {
        this.snackbar = true;
        this.snackbarclr = "#FF1717";
        this.snackmsgbar = stat;
      }
    },
handlePageChange() {
      this.getDashboard();
      // console.log("tstst",this.page);
      
    },
    closefiltercancel(){
this.status = []
this.getDashboard()
    },


    getDashboard(c) {
      const offset = this.page;
      this.apivideononul = ""
      this.showdata = [];
      this.dashboarddata = [];
      this.mainloader = true;
      console.log("thhjh",this.status);
      
      let data = JSON.stringify({
        from: this.dateSelect2,
        to: this.dateSelectto,
        stage:this.tab == 0 ? this.status : []
      });

      let config = {
        method: "post",
        url: `${apidkyc}/dashboard?filter=${this.tab == 0 ? "view" : this.tab == 1 ? "com" : this.tab == 2 ? "rej" : this.tab == 3 ? "full" : this.tab == 4 ? "mf" : null}&limit=100&offset=${offset}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data.data) {
            let data = response.data.data;
            for (let z = 0; z < data.length; z++) {
              data[z]["app_status"] = data[z]["app_status"] == null ? "mobile" : data[z]["app_status"];
              data[z]["stage_approval"] = data[z].stage_wise_approval
                ? data[z].stage_wise_approval["KRA"] == "yes"
                  ? "KRA"
                  : data[z].stage_wise_approval["nominee"] == "yes"
                  ? "nominee"
                  : data[z].stage_wise_approval["selfie"] == "yes"
                  ? "selfie"
                  : data[z].stage_wise_approval["signature"] == "yes"
                  ? "signature"
                  : data[z].stage_wise_approval["segment"] == "yes"
                  ? "segment"
                  : data[z].stage_wise_approval["bank"] == "yes"
                  ? "bank"
                  : data[z].stage_wise_approval["personal"] == "yes"
                  ? "personal"
                  : data[z].stage_wise_approval["digilocker"] == "yes"
                  ? "digilocker"
                  : data[z].stage_wise_approval["pan"] == "yes"
                  ? "pan"
                  : data[z].stage_wise_approval["email"] == "yes"
                  ? "email"
                  : data[z].stage_wise_approval["mobile"] == "yes"
                  ? "mobile"
                  : "pending"
                : "pending";

              if (data[z].declaration && data[z].declaration.standing_instructions) {
                data[z]["DIS"] = data[z].declaration.standing_instructions.DIS;
                data[z]["BSDS"] = data[z].declaration.standing_instructions.bsda;
              }
              if (data[z].declaration) {
                data[z]["DDPI"] = data[z].declaration.DDPI;
                data[z]["Settle date"] = data[z].declaration.days;
              }
              if (data[z].data_type) {
                data[z]["MTF"] = data[z].data_type.MTf ? data[z].data_type.MTf : null;
              }

              if (axiosThis.tab == 1) {
                // console.log("typeof data[z].CDSLResponse == object",typeof data[z].CDSLResponse == 'object' );
                
                data[z]["instbo"] = data[z].data_type && data[z].data_type.rekyc != "Yes" ? (data[z].instabo_status == "INSTABO" ? true : data[z].dpid && data[z].dpid != "" &&  (typeof data[z].CDSLResponse == 'object' ? Object.keys(data[z].CDSLResponse ).length == 0 : data[z].CDSLResponse == "") ? true : false) : false;
              }
            }
            axiosThis.dashboarddata = data;
            axiosThis.pageCount  = response.data.total_page_count
            // axiosThis.viewcount = response.data.view_count;
            // axiosThis.reactcount = response.data.rekyc_count;
            // axiosThis.pencount = response.data.pen_count;
            // axiosThis.rejcount = response.data.rej_count;
            // axiosThis.comcount = response.data.com_count;
            // axiosThis.mfcount = response.data.mf;
            // axiosThis.esigncount = response.data.e_signed_completed;
            // axiosThis.esignpcount = response.data.e_signed_pending;
            // axiosThis.resigncount = response.data["re-e-signed completed"];
            // axiosThis.resignpcount = response.data["re-e-signed pending"];
            if (c) {
              let obj = data.find((o) => o.mobile_no === c);
              axiosThis.getSingledata(obj);
            }
            if (this.tab == 0) {
              // this.status = []"e-signed completed";
              this.statusChange();
            } else {
              axiosThis.showdata = data;
            }
          } else {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#2a2a2a";
            axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
            axiosThis.viewcount = 0;
            axiosThis.reactcount = 0;
            axiosThis.pencount = 0;
            axiosThis.rejcount = 0;
            axiosThis.comcount = 0;
            axiosThis.esigncount = 0;
            axiosThis.esignpcount = 0;
          }
axiosThis.apivideononul = apiekyc
console.log('axiosThis.apivideononul',axiosThis.apivideononul);

          axiosThis.mainloader = false;
          axiosThis.bottomload = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.mainloader = false;
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    searchapicall(c){
    if(this.search.length > 2){

          const offset = this.page;
          this.showdata = [];
          this.dashboarddata = [];
          this.mainloader = true;
          console.log("thhjh",this.status);
          
          let data = JSON.stringify({
            from: "",
            to: "",
            stage:"",
            search_term:this.search
          });

          let config = {
            method: "post",
            url: `${apidkyc}/dashboard?filter=${this.tab == 0 ? "view" : this.tab == 1 ? "com" : this.tab == 2 ? "rej" : this.tab == 3 ? "full" : this.tab == 4 ? "mf" : null}&limit=100&offset=${offset}`,
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };

          let axiosThis = this;
          axios
            .request(config)
            .then((response) => {
              if (response.data.data) {
                let data = response.data.data;
                for (let z = 0; z < data.length; z++) {
                  data[z]["app_status"] = data[z]["app_status"] == null ? "mobile" : data[z]["app_status"];
                  data[z]["stage_approval"] = data[z].stage_wise_approval
                    ? data[z].stage_wise_approval["KRA"] == "yes"
                      ? "KRA"
                      : data[z].stage_wise_approval["nominee"] == "yes"
                      ? "nominee"
                      : data[z].stage_wise_approval["selfie"] == "yes"
                      ? "selfie"
                      : data[z].stage_wise_approval["signature"] == "yes"
                      ? "signature"
                      : data[z].stage_wise_approval["segment"] == "yes"
                      ? "segment"
                      : data[z].stage_wise_approval["bank"] == "yes"
                      ? "bank"
                      : data[z].stage_wise_approval["personal"] == "yes"
                      ? "personal"
                      : data[z].stage_wise_approval["digilocker"] == "yes"
                      ? "digilocker"
                      : data[z].stage_wise_approval["pan"] == "yes"
                      ? "pan"
                      : data[z].stage_wise_approval["email"] == "yes"
                      ? "email"
                      : data[z].stage_wise_approval["mobile"] == "yes"
                      ? "mobile"
                      : "pending"
                    : "pending";

                  if (data[z].declaration && data[z].declaration.standing_instructions) {
                    data[z]["DIS"] = data[z].declaration.standing_instructions.DIS;
                    data[z]["BSDS"] = data[z].declaration.standing_instructions.bsda;
                  }
                  if (data[z].declaration) {
                    data[z]["DDPI"] = data[z].declaration.DDPI;
                    data[z]["Settle date"] = data[z].declaration.days;
                  }
                  if (data[z].data_type) {
                    data[z]["MTF"] = data[z].data_type.MTf ? data[z].data_type.MTf : null;
                  }

                  if (axiosThis.tab == 1) {
                    // console.log("typeof data[z].CDSLResponse == object",typeof data[z].CDSLResponse == 'object' );
                    
                    data[z]["instbo"] = data[z].data_type && data[z].data_type.rekyc != "Yes" ? (data[z].instabo_status == "INSTABO" ? true : data[z].dpid && data[z].dpid != "" &&  (typeof data[z].CDSLResponse == 'object' ? Object.keys(data[z].CDSLResponse ).length == 0 : data[z].CDSLResponse == "") ? true : false) : false;
                  }
                }
                axiosThis.dashboarddata = data;
                axiosThis.pageCount  = response.data.total_page_count
                // axiosThis.viewcount = response.data.view_count;
                // axiosThis.reactcount = response.data.rekyc_count;
                // axiosThis.pencount = response.data.pen_count;
                // axiosThis.rejcount = response.data.rej_count;
                // axiosThis.comcount = response.data.com_count;
                // axiosThis.mfcount = response.data.mf;
                // axiosThis.esigncount = response.data.e_signed_completed;
                // axiosThis.esignpcount = response.data.e_signed_pending;
                // axiosThis.resigncount = response.data["re-e-signed completed"];
                // axiosThis.resignpcount = response.data["re-e-signed pending"];
                if (c) {
                  let obj = data.find((o) => o.mobile_no === c);
                  axiosThis.getSingledata(obj);
                }
                if (this.tab == 0) {
                  // this.status = []"e-signed completed";
                  this.statusChange();
                } else {
                  axiosThis.showdata = data;
                }
              } else {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "#2a2a2a";
                axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
                axiosThis.viewcount = 0;
                axiosThis.reactcount = 0;
                axiosThis.pencount = 0;
                axiosThis.rejcount = 0;
                axiosThis.comcount = 0;
                axiosThis.esigncount = 0;
                axiosThis.esignpcount = 0;
              }

              axiosThis.mainloader = false;
              axiosThis.bottomload = false;
            })
            .catch((error) => {
              console.log(error);
              axiosThis.mainloader = false;
              axiosThis.bottomload = false;
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#FF1717";
              axiosThis.snackmsgbar = error.message ? error.message : error;
            });
        
      
    }
    else if(this.search.length == 0){
      this.getDashboard()
    }else{
      console.log("errrorrr");
    }
    },
    getstatcount(){
      const axios = require('axios');

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${apidkyc}/client_details_counts`,
        headers: { }
      };
 var axiosThis = this
      axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
            axiosThis.viewcount = response.data.view_count;
            axiosThis.reactcount = response.data.rekyc_count;
            axiosThis.pencount = response.data.pen_count;
            axiosThis.rejcount = response.data.rej_count;
            axiosThis.comcount = response.data.com_count;
            axiosThis.mfcount = response.data.mf;
            axiosThis.esigncount = response.data.e_signed_completed;
            axiosThis.esignpcount = response.data.e_signed_pending;
             axiosThis.resigncount = response.data["re-e-signed completed"];
            axiosThis.resignpcount = response.data["re-e-signed pending"];
      })
      .catch((error) => {
        console.log(error);
      });

    },
    stageFind() {
      if (this.btmltab == 0 && this.stagewise) {
        this.btmdata["appv"] = this.stagewise.mobile == "yes" ? "y" : this.stagewise.mobile == "no" ? "n" : null;
        this.btmdata["sts"] = "Mobile";
      } else if (this.btmltab == 1 && this.stagewise) {
        this.btmdata["appv"] = this.stagewise.email == "yes" ? "y" : this.stagewise.email == "no" ? "n" : null;
        this.btmdata["sts"] = "Email";
      } else if (this.btmltab == 2 && this.stagewise) {
        this.btmdata["appv"] = this.stagewise.pan == "yes" && this.stagewise.panproof == "yes" ? "y" : this.stagewise.pan == "no" || this.stagewise.panproof == "no" ? "n" : null;
        this.btmdata["sts"] = "PAN";
      } else if (this.btmltab == 3 && this.stagewise) {
        this.btmdata["appv"] = this.stagewise.digilocker == "yes" ? "y" : this.stagewise.digilocker == "no" ? "n" : null;
        this.btmdata["sts"] = "Digilocker";
      } else if (this.btmltab == 4 && this.stagewise) {
        this.btmdata["appv"] = this.stagewise.personal == "yes" ? "y" : this.stagewise.personal == "no" ? "n" : null;
        this.btmdata["sts"] = "Personal";
      } else if (this.btmltab == 5 && this.stagewise) {
        this.btmdata["appv"] = this.stagewise.bank == "yes" && this.stagewise.bankproof == "yes" ? "y" : this.stagewise.bank == "no" || this.stagewise.bankproof == "no" ? "n" : null;
        this.btmdata["sts"] = "Bank";
      } else if (this.btmltab == 6 && this.stagewise) {
        this.btmdata["appv"] = this.stagewise.segment == "yes" ? "y" : this.stagewise.segment == "no" ? "n" : null;
        this.btmdata["sts"] = "Segment";
      } else if (this.btmltab == 7 && this.stagewise) {
        this.btmdata["appv"] = this.stagewise.signature == "yes" ? "y" : this.stagewise.signature == "no" ? "n" : null;
        this.btmdata["sts"] = "Signature";
      } else if (this.btmltab == 8 && this.stagewise) {
        this.btmdata["appv"] = this.stagewise.selfie == "yes" ? "y" : this.stagewise.selfie == "no" ? "n" : null;
        this.btmdata["sts"] = "Selfie";
      } else if (this.btmltab == 9 && this.stagewise) {
        this.btmdata["appv"] = this.stagewise.nominee == "yes" ? "y" : this.stagewise.nominee == "no" ? "n" : null;
        this.btmdata["sts"] = "Nominee";
      } else {
        this.btmdata["appv"] = null;
        this.btmdata["sts"] = null;
      }
    },
    dialogTrig() {
      this.stgrejdialog = true;
      setTimeout(() => this.$refs.stgrj.$refs.input.focus(), 100);
    },
    setstgReject() {
      if (this.$refs.formo.validate() == true) {
        this.setStageUP("no");
      }
    },
    setStageUP(v) {
      this.stagebtn = true;
      var st =
        this.btmltab == 0
          ? "mobile"
          : this.btmltab == 1
          ? "email"
          : this.btmltab == 2
          ? "pan"
          : this.btmltab == 3
          ? "digilocker"
          : this.btmltab == 4
          ? "personal"
          : this.btmltab == 5
          ? "bank"
          : this.btmltab == 6
          ? "segment"
          : this.btmltab == 7
          ? "signature"
          : this.btmltab == 8
          ? "selfie"
          : this.btmltab == 9
          ? "nominee"
          : "";
      let data = {
        reason: v == "no" ? this.stgrejectreason : "",
        log: this.getGenlogs(this.stgrejectreason, {type: "stage up"}),
      };
      if (st == "bank") {
        data[st] = v == "no" ? (this.fielddoc == true ? "no" : "yes") : v == "yes" ? v : "";
        data["bankproof"] = v == "no" ? (this.proofdoc == true ? "no" : "yes") : v == "yes" ? v : "";
      } else if (st == "pan") {
        data[st] = v == "no" ? (this.fielddoc == true ? "no" : "yes") : v == "yes" ? v : "";
        data["panproof"] = v == "no" ? (this.proofdoc == true ? "no" : "yes") : v == "yes" ? v : "";
      } else {
        data[st] = v;
      }
      let ways = JSON.stringify(data);
      let config = {
        method: "post",
        url: `${apidkyc}/${this.tab < 3 ? "stage_update" : "stage_updateComplete"}?mobileNo=${this.btmdata.mobile_no}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: ways,
      };
      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          axiosThis.snackbar = true;
          if (response.data) {
            axiosThis.stagewise = response.data;
            // axiosThis.stageSteper(response.data)
            axiosThis.snackbarclr = v == "no" ? "#FF1717" : v == "yes" ? "#43A833" : "warning";
            axiosThis.snackmsgbar = `${st}, stage, as ${v == "no" ? "Rejected" : v == "yes" ? "Approved" : "Restore"}`;
            if (axiosThis.btmltab <= `10` && v) {
              axiosThis.btmltab += 1;
            }
            axiosThis.btmltab == 2
              ? (axiosThis.btmrtab = 1)
              : axiosThis.btmltab == 3
              ? (axiosThis.btmrtab = 2)
              : axiosThis.btmltab == 5
              ? (axiosThis.btmrtab = 3)
              : axiosThis.btmltab == 6
              ? (axiosThis.btmrtab = 4)
              : axiosThis.btmltab == 7
              ? (axiosThis.btmrtab = 5)
              : axiosThis.btmltab == 8
              ? (axiosThis.btmrtab = 6)
              : axiosThis.btmltab == 11
              ? (axiosThis.btmrtab = 7)
              : (axiosThis.btmrtab = 0);

            if (
              axiosThis.stagewise.nominee == "yes" &&
              axiosThis.stagewise.bank == "yes" &&
              axiosThis.stagewise.digilocker == "yes" &&
              axiosThis.stagewise.email == "yes" &&
              axiosThis.stagewise.mobile == "yes" &&
              axiosThis.stagewise.pan == "yes" &&
              axiosThis.stagewise.personal == "yes" &&
              axiosThis.stagewise.segment == "yes" &&
              axiosThis.stagewise.selfie == "yes" &&
              axiosThis.stagewise.signature == "yes"
            ) {
              axiosThis.btmsheet = false;
              axiosThis.getDashboard(axiosThis.btmdata.mobile_no);
              axiosThis.bottomload = true;
              axiosThis.kraform = true;
            }
          } else {
            axiosThis.snackbarclr = "warning";
            axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
          }
          axiosThis.proofdoc = false;
          axiosThis.fielddoc = false;
          axiosThis.stageFind();
          axiosThis.stagebtn = false;
          v == "no" ? axiosThis.$refs.formo.reset() : "";
          axiosThis.stgrejdialog = false;
          // setTimeout(() => {
          //   axiosThis.snackbar = false;
          // }, 2600);
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    setStatusUP() {
      this.bottomload = true;
      let data = {
        mobile_no: this.btmdata.mobile_no,
        stages: {mobile: "yes", email: "yes", pan: "", digilocker: "", personal: "", bank: "", segment: "", signature: "", selfie: "", nominee: "", bankproof: "", panproof: ""},
        log: this.getGenlogs("", {type: "stage up"}),
      };

      let config = {
        method: "post",
        url: `${apidkyc}/status_switch`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),
      };
      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          if (res.data && res.data.msg == "successfully changed") {
            axiosThis.snackbarclr = "success";
            axiosThis.btmdata = [];
            axiosThis.getDashboard();
            axiosThis.btmsheet = false;
          } else {
            axiosThis.snackbarclr = "warning";
          }
          axiosThis.snackbar = true;
          axiosThis.snackmsgbar = res.data.msg ? res.data.msg : res.data;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
          axiosThis.bottomload = false;
        });
    },
    getSingledata(item) {
      this.bottomload = true;

      let oconfig = {
        method: "post",
        url: `${apidkyc}/viewdataCompleted?mobileNo=${item.mobile_no}&row_index=${item.row_index}&emp_code=${localStorage.getItem("empcode")}&emp_email=${localStorage.getItem("email")}&view_type=${this.tab == 0 || this.tab == 1 || this.tab == 2 ? "view" : "complete"}`,
        headers: {
          "Content-Type": "application/json",
        },
      };
      let axiosThis = this;

      axios
        .request(oconfig)
        .then((response) => {
          if (Object.keys(response.data).length > 1) {
            let data = response.data;
            data.KRA_file_path = data.KRA_file_path ? `${apikra}file?path=${data.KRA_file_path}` : "";
            data.adhar_file = data.adhar_file ? `${apikra}file?path=${data.adhar_file}` : "";
            data.clientimage = data.clientimage ? `${apikra}file?path=${data.clientimage}` : "";
            data.e_signed_pdf_path = data.e_signed_pdf_path ? `${apikra}file?path=${data.e_signed_pdf_path}` : "";
            data.uploadBankproof = data.uploadBankproof ? `${apikra}file?path=${data.uploadBankproof}` : "";
            data.uploadFinancialproof = data.uploadFinancialproof ? `${apikra}file?path=${data.uploadFinancialproof}` : "";
            data.uploadPAN = data.uploadPAN ? `${apikra}file?path=${data.uploadPAN}` : "";
            data.uploadSignature = data.uploadSignature ? `${apikra}file?path=${data.uploadSignature}` : "";
            data.aadharxmlfile = data.aadharxmlfile ? `${apikra}file?path=${data.aadharxmlfile}` : "";
            data.stamp_paper_path = data.stamp_paper_path ? `${apikra}file?path=${data.stamp_paper_path}` : "";
            // data.stamp_paper_path = data.stamp_paper_path ? `http://192.168.5.179:5005/static/${data.stamp_paper_path.split("/static/")[1]}` : "";

            let rang = data.userLocationData && data.userLocationData.includes("q=") ? data.userLocationData.split("q=")[1].split(",") : null;
            rang = rang ? !(Number(rang[0]) > 8 && Number(rang[0]) < 37 && Number(rang[1]) > 68 && Number(rang[1]) < 98) : null;
            data["IPVrange"] = rang;
            data["adhar_is"] = data.adhar_file ? (data.adhar_file.split(".").slice(-1)[0] == "pdf" ? "y" : "n") : "";
            data["bank_is"] = data.uploadBankproof ? (data.uploadBankproof.split(".").slice(-1)[0] == "pdf" ? "y" : "n") : "";
            data["income_is"] = data.uploadFinancialproof ? (data.uploadFinancialproof.split(".").slice(-1)[0] == "pdf" ? "y" : "n") : "";

            if  (
  (typeof data.hyv_ipv_res == 'string' && data.hyv_ipv_res.includes("transactionId")) ||
  (typeof data.hyv_ipv_res == 'object' && data.hyv_ipv_res != null && data.hyv_ipv_res.transactionId)
) {
              // data["hyvres"] = JSON.parse(data.hyv_ipv_res).details;
               data["hyvres"] = data.hyv_ipv_res
              data["hyvres_trxid_ipv"] = data.hyv_ipv_res.transactionId;
            } else if (typeof data.hyv_ipv_res == 'object' && data.hyv_ipv_res != null && Object.keys(data.hyv_ipv_res).length != 0 && data.hyv_ipv_res.Selfie_Liveness_Score ) {
               data["hyvres"] = data.hyv_ipv_res
              data["hyvres_trxid_ipv"] = item.mobile_no + "_IPV";
            } else if (typeof data.hyv_ipv_res == 'object' && data.hyv_ipv_res != null && data.hyv_ipv_res.result && data.hyv_ipv_res.result.transactionId) {
              data["hyvres"] = data.hyv_ipv_res;
              data["hyvres_trxid_ipv"] = data.hyv_ipv_res.result.transactionId;
            } else {
              data["hyvres"] = null;
              data["hyvres_trxid_ipv"] = "";
            }
// console.log("Object.keys(data.hyv_sig_res).length >= 1",Object.keys(data.hyv_sig_res).length >= 1);
console.log(Object.keys(data.hyv_sig_res).length);


           if (typeof data.hyv_sig_res == 'object' && data.hyv_sig_res != null && Object.keys(data.hyv_sig_res).length >= 1 && data.hyv_sig_res.transactionId) {
              // data["hyvress"] = JSON.parse(data.hyv_sig_res).details;
               data["hyvres"] = data.hyv_sig_res
              data["hyvress_trxid_sig"] = data.hyv_sig_res.transactionId;
              console.log("printtt objett");
              
            } else if (typeof data.hyv_sig_res == 'object' && data.hyv_sig_res != null && Object.keys(data.hyv_sig_res).length >= 1 && data.hyv_sig_res.Wet_Signature_Signature_Mode) {
              data["hyvress"] = data.hyv_sig_res;
              data["hyvress_trxid_sig"] = item.mobile_no + "_Sig";
            } else {
              data["hyvress"] = null;
              data["hyvress_trxid_sig"] = "";
            }
            if ("pandownresp" in response.data && response.data["pandownresp"]) {
              var panresponse = response.data.pandownresp;

              if ("pan" in panresponse && panresponse["pan"] != true) {
                data["pan_is"] = "n";
              } else {
                data["pan_is"] = "y";
              }
            } else {
              data["pan_is"] = "n";
            }
            if (data["activestatus"]) {
              var pennyresponse = data.activestatus;
              data["pennyresponse"] = pennyresponse;
            } else {
              data["pennyresponse"] = "";
            }
data["instbo"] = data.data_type && data.data_type.rekyc != "Yes"
  ? (data.instabo_status == "INSTABO"
      ? true
      : data.dpid && data.dpid != "" && (typeof data.CDSLResponse == "object" ? Object.keys(data.CDSLResponse).length == 0 : data.CDSLResponse == ""  )
        ? true
        : false)
  : false;


  //  data["instbo"] = data.data_type && data.data_type.rekyc != "Yes" ? (data.instabo_status == "INSTABO" ? true : data.dpid && data.dpid != "" && data.CDSLResponse == "" ? true : false) : false;


            data["verif"] = data.kra_code && data.kra_code == "yes" ? "KRA" : "Aadhar";

            if (data.verif == "KRA") {
              data["adhar_name"] = data["kra_name"];
              data["adhar_dob"] = data["kra_dob"];
              data["adhar_gender"] = data["kra_gender"];
              data["adhar_fathername"] = data["kra_fathername"];
              data["aadhar_address"] = data["kra_address"];
              data["digilockerVerify"] = data["kra_verify"];
              data["digilockerVerifyTime"] = data["kra_verifytime"];
            }
            axiosThis.btmdata = data;
console.log("axiosThis.btmdata",axiosThis.btmdata);

            let datas = JSON.stringify({
              reason: "",
              log: "",
              type_of_page : this.tab > 2 ? "com" : ""  

            });

            let config = {
              method: "post",
              url: `${apidkyc}/stage_update?mobileNo=${item.mobile_no}`,
              headers: {
                "Content-Type": "application/json",
              },
              data: datas,
            };

            axios
              .request(config)
              .then((response) => {
                if (Object.keys(response.data).length > 1) {
                  if ((data.verif != "KRA" && item.app_status == "re-e-signed completed") || item.app_status == "e-signed completed" || item.app_status == "Manually updated" || item.app_status == "approved") {
                    axiosThis.getKraDetails(axiosThis.btmdata);
                  }

                  axiosThis.stagewise = response.data;
                  axiosThis.btmltab = 0;
                  axiosThis.btmrtab = 0;
                  axiosThis.btmsheet = true;
                  axiosThis.stageFind();
                  if (axiosThis.kraform) {
                    axiosThis.btmltab = 11;
                    axiosThis.btmrtab = 7;
                  }
                }
                axiosThis.kraform = null;
                axiosThis.bottomload = false;
              })
              .catch((error) => {
                console.log(error);
                axiosThis.bottomload = false;
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "#FF1717";
                axiosThis.snackmsgbar = error.message ? error.message : error;
              });
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    getKraDetails(v) {
      let data = JSON.stringify({
        dob: `${v.adhar_dob.slice(0, 2)}/${v.adhar_dob.slice(3, 5)}/${v.adhar_dob.slice(6)}`,
        pan: v.client_pan,
      });

      let config = {
        method: "post",
        url: `${apikra}kra/getKRAPANDetails`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data && response.data.personal_details && response.data.personal_details.KYC_STATUS != "NO DATA FOUND") {
            axiosThis.btmdata["kradata"] = response.data;
          } else {
            axiosThis.btmdata["kradata"] = "";
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? `KRA service; ${error.message}` : `KRA service; ${error}`;
        });
    },
    delSingledata(item) {
      this.deldialog = true;
      this.btmdata = item;
      setTimeout(() => this.$refs.delrj.$refs.input.focus(), 100);
      this.$refs.formd.reset();
    },
    setDelete() {
      if (this.$refs.formd.validate() == true) {
        this.delbtn = true;
        if (this.ipaddress && this.geolocation && this.uuid) {
          let data = JSON.stringify({
            mobile: this.btmdata.mobile_no,
            log: this.getGenlogs(this.delrejectreason, {type: "delete"}),
          });

          let config = {
            method: "post",
            url: `${apidkyc}/deletebtn`,
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };
          let axiosThis = this;
          axios
            .request(config)
            .then((response) => {
              if (response.data) {
                axiosThis.deldialog = false;
                axiosThis.btmsheet = false;
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "#2a2a2a";
                axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
                axiosThis.btmdata = [];
                axiosThis.getDashboard();
              }
              axiosThis.delbtn = false;
            })
            .catch((error) => {
              console.log(error);
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#FF1717";
              axiosThis.snackmsgbar = error.message ? error.message : error;
              axiosThis.delbtn = false;
            });
        } else {
          this.snackbar = true;
          this.snackbarclr = "#FF1717";
          this.snackmsgbar = "Your log data is missing for delection.";
          this.deldialog = false;
          this.btmsheet = false;
          this.btmdata = [];
          this.delbtn = false;
        }
      }
    },
    statusChange() {
      // if (this.status && this.request) {
      //   let fstdata = this.dashboarddata.filter((obj) => {
      //     return obj.app_status === this.status;
      //   });
      //   let secdata = fstdata.filter((obj) => {
      //     return obj.request === this.request;
      //   });
      //   this.showdata = secdata;
      // } else if (this.status) {
      //   this.showdata = this.dashboarddata.filter((obj) => {
      //     return this.status == "e-signed pending" ? ["e-signed pending", "re-e-signed pending"].includes(obj.app_status) : this.status == "e-signed completed" ? ["re-e-signed completed", "e-signed completed"].includes(obj.app_status) : obj.app_status === this.status;
      //   });
      // } else {
      // }
        this.showdata = this.dashboarddata;

    },
getAppfilter() {
  const staticOrder = [
    "e-signed pending",
    "re-e-signed pending",
    "e-signed completed",
    "re-e-signed completed",
    "segment",
    "selfie",
    "pan",
    "panproof",
    "signature",
    "digilocker",
    "personal",
    "KRA",
    "email",
    "bank",
    "nominee",
    "bankproof",
    "verification"
  ];

  // const foundStatuses = new Set(
  //   this.dashboarddata.map(item => item.app_status)
  // );

  return staticOrder
},


    requestChange() {
      if (this.request && this.status) {
        let fstdata = this.dashboarddata.filter((obj) => {
          return obj.request === this.request;
        });
        let secdata = fstdata.filter((obj) => {
          return obj.app_status === this.status;
        });
        this.showdata = secdata;
      } else if (this.request) {
        this.showdata = this.dashboarddata.filter((obj) => {
          return obj.request === this.request;
        });
      } else {
        this.showdata = this.dashboarddata;
      }
    },
    setTypedata() {
      this.alldate = "";
      this.dateSelect2 = new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate()).toISOString().slice(0, 10);
      this.dateSelectto = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).toISOString().slice(0, 10);
      this.search = null;
      this.status = ["e-signed completed","re-e-signed completed"];
      this.page = 1
      this.dayCustom();
      localStorage.setItem("latstable", this.tab);
    },
    setComplete() {
      this.completebtn = true;
      let data = JSON.stringify({
        status: "approved",
        mobileNo: this.btmdata.mobile_no,
        rejected_reason: "",
        branch_id:this.branchid,
        log: this.getGenlogs("", {type: "complete"}),
        rm_code : this.rmcoden,
        referal_code : this.refrelcoden,
        remisier_code : this.remisiercoden,
        terminal_id: this.terminalidd
      });

      let config = {
        method: "post",
        url: `${apidkyc}/status_update`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data) {
            axiosThis.comdialog = false;
            axiosThis.btmsheet = false;
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#2a2a2a";
            axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
            axiosThis.btmdata = [];
            // axiosThis.tab = 1;
            axiosThis.getDashboard();
          }
          axiosThis.completebtn = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.completebtn = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    bfoRejection() {
      this.rejectreason = "";
      this.rejdialog = true;
      setTimeout(() => this.$refs.reje.$refs.input.focus(), 100);
      this.$refs.form.reset();
    },
    setReject() {
      if (this.$refs.form.validate() == true) {
        this.rejbtn = true;
        let data = JSON.stringify({
          status: "rejected",
          mobileNo: this.btmdata.mobile_no,
          rejected_reason: this.rejectreason,
          rejection_type: this.btmdata.request,
          log: this.getGenlogs(this.rejectreason, {type: "reject"}),
        });

        let config = {
          method: "post",
          url: `${apidkyc}/status_update`,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        let axiosThis = this;
        axios
          .request(config)
          .then((response) => {
            if (response.data) {
              axiosThis.rejdialog = false;
              axiosThis.btmsheet = false;
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#2a2a2a";
              axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
              axiosThis.btmdata = [];
              axiosThis.getDashboard();
            }
            axiosThis.rejbtn = false;
          })
          .catch((error) => {
            console.log(error);
            axiosThis.rejbtn = false;
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = error.message ? error.message : error;
          });
      }
    },
    bfoManual(item) {
      this.mandialog = true;
      this.btmdata = item;
      setTimeout(() => this.$refs.mane.$refs.input.focus(), 100);
      this.$refs.formm.reset();
    },
    setManual() {
      if (this.$refs.formm.validate() == true) {
        this.manbtn = true;
        this.btmdata.data_type["app_status"] = "Manually updated";
        this.btmdata.data_type["manually_res"] = this.manreason;
        let data = JSON.stringify({
          mobileNo: this.btmdata.mobile_no,
          manual_reason: this.manreason,
          data_type: this.btmdata.data_type,
          log: this.getGenlogs(this.manreason, {type: "man up"}),
        });

        let config = {
          method: "post",
          url: `${apikra}backoffice/reviewcompleted`,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        let axiosThis = this;
        axios
          .request(config)
          .then((response) => {
            if (response.data) {
              axiosThis.mandialog = false;
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = response.data.msg == "successfully updated" ? "#43A833" : "#2a2a2a";
              axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
              axiosThis.btmdata = [];
              axiosThis.getDashboard();
            }
            axiosThis.manbtn = false;
          })
          .catch((error) => {
            console.log(error);
            axiosThis.manbtn = false;
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = error.message ? error.message : error;
          });
      }
    },
    setUCCgen(item) {
      this.bottomload = true;
      let data = JSON.stringify({
        clientId: item.client_id,
      });

      let config = {
        method: "post",
        url: `${apikra}ucc/UCCGen`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          if (res.data && res.data.msg && res.data.msg.Status) {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#2a2a2a";
            axiosThis.snackmsgbar = res.data.msg.Remarks ? res.data.msg.Remarks : res.data.msg;
            axiosThis.getDashboard();
            axiosThis.bottomload = false;
            // let data = JSON.stringify({
            //   "mfcompleted": res.data.msg.Status
            // });

            // let config = {
            //   method: 'post',
            //   url: `${apiekyc}/getstart?mob=${item.mobile_no}&type=add`,
            //   headers: {
            //     'Content-Type': 'application/json'
            //   },
            //   data: data
            // };

            // axios.request(config)
            //   .then(() => {
            //     axiosThis.snackbar = true;
            //     axiosThis.snackbarclr = '#2a2a2a';
            //     axiosThis.snackmsgbar = res.data.msg.Remarks ? res.data.msg.Remarks : res.data.msg;
            //     axiosThis.getDashboard();
            //     axiosThis.bottomload = false;
            //   })
            //   .catch((error) => {
            //     console.log(error);
            //     axiosThis.bottomload = false;
            //     axiosThis.snackbar = true;
            //     axiosThis.snackbarclr = '#2a2a2a';
            //     axiosThis.snackmsgbar = error;
            //   });
          } else {
            axiosThis.bottomload = false;
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#2a2a2a";
            axiosThis.snackmsgbar = res.data.msg ? res.data.msg : res.data;
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#2a2a2a";
          axiosThis.snackmsgbar = error;
        });
    },
    setStamppaper(item) {
      this.bottomload = true;

      let data = JSON.stringify({
        mobile_no: item.mobile_no,
      });

      let config = {
        method: "post",
        url: `${apidkyc}/ddpi_mail`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "warning";
          axiosThis.snackmsgbar = res.data.msg ? res.data.msg : res.data;

          // if (res.data && res.data.status && res.data.status == "success") {
          //   axiosThis.snackbarclr = "success";
          //   axiosThis.snackmsgbar = res.data.msg ? res.data.msg : res.data;
          //   axiosThis.getDashboard();
          // } else {
          //   axiosThis.snackbarclr = "warning";
          //   axiosThis.snackmsgbar = res.data.msg ? res.data.msg : res.data;
          // }
          axiosThis.bottomload = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#2a2a2a";
          axiosThis.snackmsgbar = error;
        });
    },
    // setExchjson(item, exch) {
    //   console.log(item, exch);

    //   let config = {
    //     method: "post",
    //     // url: `${apiexkyc}/EditJsonUCC/${item.mobile_no}`,
    //     url: `${apiexkyc}/EditJsonUCC/8939829123`,
    //     headers: {},
    //   };

    //   let axiosThis = this;
    //   axios
    //     .request(config)
    //     .then((res) => {
    //       console.log(res.data.msg[0]);
    //       if (res.data && res.data.msg && res.data.msg[0]) {
    //         axiosThis.responsdialog = true;
    //         axiosThis.respdialogmode = "ex";
    //         axiosThis.responsdatas = res.data.msg[0];
    //         axiosThis.btmdata = item;
    //         axiosThis.btmdata["exch"] = exch;
    //       } else {
    //         axiosThis.snackbar = true;
    //         axiosThis.snackbarclr = "#2a2a2a";
    //         axiosThis.snackmsgbar = res.data && res.data.msg ? res.data.msg : res.data;
    //       }
    //       axiosThis.bottomload = false;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       axiosThis.snackbar = true;
    //       axiosThis.snackbarclr = "#2a2a2a";
    //       axiosThis.snackmsgbar = error;
    //       axiosThis.bottomload = false;
    //     });
    // },
    getUserPDstat(item) {
      this.bottomload = true;
      let data = JSON.stringify({
        mobile: item.mobile_no,
      });

      let config = {
        method: "post",
        url: `${apidkyc}/backstatuscheck`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          var w = res.data.data;
          axiosThis.snackbar = true;
          if (w && w.status == "completed") {
            axiosThis.snackbarclr = "success";
            axiosThis.snackmsgbar = w.status;
            axiosThis.getSingledata(axiosThis.btmdata);
          } else {
            axiosThis.snackbarclr = "warning";
            axiosThis.snackmsgbar = w && w.status ? w.status : res.data.msg ? res.data.msg : res.data;
            axiosThis.bottomload = false;
          }
        })
        .catch((error) => {
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackmsgbar = error;
          axiosThis.snackbarclr = "error";
        });
    },
    setExchange(item, exch) {
      this.bottomload = true;
      // if (flow) {
      this.completebtn = true;
      let config = {
        method: "post",
        url: `${apiexkyc}/${exch == "nse" ? (this.protype ? "manualNseUCCkyc" : "nseUCCkyc") : exch == "bse" ? (this.protype ? "manualBseUCCkyc" : "bseUCCkyc") : exch == "mcx" ? (this.protype ? "manualMcxUCCkyc" : "mcxUCCkyc") : ""}/${item.mobile_no}`,
        headers: {"Content-Type": "application/json"},
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          console.log(JSON.stringify(res.data));
          axiosThis.snackbar = true;
          if (res.data && res.data.success == true) {
            axiosThis.snackbarclr = "#43A833";
            axiosThis.getDashboard();
          } else {
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.bottomload = false;
          }
          axiosThis.responsdialog = false;
          axiosThis.respdialogmode = "";
          axiosThis.responsdatas = [];
          axiosThis.completebtn = false;
          axiosThis.btmdata = [];
          axiosThis.snackmsgbar = res.data.msg ? res.data.msg : res.data;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#2a2a2a";
          axiosThis.snackmsgbar = error;
          axiosThis.completebtn = false;
          axiosThis.bottomload = false;
        });
      // } else {
      //   this.setExchjson(item, exch);
      // }
    },
    setKRAvalidation(item) {
      this.krastatdata = []
      this.karstatupmob = item.mobile_no
      this.bottomload = true;
      let config = {
        method: "post",
        url: `${apikra}kra/SolicitPANDetailsFetchALLKRA?mobile=${item.mobile_no}${this.tab == 1 ? "&pending=True" : ""}`,
        headers: {},
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          let kra = res.data;
axiosThis.krastatdata = res.data
          if (kra && kra.kra_status && kra.old && kra.new) {
            var raw = [];
            axiosThis.btmdata = item;
            axiosThis.btmdata["valid"] = [];

            if (kra.kra != "1") {
              for (const [key, value] of Object.entries(kra.new)) {
                var ee = [];
                for (const [keys, values] of Object.entries(value)) {
                  var m = (kra.old[key] && kra.old[key][keys] ? kra.old[key][keys] : "") == values ? 1 : 0;
                  ee[keys] = [values, kra.old[key] && kra.old[key][keys] ? kra.old[key][keys] : "", m, m == 1 ? true : false, m == 1 ? 0 : null];
                  if (m != 1) {
                    axiosThis.btmdata.valid.push(keys);
                  }
                }
                raw[key] = {...ee};
              }
              axiosThis.cor_addr = {...raw.cor_addr};
              axiosThis.per_addr = {...raw.per_addr};
              axiosThis.per_details = {...raw.personal_details};
              axiosThis.btmdata["item"] = item;
            } else {
              axiosThis.cor_addr = {};
              axiosThis.per_addr = {};
              axiosThis.per_details = {};
            }

            // axiosThis.el = 2;
            axiosThis.el = kra.complete_kra == "1" ? 4 : kra.kraDocumentUploaded == "1" ? 3 : kra.kra == "1" ? 2 : 1;
            axiosThis.btmdata["mode"] = Object.entries(kra.old.personal_details).length > 0 ? true : false;
            axiosThis.btmdata["reskra"] = kra;
            axiosThis.kradialog = true;
          } else {
            axiosThis.kradialog = false;
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "warning";
            axiosThis.snackmsgbar = kra.emsg ? kra.emsg : kra;
          }
          axiosThis.delbtn = false;
          axiosThis.bottomload = false;
        })
        .catch((error) => {
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#2a2a2a";
          axiosThis.snackmsgbar = error;
        });
    },

    setKRApushedit() {
      this.bottomload = true;
      this.delbtn = true;
      var kramodifi = this.btmdata.mode
        ? {
            kra_status: this.btmdata.reskra.kra_status,
            edit: {},
            old: this.btmdata.reskra.old,
            new: this.btmdata.reskra.new,
          }
        : {};

      if (this.btmdata.mode) {
        for (const [key, value] of Object.entries({cor_addr: this.cor_addr, per_addr: this.per_addr, personal_details: this.per_details})) {
          var ee = {};
          for (const [keys, values] of Object.entries(value)) {
            ee[keys] = values[values[4]] ? values[values[4]] : values[values[0]]  || "";
          }
          kramodifi["edit"][key] = {...ee};
        }
      }
      kramodifi["log"] = this.getGenlogs();
      let data = JSON.stringify(kramodifi);

      let config = {
        method: "post",
        url: `${apikra}kra/${this.btmdata.mode ? `newKRA?updatekra=true&mobile=${this.btmdata.mobile_no}` : `newKRA?mobile=${this.btmdata.mobile_no}`}${this.tab == 1 ? "&pending=true" : ""}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          if (res.data) {
            axiosThis.snackbarclr = "#2a2a2a";
            axiosThis.setKRAvalidation(axiosThis.btmdata.item);
          } else {
            axiosThis.delbtn = false;
            axiosThis.bottomload = false;
            axiosThis.snackbarclr = "warning";
          }
          axiosThis.snackbar = true;
          axiosThis.snackmsgbar = res.data;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.kradialog = false;
          axiosThis.delbtn = false;
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#2a2a2a";
          axiosThis.snackmsgbar = error;
        });
    },
    setUPloadKra() {
      this.bottomload = true;
      this.delbtn = true;

      let data = {log: this.getGenlogs()};

      let config = {
        method: "post",
       url: `${apikra}kra/cvlkra_upload_sftp/${this.btmdata.mobile_no}${this.tab == 1 ? "?pending=true" : ""}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          if (res.data && res.data.success == true) {
            axiosThis.snackbarclr = "success";
            axiosThis.setKRAvalidation(this.tab == 1 ? axiosThis.btmdata : axiosThis.btmdata.item);
          } else {
            axiosThis.delbtn = false;
            axiosThis.bottomload = false;
            axiosThis.snackbarclr = "warning";
          }
          axiosThis.snackbar = true;

          axiosThis.snackmsgbar = res.data && res.data.msg ? res.data.msg : res.data;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.kradialog = false;
          axiosThis.delbtn = false;
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "error";
          axiosThis.snackmsgbar = error;
        });
    },

    setKRAfiledchanges(key, index, n, type) {
      if (type == 0) {
        this.$set(this.cor_addr, key, n);
        this.cor_addr[key] = [...n];
      } else if (type == 1) {
        this.$set(this.per_addr, key, n);
        this.per_addr[key] = [...n];
      } else if (type == 2) {
        this.$set(this.per_details, key, n);
        this.per_details[key] = [...n];
      }
      if (key == "all") {
        Object.keys(this.cor_addr).forEach((i) => {
          this.cor_addr[i][4] = index;
          this.cor_addr[i] = [...this.cor_addr[i]];
        });
        Object.keys(this.per_addr).forEach((i) => {
          this.per_addr[i][4] = index;
          this.per_addr[i] = [...this.per_addr[i]];
        });
        Object.keys(this.per_details).forEach((i) => {
          this.per_details[i][4] = index;
          this.per_details[i] = [...this.per_details[i]];
        });
        this.btmdata.valid = [];
      }
      if (key != "all" && this.btmdata.valid.includes(key) && n && n[4] >= 0) {
        this.btmdata.valid.splice(this.btmdata.valid.indexOf(key), 1);
      }
    },
    async getPublicIP() {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        this.ipaddress = data.ip;
      } catch (error) {
        console.error(error);
        this.ipaddress = null;
      }
    },
    showPosition(position) {
      this.geolocation = `La: ${position.coords.latitude}, Lo: ${position.coords.longitude}, ac: ${position.coords.accuracy}`;
    },
    dateClear() {
      this.alldate = "";
      this.dateSelect2 = "";
      this.dateSelectto = "";
      this.getDashboard();
    },
    dayCustom() {
      let dateis = `${new Date(this.dateSelect2).toDateString().slice(3)} ${new Date(this.dateSelect2).toLocaleString("en-US", {hour: "numeric", minute: "numeric", hour12: true})}`;
      let dateto = `${new Date(this.dateSelectto).toDateString().slice(3)} ${new Date(this.dateSelectto).toLocaleString("en-US", {hour: "numeric", minute: "numeric", hour12: true})}`;
      this.alldate = `${dateis.slice(0, 7)} ~ ${dateto.slice(0, 12)}`;
      this.getDashboard();
    },
    getemaildata() {
      this.delbtn = true;

      let oconfig = {
        method: "post",
        url: `${apidkyc}/${this.tab < 3 ? "viewdata" : "viewdataCompleted"}?mobileNo=${this.emailmobile}&row_index=0&view_type=${this.tab == 0 || this.tab == 1 || this.tab == 2 ? "view" : "complete"}`,
        headers: {
          "Content-Type": "application/json",
        },
      };
      let axiosThis = this;

      axios
        .request(oconfig)
        .then((response) => {
          if (Object.keys(response.data).length > 1) {
            axiosThis.btmdata = response.data;
          } else {
            axiosThis.btmdata = [];
          }
          axiosThis.delbtn = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.delbtn = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    setSinglemail() {
      this.delbtn = true;
      let data = JSON.stringify({
        mobile: this.btmdata.mobile_no,
        msg: this.emailmsg,
        status: this.emailstatus ? "approved" : "rejected",
      });

      let config = {
        method: "post",
        url: `${apidkyc}/mail_sent`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          axiosThis.delbtn = false;

          axiosThis.snackbar = true;
          axiosThis.snackbarclr = response.data.msg == "mail send success" ? "#43A833" : "#FF1717";
          axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
          axiosThis.emaildialog = false;
          axiosThis.btmdata = [];
          axiosThis.emailmsg = null;
          axiosThis.emailstatus = false;
          axiosThis.emailmobile = null;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    downloadFile(type) {
      if (type == "comxls") {
        this.mainloader = true;
        let config = {
          method: "get",
          url: `${apidkyc}/colums_list_data`,
        };

        let axiosThis = this;
        axios
          .request(config)
          .then((res) => {
            console.log("commmmmmm");

            if (res.data && res.data.msg && res.data.msg.length > 0) {
              axiosThis.downloadcolumns = res.data.msg;

              axiosThis.downloadcolumns.splice(axiosThis.downloadcolumns.indexOf("percent_feild1"), 1, "Nominee1_percent");
              axiosThis.downloadcolumns.splice(axiosThis.downloadcolumns.indexOf("percent_feild2"), 1, "Nominee2_percent");
              axiosThis.downloadcolumns.splice(axiosThis.downloadcolumns.indexOf("percent_feild3"), 1, "Nominee3_percent");

              axiosThis.columndialog = true;
            } else {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#FF1717";
              axiosThis.snackmsgbar = res.data.msg ? res.data.msg : res.data;
              axiosThis.downloadFile("xls");
            }
            axiosThis.colushowdata = ['clientcode' , 'pan' , 'name' , 'rmcode', 'email_time_after_esign','kra_code' , 'log' , 'BO_created_datetime','approved_datetime'];
            axiosThis.mainloader = false;
          })
          .catch((error) => {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = error;
            axiosThis.mainloader = false;
            axiosThis.downloadFile("xls");
            console.log(error);
          });
      } else if (type == "column") {
        this.delbtn = true;
        this.mainloader = true;
        if (this.colushowdata.indexOf("clientcode") == -1) {
          this.colushowdata.unshift("clientcode");
        }

        if (this.colushowdata.indexOf("Nominee1_percent") >= 0) {
          this.colushowdata.splice(this.colushowdata.indexOf("Nominee1_percent"), 1, "percent_feild1");
        }
        if (this.colushowdata.indexOf("Nominee2_percent") >= 0) {
          this.colushowdata.splice(this.colushowdata.indexOf("Nominee2_percent"), 1, "percent_feild2");
        }
        if (this.colushowdata.indexOf("Nominee3_percent") >= 0) {
          this.colushowdata.splice(this.colushowdata.indexOf("Nominee3_percent"), 1, "percent_feild3");
        }

        let config = {
          method: "post",
          url: `${apidkyc}/colums_list_json${this.tab == 0 || this.tab == 1 || this.tab == 2 ? '?view=true':''}`,
          data: {columns: this.colushowdata, from: this.dateSelect2, to: this.dateSelectto , filter:this.status},

        };

        let axiosThis = this;
        axios
          .request(config)
          .then((res) => {
            console.log("commmmmmm222");

            if (res.data && res.data.msg && res.data.msg.length > 0) {
              var data = res.data.msg;

              if (data && axiosThis.colushowdata.indexOf("declaration") >= 0) {
                for (let f = 0; f < data.length; f++) {
                  for (const [key, value] of Object.entries(data[f].declaration)) {
                    if (key == "standing_instructions") {
                      for (const [keys, values] of Object.entries(data[f].declaration[key])) {
                        data[f][keys] = values;
                      }
                    } else {
                      data[f][key] = value;
                    }
                  }
                }
              }

              var fileName = `Complete_report${new Date().toLocaleString()}`;
              const exportType = exportFromJSON.types.csv;

              if (data) exportFromJSON({data, fileName, exportType});

              axiosThis.downloadcolumns = [];
              axiosThis.columndialog = false;
            } else {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#FF1717";
              axiosThis.snackmsgbar = res.data.msg ? res.data.msg : res.data;
            }
            axiosThis.delbtn = false;
            axiosThis.mainloader = false;
          })
          .catch((error) => {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = error;
            axiosThis.delbtn = false;
            axiosThis.mainloader = false;
          });
      } else if (type == "viewxls") {
        this.mainloader = true;
        let config = {
          method: "get",
          url: `${apidkyc}/colums_list_data`,
        };

        let axiosThis = this;
        axios
          .request(config)
          .then((res) => {
            console.log("commmmmmm3333333333333");

            if (res.data && res.data.msg && res.data.msg.length > 0) {
              axiosThis.downloadcolumns = res.data.msg;

              axiosThis.downloadcolumns.splice(axiosThis.downloadcolumns.indexOf("percent_feild1"), 1, "Nominee1_percent");
              axiosThis.downloadcolumns.splice(axiosThis.downloadcolumns.indexOf("percent_feild2"), 1, "Nominee2_percent");
              axiosThis.downloadcolumns.splice(axiosThis.downloadcolumns.indexOf("percent_feild3"), 1, "Nominee3_percent");

              axiosThis.columndialog = true;
            } else {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#FF1717";
              axiosThis.snackmsgbar = res.data.msg ? res.data.msg : res.data;
              axiosThis.downloadFile("xls");
            }
            axiosThis.colushowdata = ['clientcode' , 'pan' , 'name' , 'rmcode', 'email_time_after_esign','kra_code','segment'];
            axiosThis.mainloader = false;
          })
          .catch((error) => {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = error;
            axiosThis.mainloader = false;
            axiosThis.downloadFile("xls");
            console.log(error);
          });
      } else if (type == "columnview") {
        this.delbtn = true;
        this.mainloader = true;
        if (this.colushowdata.indexOf("clientcode") == -1) {
          this.colushowdata.unshift("clientcode");
        }

        if (this.colushowdata.indexOf("Nominee1_percent") >= 0) {
          this.colushowdata.splice(this.colushowdata.indexOf("Nominee1_percent"), 1, "percent_feild1");
        }
        if (this.colushowdata.indexOf("Nominee2_percent") >= 0) {
          this.colushowdata.splice(this.colushowdata.indexOf("Nominee2_percent"), 1, "percent_feild2");
        }
        if (this.colushowdata.indexOf("Nominee3_percent") >= 0) {
          this.colushowdata.splice(this.colushowdata.indexOf("Nominee3_percent"), 1, "percent_feild3");
        }

        let config = {
          method: "post",
          url: `${apidkyc}/colums_list_json${this.tab == 0 || this.tab == 1 || this.tab == 2 ? '?view=true':''}`,
          data: {columns: this.colushowdata, from: this.dateSelect2, to: this.dateSelectto ,filter:this.status
},
          

        };

        let axiosThis = this;
        axios
          .request(config)
          .then((res) => {
            if (res.data && res.data.msg && res.data.msg.length > 0) {
              var data = res.data.msg;

              if (data && axiosThis.colushowdata.indexOf("declaration") >= 0) {
                for (let f = 0; f < data.length; f++) {
                  for (const [key, value] of Object.entries(data[f].declaration)) {
                    if (key == "standing_instructions") {
                      for (const [keys, values] of Object.entries(data[f].declaration[key])) {
                        data[f][keys] = values;
                      }
                    } else {
                      data[f][key] = value;
                    }
                  }
                }
              }

              var fileName = `View_Report${new Date().toLocaleString()}`;
              const exportType = exportFromJSON.types.csv;

              if (data) exportFromJSON({data, fileName, exportType});

              axiosThis.downloadcolumns = [];
              axiosThis.columndialog = false;
            } else {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#FF1717";
              axiosThis.snackmsgbar = res.data.msg ? res.data.msg : res.data;
            }
            axiosThis.delbtn = false;
            axiosThis.mainloader = false;
          })
          .catch((error) => {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = error;
            axiosThis.delbtn = false;
            axiosThis.mainloader = false;
          });
      } else {
      console.log("elseeeeee");

      
        let data;
        let fileName;
        if (type == "single") {
      console.log("elseeeeee --- iffff" );

          data = [this.btmdata];
          delete data[0].aadharxmlfile;
          delete data[0].adhar_file;
          delete data[0].adhar_image;
          delete data[0].adharimg;
          delete data[0].clientimage;
          delete data[0].data_type;
          delete data[0].e_signed_pdf_path;
          delete data[0].uploadBankproof;
          delete data[0].uploadFinancialproof;
          delete data[0].uploadPAN;
          delete data[0].uploadSignature;
          delete data[0].stage_wise_approval;
          fileName = `${this.btmdata.mobile_no}_${this.btmdata.client_id}_${this.btmdata.client_pan}`;
        } 
        
        else {
          let data = [];
          let fileName = "";   

if (this.tab == 1) {
 
  console.log("tabbb111");
  
  for (let t = 0; t < this.showdata.length; t++) {
    const element = this.showdata[t];
    data.push({
      "app_status": element.app_status,
      "Client Id": element.client_id,
      "client_name": element.client_name,
      "Approved Date": element.approved_datetime,
      "client_pan": element.client_pan,
      "dpid": element.dpid,
      "Esign Date": element.email_time_after_esign,
      "segment": element.segment,
      "instabo_status": element.instabo_status,
      "exchange": element.exchange,
      "rmcode": element.rmcode,
      "Kra type":element.data_type.kra
    });
  }
} 

else if(this.tab ==2){
  console.log("tabbb 2");

  for (let t = 0; t < this.showdata.length; t++) {
    const element = this.showdata[t];
    data.push({
      "Client Code": element.app_status,
      "Pan": element.client_id,
      "client_name": element.client_name,
      "rmcode": element.rmcode,
      "Kra type":element.data_type.kra,
      "Date of Initiated": element.date_time,
      "Esign Date": element.email_time_after_esign,

      "Date of rejected": element.rejection_date_time,
    });
  }
  
}


else {
  console.log("elseeeeee - elseeeee");
  data = this.showdata;
}

fileName = `${
  this.tab == 0
    ? "view"
    : this.tab == 1
    ? "Complete"
    : this.tab == 2
    ? "Reject"
    : "file"
}${this.alldate ? `_${this.alldate}` : ""}${this.status ? `_${this.status}` : ""}`;

// Export to CSV
const exportType = exportFromJSON.types.csv;
if (data && data.length) {
  exportFromJSON({ data, fileName, exportType });
} else {
  console.warn("No data to export");
}

}

        const exportType = exportFromJSON.types.csv;

        if (data) exportFromJSON({data, fileName, exportType});
      }
    },
    getGenlogs(reason, data) {
      var today = new Date();
      var date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = date + " " + time;
      // var dateTime = new Date().toLocaleString("en-GB");
      var raw = {datetime: dateTime, IP_address: this.ipaddress, browser: navigator.appCodeName, Location: this.geolocation, emp_emailid: this.uemail, emp_ID: this.uuid, reason: reason ? reason : ""};
      var combo = data ? {...data, ...raw} : raw;
      return combo;
    },
    revertkrastatus(){
      this.krareverload = true
      const axios = require('axios');
      let data = JSON.stringify({
        log: this.getGenlogs(),
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apikra}kra/updateKRA_again?mobile=${this.karstatupmob}${this.tab == 1 ? "&pending=true" : ''}`,
        headers: { 
          'Content-Type': 'application/json'
        },
        data : data
      };
      var axiosThis = this
      axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        axiosThis.krareverload = false
        axiosThis.snackbar = true;
            axiosThis.snackbarclr = "green";
            axiosThis.snackmsgbar = response.data.msg;
            axiosThis.dialogkraconf = false
axiosThis.kradialog = false
      })
      .catch((error) => {
        console.log(error);
        axiosThis.krareverload = false
        axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = error;
            axiosThis.dialogkraconf = false
axiosThis.kradialog = false


      });

    },
    isDisabled(item) {
          // console.log("irir",item.client_pan);
          
    // const item = this.item;
// console.log("fbjkfd",item);

    const changesComplete = item.changes === 'reviewcomplete' || item.changes === 'manualcomplete';
    const cdslComplete = item.CDSLComplete === '1';
    // const cdslResponseExists =
      // typeof item.CDSLResponse === 'object'
      //   ? Object.keys(item.CDSLResponse).length !== 0
      //   : item.CDSLResponse !== '';
    const isFno = item.segment === 'F&O';

    let autoPushValid = false;
    if (typeof item.auto_push_resp === 'object' && item.auto_push_resp !== null) {
      // console.log("iffff inside",typeof item.auto_push_resp === 'object' && item.auto_push_resp !== null);
      
      autoPushValid = Object.keys(item.auto_push_resp).length !== 0 && item.auto_push_resp.auto_push_process === true;
      console.log("dkjd",autoPushValid);
      
    } else {
      // console.log("elsweereee inside");

      autoPushValid = item.auto_push_resp !== '';
    }

    return (changesComplete && cdslComplete  && isFno ) ||autoPushValid;
},
isBtnEnabled(item,type_item) {
    if (this.protype) {
      // When protype is true
      if (type_item == "cdslapi"){
          return item.changes !== 'reviewcomplete' && item.changes !== 'manualcomplete';
      }else if(type_item == "cdsl"){
        return item.changes != 'reviewcomplete' && item.changes != 'manualcomplete' 
      }else if(type_item == "backoffice"){
        return item.segment == 'Commodity' ? true :  (item.changes != 'reviewcomplete' || item.changes != 'manualcomplete') 
      }
      
    } else {
       if (typeof item.auto_push_resp === 'object' && item.auto_push_resp !== null) {
       var newauotpush = Object.keys(item.auto_push_resp).length !== 0 && item.auto_push_resp.auto_push_process === true;
        if(newauotpush == true){
          return false
        }
       }
    if  (type_item == "cdslapi"){
    return (typeof item.CDSLResponse == 'object' 
        ? Object.keys(item.CDSLResponse).length == 0 
        : item.CDSLResponse == '') 
      && item.CDSLComplete == '' 
      && item.changes != 'reviewcomplete' ;}
      else if(type_item == "cdsl"){
        return (typeof item.CDSLResponse === 'object' ? Object.keys(item.CDSLResponse).length !== 0 :  item.CDSLResponse != '') && item.CDSLComplete === '' && item.changes !== 'reviewcomplete'
      }else if(type_item == "backoffice"){
        return item.segment == 'Commodity' ? true : (item.CDSLComplete == '1' && item.changes != 'reviewcomplete' && item.data_type.rekyc != 'Yes')
      }
    }
  },

  cdsl_signdata(){
    console.log(this.btmdata.mobile_no)
this.bosigload = true
    const axios = require('axios');
      let data = JSON.stringify({
        "mobile": this.btmdata.mobile_no
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: apikra + 'cdsl/cdsl_signature_resend',
        headers: { 
          'Content-Type': 'application/json'
        },
        data : data
      };
var axiosThis = this
      axios.request(config)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
axiosThis.bosigload = false
        if(response.data.msg == 'Signature resend success'){
          axiosThis.bocodisabled = true
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "green";
            axiosThis.snackmsgbar = response.data.msg;
        }else{
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "red";
            axiosThis.snackmsgbar = response.data.msg;
        }
      })
      .catch((error) => {
        console.log(error);
          axiosThis.bosigload = false
          axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = error.response.data.msg ? error.response.data.msg : error;
            // console.log("errr",error);
            // console.log("errr",error.response.data);
            // console.log("errr",error.response.data.msg);

            
      });

  }
  
  },
  computed: {
    itemsWithSno() {
      return this.showdata.map((d, index) => ({...d, sno: index + 1}));
    },
    // status box of the re-active CDSL check dialog: the first matching case wins
    cdslChkStatus() {
      const d = this.cdslchkdata || {};
      const details = this.cdslChkNote(d.reason || d.msg || d.error || "");
      const red = (text, extra) => ({color: "error", text, details: extra === undefined ? details : extra, canPush: false});
      if (this.cdslchkerror || d.stat == "Not_ok") return red("Couldn't check this client right now. Please try again in a moment.", this.cdslchkerror ? this.cdslChkNote(this.cdslchkerror) : details);
      const boids = Array.isArray(d.boids_in_back_office) ? d.boids_in_back_office : [];
      if (d.flow == "Blocked") {
        if (!boids.length) return red("Can't send to CDSL: back office has no CDSL demat account (BOID starting 12080400) for this client.");
        if (boids.length > 1) return red(`Can't send to CDSL: back office has more than one CDSL demat account for this client (${boids.join(", ")}). Back office has to be corrected first.`);
        return red("Can't send to CDSL: the PAN the client gave doesn't match the PAN in back office.");
      }
      if (d.rekyc === false) return {color: "info", text: "This is not a re-active client. Complete CDSL will open the CDSL account as usual.", details: "", canPush: true};
      if (d.flow == "BO Setup") {
        if (!d.boid) return {color: "info", text: "The client has no CDSL demat account and no NSE or BSE cash segment in back office, so Complete CDSL will send the full account set-up to CDSL, the same as for a new client.", details: "", canPush: true};
        return {color: "info", text: `The client has no NSE or BSE cash segment in back office, so Complete CDSL will send the full account set-up to CDSL using the existing demat ID ${d.boid || "—"}. The table below is for information only.`, details: "", canPush: true};
      }
      if (d.flow == "BO Modify") {
        const amber = (text) => ({color: "amber darken-3", text, details, canPush: false});
        if (!d.eligible_for_bo_modify) {
          if (d.e_signed === false) return amber("The client's existing CDSL account can only be updated after the application is e-signed. It isn't e-signed yet.");
          return amber("The client's CDSL account can't be updated right now.");
        }
        const fields = Array.isArray(d.fields_to_send) ? d.fields_to_send : [];
        if (fields.length) return {color: "success", text: `The client's existing CDSL account will be updated. Only these details will change at CDSL: ${fields.join(", ")}. Everything else stays as it is.`, details: "", canPush: true};
        return {color: "success", text: "Nothing has changed compared to back office. Complete CDSL will mark CDSL as done; nothing will be sent to CDSL.", details: "", canPush: true};
      }
      return {color: "grey darken-1", text: "Can't decide what to send for this client.", details, canPush: false};
    },
    cdslChkSummary() {
      const d = this.cdslchkdata || {};
      const cash = d.cash_segment && typeof d.cash_segment === "object" ? d.cash_segment : {};
      return [
        {label: "Client ID", value: d.client_id || this.cdslchkitem.client_id || "—"},
        {label: "PAN", value: d.pan || "—"},
        {label: "Demat ID", value: d.boid || "—"},
        {label: "NSE Cash", value: this.cdslChkCash(cash.NSE_CASH)},
        {label: "BSE Cash", value: this.cdslChkCash(cash.BSE_CASH)},
      ];
    },
    // labels of every detail that differs from back office; null when the check gave no list (hides the line)
    // a Blocked client can't go to CDSL at all, so the dialog shows only the red box and the summary row
    cdslChkBlocked() {
      return !!(this.cdslchkdata && this.cdslchkdata.flow == "Blocked");
    },
    cdslChkChanged() {
      const c = this.cdslchkdata && this.cdslchkdata.changed_fields;
      return Array.isArray(c) ? c.filter((x) => !this.cdslChkEmpty(x)) : null;
    },
    // to_cdsl sections ready to render: action chip colour, "{meaning} ({value})" values, and a plain sentence for a
    // nominee deletion that only carries the nominee number
    cdslChkToCdsl() {
      const list = this.cdslchkdata && this.cdslchkdata.to_cdsl;
      if (!Array.isArray(list)) return [];
      return list
        .filter((s) => s && typeof s === "object")
        .map((s) => {
          const fields = (Array.isArray(s.fields) ? s.fields : []).map((f) => {
            const value = this.cdslChkEmpty(f.value) ? "—" : f.value;
            const meaning = this.cdslChkEmpty(f.meaning) ? "" : this.cdslChkNote(f.meaning);
            return {field: f.field, column: f.column, display: meaning ? `${meaning} (${value})` : value};
          });
          const only = fields.length == 1 && s.fields[0];
          const removeText = s.action == "Delete" && only && only.field == "Nominee number" ? `Nominee ${only.value} will be removed at CDSL` : "";
          return {section: s.section, action: s.action, chip: {Add: "success", Modify: "orange darken-1", Delete: "error"}[s.action] || "", fields, removeText};
        });
    },
    cdslChkWarnings() {
      const w = this.cdslchkdata && this.cdslchkdata.warnings;
      return Array.isArray(w) ? w.filter((x) => !this.cdslChkEmpty(x)).map((x) => this.cdslChkNote(x)) : [];
    },
    // comparison entries in the backend's order (unknown keys after), each with its key
    cdslChkRows() {
      const c = this.cdslchkdata && this.cdslchkdata.comparison;
      if (!c || typeof c !== "object") return [];
      const order = ["name", "dob", "address", "father_name", "income", "occupation", "bank", "nominee"];
      const keys = [...order.filter((k) => c[k]), ...Object.keys(c).filter((k) => !order.includes(k) && c[k])];
      return keys.map((k) => ({...c[k], key: k, label: c[k].label || k}));
    },
      filteredValidation() {
    return this.datatablerespoce.filter(
      item => item.check_name !== "DOB Validation"
    );
  }

  },
};
</script>

<style>
@import "../assets/style.css";

</style>


